/*

* @Description: In User Settings Edit
* @Author: your name
* @Date: 2019-08-09 16:41:54
* @LastEditTime: 2019-12-19 10:53:49
* @LastEditTime: 2019-09-09 11:43:43
* @LastEditors: Please set LastEditors
*/

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'मेरे वीडियो शॉर्ट्स',
    see_more: 'और देखें',
    no_shorts_found: 'कोई शॉर्ट्स नहीं मिले',
    shorts: 'शॉर्ट्स',
    general_information: 'सामान्य जानकारी',
    gamification: 'गेमिफिकेशन',
    click_to_select_files: 'फाइलें चुनने के लिए क्लिक करें',
    selected_files: 'चुनी गई फाइलें',
    uploaded: 'अपलोड किया गया',
    failed: 'असफल',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'सिस्टम स्वचालित रूप से विश्लेषण करेगा और सामग्री आवश्यकताओं के आधार पर आपके संगठन के पुस्तकालय से सबसे प्रासंगिक दस्तावेज़ चुनेंगा।',
    select_from_library: ' पुस्तकालय से चुनें',
    search_document: 'दस्तावेज़ खोजें...',
    selected: 'चुना गया',
    loading_documents: 'दस्तावेज़ लोड हो रहे हैं...',
    review_generated_content: 'जनरेट की गई सामग्री की समीक्षा करें',
    confirm_and_replace_content: 'सामग्री की पुष्टि करें और बदलें',
    the_generate_content_will_replace:
      'जनरेट की गई सामग्री चयनित पृष्ठों पर मौजूदा पाठ को बदल देगी। यदि आप ये परिवर्तन लागू नहीं करना चाहते, तो आप पिछले चरण पर लौट सकते हैं।',
    pages_to_be_updated: 'अपडेट किए जाने वाले पृष्ठ',
    generated_revisions: 'जनरेट की गई संशोधन',
    lesson_preview: 'पाठ पूर्वावलोकन',
    create_new_folder: 'नया फ़ोल्डर बनाएं',
    rename_item: 'आइटम का नाम बदलें',
    enter_folder_name: 'फ़ोल्डर का नाम दर्ज करें:',
    enter_new_name: 'नया नाम दर्ज करें:',
    folder_name: 'फ़ोल्डर नाम:',
    new_name: 'नया नाम',
    move_items: 'आइटम्स को स्थानांतरित करें',
    copy_items: 'आइटम्स की प्रतिलिपि बनाएं',
    move_here: 'यहाँ स्थानांतरित करें',
    copy_here: 'यहाँ कॉपी करें',
    select_destination_library_and_folder: 'गंतव्य पुस्तकालय और फ़ोल्डर चुनें:',
    items_selected: 'चयनित आइटम्स',
    version: 'संस्करण',
    modified_by: 'के द्वारा संशोधित किया गया',
    size: 'आकार',
    restore: 'पुनर्स्थापित करें',
    are_you_sure_you_want_to_restore_this_version:
      'क्या आप वाकई इस संस्करण को पुनर्स्थापित करना चाहते हैं?',
    this_will_replce_the_current_version_with_the_selected_one:
      'यह वर्तमान संस्करण को चयनित संस्करण से बदल देगा।',
    restore_this_version: 'इस संस्करण को पुनर्स्थापित करें',
    restore_not_available: 'पुनर्स्थापना उपलब्ध नहीं है',
    version_history: 'संस्करण इतिहास:',
    by_making_items_public:
      'आइटम्स को सार्वजनिक बनाने पर, वे सभी के लिए दिखाई देंगे। कृपया आगे बढ़ने से पहले नियम और शर्तें पढ़ें।',
    the_selected_items_will_be_copied:
      'चयनित आइटम्स आपकी सार्वजनिक पुस्तकालय में कॉपी किए जाएंगे और सभी के लिए दिखाई देंगे।',
    the_selected_items_will_be_copied_to_org:
      'चयनित आइटम्स आपके संगठन की पुस्तकालय में कॉपी किए जाएंगे और सभी संगठन सदस्यों के लिए दिखाई देंगे।',
    the_selected_items_will_be_copied_to_your_private:
      'चयनित आइटम्स आपकी निजी पुस्तकालय में कॉपी किए जाएंगे और केवल आपके लिए दिखाई देंगे।',
    loading_organization: 'संगठन उपयोगकर्ता लोड हो रहे हैं...',
    click_download_to_view: 'देखने के लिए डाउनलोड पर क्लिक करें',
    archive_file: 'आर्काइव फ़ाइल',
    no_preview_available: 'कोई पूर्वावलोकन उपलब्ध नहीं',
    audit_report: 'ऑडिट रिपोर्ट',
    audit_type: 'क्रिया प्रकार',
    i_agree_to_the_terms_and_conditions: 'मैं नियम और शर्तों से सहमत हूँ।',
    this_file_is_indexed_for_ai: 'यह फ़ाइल AI के लिए अनुक्रमित है।',
    file_is_not_indexed_for_ai: 'फ़ाइल AI के लिए अनुक्रमित नहीं है।',
    no_users_found: 'कोई उपयोगकर्ता नहीं मिला',
    no_users_available: 'कोई उपयोगकर्ता उपलब्ध नहीं',
    add_people: 'लोग जोड़ें',
    people: 'लोग',
    access_type: 'पहुँच प्रकार',
    no_group_found: 'कोई समूह नहीं मिला',
    add_group: 'समूह जोड़ें',
    groups: 'समूह',
    users_top: 'उपयोगकर्ता',
    confirm_delete: 'हटाने की पुष्टि करें',
    do_you_want_remove: 'क्या आप वाकई हटाना चाहते हैं',
    form_this_documents_permissions: 'इस दस्तावेज़ की अनुमति से?',
    no_users_found_in_this_group: 'इस समूह में कोई उपयोगकर्ता नहीं मिला',
    add_selected_users: 'चयनित उपयोगकर्ता जोड़ें',
    choose_users_from_the_list: 'सूची से उपयोगकर्ता चुनें',
    selected_users: 'चयनित उपयोगकर्ता',
    archived: 'संग्रहीत',
    request_approval: 'अनुमोदन का अनुरोध करें',
    document_in_review: 'दस्तावेज़ समीक्षा में',
    approve: 'स्वीकृत करें',
    reject: 'अस्वीकृत करें',
    comment: 'टिप्पणी:',
    enter_your_commit: 'अपनी टिप्पणी दर्ज करें...',
    confirm_cancel: 'रद्द करने की पुष्टि करें',
    upload_3d_zip: '3D ज़िप अपलोड करें',
    delete_items: 'आइटम्स हटाएं',
    video_upload_request: 'वीडियो अपलोड अनुरोध',
    reject_video: 'वीडियो अस्वीकार करें',
    enter_rejection_reason: 'अस्वीकृति का कारण दर्ज करें...',
    please_provide_a_reason_for_reejection_this_video:
      'कृपया इस वीडियो को अस्वीकार करने का कारण प्रदान करें:',
    generate_trivia_with_ai: 'AI के साथ ट्रिविया बनाएं',
    select_category: 'श्रेणी चुनें:',
    number_of_question: 'प्रश्नों की संख्या',
    generated_questions: 'निर्मित प्रश्न',
    this_will_clear_all_generate_question:
      'यह सभी निर्मित प्रश्नों को साफ़ कर देगा। जारी रखें?',
    sure_delete: 'क्या आप वाकई हटाना चाहते हैं?',
    delete_this_question: 'क्या आप वाकई इस प्रश्न को हटाना चाहते हैं?',
    loading_quiz: 'क्विज़ लोड हो रहा है...',
    creteing_file: 'फ़ाइल बनाई जा रही है',
    opening_desktop_app: 'डेस्कटॉप ऐप खोला जा रहा है',
    this_folder_is_empty: 'यह फ़ोल्डर खाली है',
    select_a_competition: 'प्रतियोगिता चुनें...',
    activity_badges: 'गतिविधि बैज',
    awarded_every_badges:
      'प्रत्येक 4, 8, 16, 32, 64, 128, 256, 512 लॉगिन पर दिया गया',
    learning_badges: 'लर्निंग बैज',
    awarded_every_courses:
      'प्रत्येक 1, 4, 8, 16, 32, 64, 128 पूरा किए गए पाठ्यक्रम पर दिया गया',
    test_badges: 'टेस्ट बैज',
    awarded_every_passes_tests:
      'प्रत्येक 2, 4, 8, 16, 32, 64, 128, 256 पास किए गए परीक्षणों पर दिया गया',
    assignment_badges: 'असाइनमेंट बैज',
    awarded_every_passed_assignments:
      'प्रत्येक 1, 2, 4, 8, 16, 32, 64, 128 पास किए गए असाइनमेंट पर दिया गया',
    perfectionism_badges: 'परफेक्शनिज़्म बैज',
    awarded_every_assignments_with_scrore:
      'प्रत्येक टेस्ट या असाइनमेंट जिसमें 90%+ स्कोर हो, दिया गया',
    communication_badges: 'कम्युनिकेशन बैज',
    awarded_every_topics_or_comments:
      'प्रत्येक 2, 4, 8, 16, 32, 64, 128, 256 विषय या टिप्पणियों पर दिया गया',
    certification_badges: 'सर्टिफिकेशन बैज',
    awarded_every_certificates:
      'प्रत्येक 1, 2, 4, 8, 16, 32, 64, 128 प्रमाणपत्र पर दिया गया',
    level_name: 'स्तर का नाम',
    delete_competition: 'प्रतियोगिता हटाएं',
    this_week: 'इस सप्ताह',
    this_year: 'इस वर्ष',
    make_organization: 'संगठन बनाएं',
    no_results_found: 'कोई परिणाम नहीं मिला',
    no_items_available: 'कोई आइटम उपलब्ध नहीं',
    help_video: 'सहायता वीडियो',
    select_a_video_from_the_list:
      'सीखना शुरू करने के लिए सूची से एक वीडियो चुनें'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'फ़ाइल ड्रॉप करें और अपलोड करने के लिए स्थान चुनें।',
    duplicate_lessoon: 'पाठ्यक्रम में पहले से ही यह पाठ मौजूद है',
    skill_rule_title: 'कृपया कौशल यात्रा का शीर्षक दर्ज करें',
    imageCreatorTitle: 'इमेज क्रिएटर',
    isTranslated: 'अनुवादित',
    translationCourseDesc:
      'इस पाठ्यक्रम का अनुवाद कुछ मिनट ले सकता है। आपकी सहनशीलता के लिए धन्यवाद!',
    translateCourseTip:
      'एक अनुवादित पाठ्यक्रम बनाएँ जिसे आप मूल से स्वतंत्र रूप से संशोधित कर सकते हैं, जिसमें सभी पाठ और पृष्ठ शामिल हैं।',
    translateModalBtn: 'अनुवाद करें',
    translationSuccess: 'पाठ्यक्रम "<0/>" सफलतापूर्वक अनूदित हो चुका है!',
    translatingCourse: 'पाठ्यक्रम का अनुवाद किया जा रहा है...',
    translateModalTitle: 'पाठ्यक्रम अनुवाद करें',
    translateSelectLang: 'भाषा चुनें',
    fileDeleteconfirm:
      'क्या आप निश्चित हैं कि आप इस फ़ाइल को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।',
    fileDeleteMessage: 'फ़ाइल सफलतापूर्वक हटाई गई।',
    fileDeleteFailedMessage: 'फ़ाइल हटाने में विफल!',
    fileDelete: 'इस फ़ाइल को हटाएं।',
    certificate_save_btn: 'प्रमाणपत्र जोड़ें ',
    maze_path_info: 'ग्राफ के लिए कोई पथ उपलब्ध नहीं है!',
    file_size_mb: 'फ़ाइल का आकार 25 एमबी से कम होना चाहिए!',
    reports: {
      products: 'उत्पाद',
      users: 'उपयोगकर्ता',
      ph_username: 'उपयोगकर्ता नाम द्वारा खोजें',
      ph_id: 'उपयोगकर्ता की आईडी संख्या द्वारा खोजें',
      ph_email: 'उपयोगकर्ता के ईमेल द्वारा खोजें'
    },
    select_upload_section_id: 'सेक्शन फ़ाइल आवश्यक है',
    tags_all: 'सभी',
    delete_file_confirm:
      'क्या आप निश्चित हैं कि आप इस फ़ाइल को हटाना चाहते हैं?',
    delete_file_title: 'फ़ाइल हटाएं',
    tooltip_publish: 'चयनित विकल्प पर पाठ्यक्रम प्रकाशित करें',
    tooltip_save: 'वर्तमान अपडेट के साथ पाठ्यक्रम सहेजें',
    tooltip_next: 'अगली पाठ्यक्रम सेटिंग पर जाएं',
    tooltip_finish: 'वर्तमान अपडेट पूरा करें और सहेजें',
    stories_modal: {
      title_upload: 'कहानियाँ अपलोड करें',
      title_update: 'कहानियाँ अपडेट करें',
      title_audio: 'कहानी ऑडियो फ़ाइल',
      btn_upload: 'अपलोड करें',
      btn_update: 'अपडेट करें',
      btn_close: 'बंद करें',
      btn_cancel: 'रद्द करें',
      lbl_cover: 'कहानी कवर चित्र',
      rule_cover: 'कृपया कहानी ऑडियो कवर अपलोड करें!',
      lbl_title: 'कहानी ऑडियो शीर्षक',
      rule_title: 'कृपया कहानी ऑडियो शीर्षक दर्ज करें!',
      lbl_description: 'कहानी ऑडियो विवरण',
      rule_description: 'कृपया कहानी ऑडियो विवरण दर्ज करें!',
      lbl_file: 'कहानी ऑडियो फ़ाइल अपलोड करें',
      rule_file: 'कृपया कहानी ऑडियो फ़ाइल अपलोड करें!',
      rule_file_type: 'कृपया वैध कहानी ऑडियो फ़ाइल अपलोड करें!',
      lbl_select_file: 'कहानी ऑडियो फ़ाइल चुनें',
      msg_valid_file: 'कृपया वैध कहानी ऑडियो फ़ाइल चुनें!',
      msg_success: 'कहानी ऑडियो फ़ाइल सफलतापूर्वक अपलोड हुई',
      msg_failed: 'मीडिया डेटा असाइन करने में विफल!',
      msg_error: 'फ़ाइल अपलोड करते समय त्रुटि!'
    },
    audio_modal: {
      title_upload: 'अपलोड करें',
      title_update: 'अपडेट करें',
      title_audio: 'ऑडियो फ़ाइल',
      btn_upload: 'अपलोड करें',
      btn_update: 'अपडेट करें',
      btn_close: 'बंद करें',
      btn_cancel: 'रद्द करें',
      lbl_cover: 'ऑडियो कवर',
      rule_cover: 'कृपया ऑडियो कवर अपलोड करें!',
      lbl_title: 'ऑडियो शीर्षक',
      rule_title: 'कृपया ऑडियो शीर्षक दर्ज करें!',
      lbl_description: 'ऑडियो विवरण',
      rule_description: 'कृपया ऑडियो विवरण दर्ज करें!',
      lbl_file: 'ऑडियो फ़ाइल अपलोड करें',
      rule_file: 'कृपया ऑडियो फ़ाइल अपलोड करें!',
      rule_file_type: 'कृपया वैध ऑडियो फ़ाइल अपलोड करें!',
      lbl_select_file: 'ऑडियो फ़ाइल चुनें',
      msg_valid_file: 'कृपया वैध ऑडियो फ़ाइल चुनें!',
      msg_success: 'ऑडियो फ़ाइल सफलतापूर्वक अपलोड हुई',
      msg_failed: 'मीडिया डेटा असाइन करने में विफल!',
      msg_error: 'फ़ाइल अपलोड करते समय त्रुटि!'
    },
    info_episode: 'एपिसोड के लिए कवर चित्र।',
    btn_delete_episode: 'इस पॉडकास्ट एपिसोड को हटाएं।',
    btn_edit_marketplace: 'मार्केटप्लेस विवरण संपादित करें।',
    btn_save_marketplace: 'वर्तमान परिवर्तनों को सहेजें।',
    btn_ai_podcast: 'AI-पावर्ड पॉडकास्ट एपिसोड बनाएं।',
    btn_upload_podcast: 'अपना पॉडकास्ट ऑडियो एपिसोड अपलोड करें।',
    attach_file:
      'अपने दर्शकों के साथ अधिक सामग्री साझा करने के लिए फ़ाइलें अपलोड करें',
    fileDownload: 'इस फ़ाइल को डाउनलोड करें।',
    singleEpishode: 'एपिसोड',
    podcast_music: 'पॉडकास्ट, संगीत और कहानियाँ',
    publishHeader: 'पॉडकास्ट, संगीत और कहानियाँ प्रकाशित करें',
    editHeader: 'पॉडकास्ट, संगीत और कहानियाँ संपादित करें',
    createHeader: 'पॉडकास्ट, संगीत और कहानियाँ बनाएं',
    marketplaceHeader: 'पॉडकास्ट, संगीत और कहानियाँ मार्केटप्लेस विवरण',
    message_marketplace: 'कृपया मार्केटप्लेस फ़ॉर्म पूरा करें!',
    create_podcast_live: 'लाइव पॉडकास्ट और संगीत',
    create_podcast_custom: 'कस्टम पॉडकास्ट और संगीत',
    create_podcast_stories: 'कहानी',
    ai_Assisted_podcast_reation: 'AI-सहायता प्राप्त पॉडकास्ट और संगीत',
    publishTitle:
      'सार्वजनिक दर्शकों के लिए पॉडकास्ट, संगीत और कहानियाँ प्रकाशित करें।',
    customButton: 'कस्टम बनाएं',
    customTitle: 'पॉडकास्ट में किए गए परिवर्तनों को सहेजें।',
    updateButton: 'अपडेट करें',
    createButton: 'बनाएं',
    createNewButton: 'नया बनाएं',
    updateTitle: 'वर्तमान पॉडकास्ट, संगीत और कहानियों का विवरण अपडेट करें।',
    createTitle: 'नया पॉडकास्ट, संगीत और कहानियाँ बनाएं',
    createNewTitle:
      'नया पॉडकास्ट, संगीत और कहानियाँ वर्तमान पॉडकास्ट, संगीत और कहानियों पर नई इनपुट विवरण के साथ बनाए जाएंगे।',
    podcastTitle: 'एपिसोड सूची',
    podcastStoryTitle: 'कहानियों के एपिसोड की सूची',
    podcastToolTipTitle: 'पॉडकास्ट एपिसोड की सूची',
    uploadAudio: 'अपलोड करें',
    aiAudio: 'AI ऑडियो',
    emptyPodcast:
      'अभी तक कोई पॉडकास्ट, संगीत और कहानियों का ऑडियो रिकॉर्ड नहीं हुआ है।',
    emptyStoriesPodcast: 'अभी तक कोई कहानी जोड़ी नहीं गई है।',
    emptyCreatePodcast: 'ऑडियो जोड़ने के लिए कृपया पॉडकास्ट बनाएं।',
    playPodcast: 'चयनित पॉडकास्ट, संगीत और कहानियों को चलाएं।',
    pausePodcast: 'चयनित पॉडकास्ट, संगीत और कहानियों को रोकें।',
    selectPodcast: 'इस पॉडकास्ट, संगीत और कहानियों का चयन करें।',
    downloadPodcast: 'इस ऑडियो को डाउनलोड करें।',
    uploadAudioFile: 'नया ऑडियो अपलोड करें और वर्तमान ऑडियो को बदलें।',
    deleteConfirm: 'क्या आप इस ऑडियो को हटाने के लिए सुनिश्चित हैं?',
    roomName: 'पॉडकास्ट का नाम',
    addGuestTitle: 'अतिथि वक्ता जोड़ें',
    showTime: 'दिखाने का समय',
    startTime: 'शुरुआत का समय',
    endTime: 'समाप्ति का समय',
    erorMsgImg: 'कृपया वैध छवि चुनें।',
    failedMsgImg: 'छवि लोड करने में विफल। कृपया पुनः प्रयास करें!',
    failedMsgUpload: 'कवर छवि अपलोड करने में विफल!',
    btnCoverUpload: 'कवर अपलोड करें',
    is_private: 'निजी',
    to_attach: 'फ़ाइल संलग्न करें',
    file_attached: 'संलग्न फ़ाइल (फ़ाइलें)',
    main_event: 'मुख्य कार्यक्रम',
    event: 'कार्यक्रम',
    upload_pdf: 'पीडीएफ़ अपलोड करें',
    portrait: 'पोर्ट्रेट',
    landscape: 'लैंडस्केप',
    import_from_library: 'मीडिया लाइब्रेरी से टेक्स्ट आयात करें',
    question_answer_ai: 'प्रश्न/उत्तर एआई',
    take_maze: 'मेटा माज़ लें',
    training: 'प्रशिक्षण',
    select_transcribe_locale: 'ट्रांसक्राइब करने के लिए भाषा चुनें',
    transcribe_limit: 'कृपया ट्रांसक्राइब मिनट दर्ज करें',
    not_complete: 'मार्केटप्लेस जानकारी पूरी नहीं है',
    complete: 'मार्केटप्लेस जानकारी पूरी है',
    not_admin:
      'मार्केटप्लेस पर प्रकाशित करने के लिए एडमिन विशेषाधिकार आवश्यक है',
    no_course:
      'कृपया शीर्षक दर्ज करें और मार्केटप्लेस सक्षम करने के लिए एक छवि चुनें',
    scorm_not_complete:
      'SCORM फ़ाइल अपलोड करने के लिए कृपया शीर्षक दर्ज करें और एक छवि चुनें',
    not_found_maze: 'MetaMaze नहीं मिला',
    email_require: 'ईमेल आवश्यक हैं',
    poll_required: 'पोल डेटा आवश्यक है',
    alert: 'चेतावनी!',
    warning: 'चेतावनी!',
    ok: 'ठीक है',
    cancel: 'रद्द करें',
    done: 'समाप्त',
    insert: 'डालें',
    private: 'निजी',
    public: 'सार्वजनिक',
    no_connection: 'इंटरनेट कनेक्शन खो गया',
    switch: 'स्विच',
    share_screen: 'स्क्रीन साझा करें',
    stop_share_screen: 'स्क्रीन साझा करना बंद करें',
    share_screen_with_camera: 'कैमरा के साथ स्क्रीन साझा करें',
    stop_share_screen_with_camera: 'कैमरा के साथ स्क्रीन साझा करना बंद करें',
    camera_on: 'कैमरा चालू',
    camera_off: 'कैमरा बंद',
    mic_on: 'म्यूट हटाएं',
    mic_off: 'म्यूट करें',
    fullscreen: 'फुल स्क्रीन',
    live_now: 'अब लाइव',
    schedule_on: 'के लिए शेड्यूल करें',
    organisations: 'संगठन',
    org_groups: 'संगठन समूह',
    specific_user: 'विशिष्ट उपयोगकर्ता',
    gif: 'GIF',
    unavailable: 'उपलब्ध नहीं',
    yes: 'हाँ',
    no: 'नहीं',
    event_duration_message: 'अधिकतम 300 मिनट (5 घंटे)',
    send_email: 'ईमेल सूचना भेजें',
    admin_only: 'केवल एडमिन',
    join: 'शामिल हों',
    leave: 'छोड़ें',
    share: 'साझा करें',
    share_text:
      'कृपया उस व्यक्ति का ईमेल पता टाइप करें जिसके साथ आप यह फ़ाइल साझा करना चाहते हैं।',
    share_text_title: 'पीडीएफ़ साझा करें',
    share_text_title_txt: 'टेक्स्ट साझा करें',
    select_users: 'उपयोगकर्ता चुनें',
    delete: 'हटाएँ',
    attachment_event: 'कार्यक्रम के लिए संलग्नक:',
    transcribe_limit: 'ट्रांसक्राइब मिनट',
    monthly_transcribe: 'मासिक ट्रांसक्राइब सीमा:',
    enable_ai: 'एआई सक्षम करें:',
    enable_maze: 'मेटा माज़ सक्षम करें:',
    media_service: 'मीडिया सेवा',
    allow_others: 'दूसरों को संपादित करने की अनुमति दें',
    join_breakout_room: 'ब्रेकआउट रूम में शामिल हों',
    bio: 'बायो',
    linkedin: 'LinkedIn',
    select_org_report: 'कृपया रिपोर्ट बनाने के लिए एक संगठन चुनें।',
    org_image_not_found: 'छवि नहीं मिली',
    insert_text: 'टेक्स्ट डालें',
    insert_question_answer: 'प्रश्न/उत्तर एआई',
    modal_title2: 'टेक्स्ट गैलरी',
    my_text_library: 'मेरी टेक्स्ट लाइब्रेरी',
    ai: 'एआई',
    public_text_library: 'सार्वजनिक टेक्स्ट लाइब्रेरी',
    organization_text_library: 'संगठन टेक्स्ट लाइब्रेरी',
    no_transcribed_text: 'कोई ट्रांसक्राइब्ड टेक्स्ट नहीं मिला',
    public_text_not_found: 'सार्वजनिक ट्रांसक्राइब्ड टेक्स्ट नहीं मिला',
    org_text_not_found: 'संगठन ट्रांसक्राइब्ड टेक्स्ट नहीं मिला',
    org_video_not_found: 'वीडियो नहीं मिला',
    canva: 'Canva से करें',
    canva_open: 'Canva संपादक खोलने के लिए यहां क्लिक करें।',
    pdf: 'पीडीएफ़',
    txt: 'टेक्स्ट',
    human: 'प्रीमियम',
    shared_file: 'आपकी फ़ाइल सफलतापूर्वक साझा की गई है।',
    error_shared_file: 'फ़ाइल साझा करने में समस्या है। कृपया पुनः प्रयास करें।',
    publish: 'प्रकाशित करें',
    maze_scenes: 'मेटा माज़ दृश्य',
    pexel_images: 'पेक्सेल छवियां',
    group: 'समूह',
    group_name: 'समूह का नाम',
    select_group: 'समूह चुनें',
    search_maze: 'मेटामेज़ खोजें',
    hosts: 'मेजबान',
    avg_score: 'प्रतिशत स्कोर',
    maze_report: 'मेज़ रिपोर्ट',
    maze_view: 'मेज़ दृश्य',
    title_maze: 'मेटामेज़',
    author: 'लेखक',
    match: 'पथ मिलान',
    preview_mazeTitle: 'शीर्षक: ',
    other: 'अन्य',
    total: 'कुल',
    report_course: 'कोर्स',
    report_courses: 'कोर्स',
    report_event: 'कार्यक्रम',
    report_events: 'कार्यक्रम',
    report_maze: 'मेज़',
    report_personalize_learning: 'व्यक्तिगत सीखना',
    report_live_assessment: 'लाइव आकलन',
    report_live_assessments: 'लाइव आकलन',
    report_skill_journey: 'कौशल यात्रा',
    skill_journey: 'कौशल यात्रा',
    skill_journeys: 'कौशल यात्राएं',
    date: 'तारीख: ',
    search_people: 'लोग खोजें',
    passed: 'उत्तीर्ण',
    failed: 'अनुत्तीर्ण',
    item: 'आइटम',
    type: 'प्रकार',
    minimum_pass_score: 'परीक्षा उत्तीर्ण करने के लिए न्यूनतम अंक',
    resources_count: 'संसाधनों की संख्या',
    back: 'वापस',
    resources: 'संसाधन',
    time_spent: 'समय व्यतीत (मिनट)',
    detail: 'विवरण',
    watched_time_mins: 'देखा गया समय (मिनट)',
    personalize_learning: 'व्यक्तिगत सीखना',
    result: 'परिणाम',
    assessment_title: 'शीर्षक',
    marketPlace_graph: 'मार्केटप्लेस ग्राफ',
    attachments: 'अतिरिक्त अटैचमेंट्स',
    new_scorm_course: 'नया SCORM कोर्स अपलोड करें',
    upload_scorm_course: 'SCORM कोर्स अपलोड करें',
    new_maze: 'नया मेटामेज़ बनाएं',
    new_skill_journey: 'कौशल यात्रा बनाएं',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'कौशल यात्रा',
    new_discussion_room: 'नया पॉडकास्ट बनाएं',
    title: 'आज आप क्या करना चाहते हैं?',
    build_course: 'मेरा कोर्स बनाएं',
    live_broadcast: 'लाइव प्रसारण',
    invite_users: 'मेरे संगठन में उपयोगकर्ताओं को आमंत्रित करें',
    build_voice_over: 'मेरी वॉयसओवर बनाएं',
    view_reports: 'रिपोर्ट देखें',
    upload_media: 'मीडिया या कार्य अपलोड करें और साझा करें',
    main_menu: 'मुख्य मेनू',
    get_started: 'शुरू करें',
    search_group: 'संगठन समूह खोजें',
    ai_course: 'एआई कोर्स',
    search_user: 'कंपनी का नाम खोजें',
    no_maze: 'वर्तमान में कोई मेटामेज़ नहीं है।',
    conference_event_title: 'सम्मेलन कार्यक्रम',
    conference_event_subTitle: 'पूरा हुआ सम्मेलन कार्यक्रम',
    conference_event: 'वर्तमान में कोई सम्मेलन कार्यक्रम नहीं है।',
    no_skill: 'वर्तमान में कोई कौशल यात्रा नहीं है।',
    no_podcast: 'वर्तमान में कोई पॉडकास्ट नहीं है।',
    maze_channel: 'मेटामेज़',
    past_live_assessment: 'पिछले लाइव आकलन',
    no_live_assessment: 'वर्तमान में कोई लाइव आकलन नहीं है।',
    enrolled_courses: 'कोर्स',
    my_video_channel: 'मेरे वीडियो चैनल',
    enrolled_liveEvents: 'लाइव कार्यक्रम',
    sharebot: 'शेयरबोट',
    selected_language: 'चयनित भाषा',
    shareSphere_game: 'शेयरस्फीयर गेम',
    maze: 'मेटामेज़',
    skill: 'कौशल यात्रा',
    channel: 'चैनल',
    order: 'आदेश',
    is_record: 'रिकॉर्ड',
    no_maze_found: 'कोई मेटामेज़ नहीं मिला।',
    maze_self_limit_reached: 'मेटामेज़ स्व-मूल्यांकन सीमा तक पहुंच गया।',
    metamaze_two_times: 'आपने यह मेटामेज़ पहले ही 2 बार लिया है।',
    metamaze_two_times_no_result:
      'आपने यह मेटामेज़ पहले ही 2 बार लिया है। दूसरी बार के बाद आपकी परिणाम को ट्रैक नहीं किया जाएगा।',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'उत्तीर्ण करने के लिए न्यूनतम अंक',
    organization: 'कृपया एक संगठन चुनें',
    pass_score_mark: 'कृपया 1 से 100 के बीच अंक दर्ज करें',
    maze_cloning_success: 'मेटामेज़ "<0/>" सफलतापूर्वक क्लोन हो गया है!',
    create_certificate: 'प्रमाणपत्र बनाएं',
    create_badge: 'बैज बनाएं',
    certificate_added: 'प्रमाणपत्र जोड़ा गया।',
    badge_added: 'बैज जोड़ा गया।',
    certificate_warning:
      'प्रमाणपत्र/बैज प्रकाशित होने के बाद संपादित नहीं किया जा सकता!',
    created_course_plan:
      'अपने बनाए गए कोर्स और लाइव इवेंट्स को संपादित करें और प्रकाशित करें',
    market_place_space: 'मार्केटप्लेस',
    select_course_language: 'भाषा चुनें (वैकल्पिक)',
    select_language: 'भाषा चुनें',
    file_upload: 'फ़ाइल अपलोड करें',
    text: 'यहाँ टेक्स्ट लिखें…',
    attempts_count: 'उपयोगकर्ता पुनः प्रयास कर सकते हैं',
    no_of_people_placeholder: 'लोगों की संख्या',
    back_to_maze: 'मेटामेज़ पर वापस जाएं',
    edit_maze: 'मेटामेज़ संपादित करें',
    wait: 'कृपया प्रतीक्षा करें...',
    retry: 'पुनः प्रयास करें',
    publish_scorm_course: 'अपना SCORM कोर्स प्रकाशित करें',
    publish_maze: 'अपना मेटामेज़ प्रकाशित करें',
    import: 'तत्व आयात करें',
    answer_correct: 'सही उत्तर चुनें',
    author_name: `कृपया लेखक का नाम दर्ज करें`,
    select_category: 'कृपया एक श्रेणी चुनें',
    course_outline: 'कृपया पाठ्यक्रम की रूपरेखा दर्ज करें',
    course_obj: 'कृपया पाठ्यक्रम के उद्देश्य दर्ज करें',
    course_description: 'कृपया पाठ्यक्रम का विवरण दर्ज करें',
    maze_outline: 'कृपया भूलभुलैया की रूपरेखा दर्ज करें',
    maze_obj: 'कृपया भूलभुलैया के उद्देश्य दर्ज करें',
    maze_description: 'कृपया भूलभुलैया का विवरण दर्ज करें',
    lessons: 'कृपया पाठों की संख्या दर्ज करें',
    user_email_require: `उपयोगकर्ता ईमेल आवश्यक है`,
    team_size: `टीम का आकार आवश्यक है`,
    enter_price: 'कृपया एक मूल्य दर्ज करें (5 या अधिक)',
    input_title_maze: 'कृपया भूलभुलैया का शीर्षक दर्ज करें',
    trainer_bio: 'कृपया प्रशिक्षक का जैव विवरण दर्ज करें',
    trainer_linkedin: 'कृपया प्रशिक्षक का LinkedIn लिंक दर्ज करें',
    error_video: 'कृपया वीडियो की संख्या दर्ज करें',
    input_video_link: 'कृपया वीडियो लिंक दर्ज करें',
    number_of_video: 'वीडियो की संख्या',
    number_of_lessions: 'पाठों की संख्या',
    no_of_people_in_conference: 'सम्मेलन में कितने लोग हैं?',
    transcribe_settings: 'लिप्यंतरण सेटिंग्स',
    transcribe: 'लिप्यंतरण करें',
    cloning_maze: 'MetaMaze क्लोन किया जा रहा है...',
    id_number: 'पहचान संख्या',
    timezone: 'समय क्षेत्र',
    edit_maze: 'संपादित करें',
    delete_maze: 'हटाएं',
    view_maze: 'देखें',
    create_metamaze: 'MetaMaze बनाएं',
    metamaze_scenario: 'MetaMaze परिदृश्य',
    publish_metamaze: 'प्रकाशन सेटिंग्स',
    search_result: 'खोज परिणाम:',
    search_for: 'के लिए खोजें',
    search_no_result: '- कोई परिणाम नहीं मिला!',
    channel_no_available: 'कोई चैनल उपलब्ध नहीं है!',
    this_card: 'यह एक कार्ड है',
    course_no_available: 'कोई पाठ्यक्रम उपलब्ध नहीं है!',
    exit_fullscreen: 'पूर्ण स्क्रीन से बाहर निकलें',
    bg_image: 'पृष्ठभूमि चित्र',
    introduction: 'परिचय',
    summary: 'सारांश',
    generate_introduction: 'परिचय बनाएँ',
    generate_summary: 'सारांश बनाएँ',
    bullet_points: 'बुलेट पॉइंट्स',
    title_simulation: 'कृपया सिमुलेशन का नाम दर्ज करें',
    view_generated_images: 'बनाई गई छवियाँ देखें',
    image_transparency: 'छवि पारदर्शिता',
    template_bg_color: 'टेम्पलेट की पृष्ठभूमि का रंग',
    select_template_layout: 'टेम्पलेट लेआउट चुनें',
    reload_template: '(टेम्पलेट पुनः लोड करें)',
    are_you_sure_want_close: 'क्या आप वाकई इसे बंद करना चाहते हैं?',
    all_your_changes_will_be_lost: 'आपके सभी परिवर्तन खो जाएंगे।',
    please_checked_before_generated_video:
      'कृपया वीडियो उत्पन्न होने से पहले सभी शर्तें जांचें।',
    voice_must_be_selected: 'एक आवाज़ चुनी जानी चाहिए',
    avatar_must_be_selected: 'एक अवतार चुना जाना चाहिए।',
    maximum_five_slides_try_again:
      'आपकी फ़ाइल से छवियाँ निकालने में त्रुटि। सुनिश्चित करें कि अधिकतम 5 स्लाइड्स हैं और प्रत्येक में नोट्स हैं। कृपया पुनः प्रयास करें!',
    back_to_upload: 'अपलोड पर वापस जाएं',
    uploading_file_to_server: 'आपकी फ़ाइल सर्वर पर अपलोड हो रही है',
    extracting_images_from_your_file: 'आपकी फ़ाइल से छवियाँ निकाली जा रही हैं',
    upload_your_ppt_or_drag:
      'अपनी प्रेजेंटेशन फ़ाइल (.PPTX) अपलोड करें या इसे यहाँ खींचें।',
    maximum_five_slides_error:
      'सुनिश्चित करें कि PowerPoint फ़ाइल में अधिकतम 5 स्लाइड्स हैं और प्रत्येक में नोट्स हैं, अन्यथा त्रुटि उत्पन्न होगी।',
    number_of_questions_generated: 'जनरेट किए जाने वाले प्रश्नों की संख्या',
    quiz_page_this_cannot_be_done:
      'क्या आप सुनिश्चित हैं कि आप इस पृष्ठ पर क्विज़ जोड़ना चाहते हैं? इसे पूर्ववत नहीं किया जा सकता।',
    confirm_selection: 'चयन की पुष्टि करें',
    select_quiz_page: 'क्विज़ पृष्ठ चुनें',
    lesson_do_you_want_add_this_quiz:
      'आप पाठ के किस भाग में यह क्विज़ जोड़ना चाहते हैं?',
    beginning_of_lesson: 'पाठ की शुरुआत में',
    end_of_lesson: 'पाठ के अंत में',
    currently_active_page: 'वर्तमान सक्रिय पृष्ठ',
    finish: 'समाप्त करें',
    upload_selection_file: 'सेक्शन फ़ाइल अपलोड करें',
    general_quiz: 'सामान्य क्विज़',
    manage_sequence: 'अनुक्रम प्रबंधित करें',
    save_sequence: 'अनुक्रम सहेजें',
    new: 'नया',
    in_progress: 'प्रगति में',
    recommended_course: 'अनुशंसित पाठ्यक्रम',
    up_coming: 'आगामी',
    past_live: 'पिछला लाइव',
    input_your_channel_name: 'कृपया अपना चैनल नाम दर्ज करें!',
    organization_place: 'संगठन स्थान',
    marketplace_report: 'मार्केटप्लेस रिपोर्ट',
    story_writing: 'कहानी लेखन',
    Ai_quiz: 'एआई क्विज़',
    generate_quiz: 'क्विज़ बनाएँ',
    create_story: 'कहानी बनाएँ',
    change_layout_page: 'आप इस पृष्ठ की लेआउट बदलने वाले हैं।',
    change_layout_message:
      'कृपया ध्यान दें कि केवल पाठ, चित्र, पृष्ठभूमि और लोगो रखे जाएंगे। अन्य सभी तत्व हटाए जाएंगे।',
    reviews: 'समीक्षाएँ',
    tab_attachments: 'संलग्नक',
    zoom_in: 'ज़ूम इन',
    zoom_out: 'ज़ूम आउट',
    zoom_reset: 'ज़ूम रीसेट',
    no_attachment: 'कोई संलग्नक नहीं।',
    select_upload_simulation: 'कृपया सिमुलेशन चुनें/अपलोड करें।',
    quiz_updated_successfully: 'क्विज़ सफलतापूर्वक अपडेट हो गया!',
    quizes: 'क्विज़',
    trivia: 'ट्रिविया',
    closing: 'बंद किया जा रहा है...',
    products: 'उत्पाद',
    ask_questions: 'यहाँ कोई प्रश्न पूछें...',
    course_information: 'पाठ्यक्रम जानकारी',
    course_assistance: 'पाठ्यक्रम निर्माण सहायता',
    go_back: 'वापस जाएँ',
    ai_generate_content_progress: 'AI सामग्री निर्माण प्रगति',
    view_generate_content: 'जनित सामग्री देखें',
    generate_error: 'निर्माण त्रुटि!',
    confirm_creating_course:
      'क्या आप इस सामग्री का उपयोग करके पाठ्यक्रम बनाना चाहते हैं?',
    generate_content_automatically:
      'यह आपके पाठ्यक्रम में स्वचालित रूप से सभी जनित सामग्री को पाठों और पृष्ठों के रूप में जोड़ देगा।',
    quiz_created_successfully: 'क्विज़ सफलतापूर्वक बनाया गया!',
    create_quiz: 'क्विज़ बनाएँ',
    quiz_setting: 'क्विज़ सेटिंग',
    please_fill_quiz_setting: '* कृपया क्विज़ सेटिंग में सभी फ़ील्ड भरें',
    question_list: 'प्रश्न सूची',
    add_quiz_to_page: 'पृष्ठ में क्विज़ जोड़ें',
    form_create_question: 'प्रश्न निर्माण फॉर्म',
    user_information_updated: 'उपयोगकर्ता जानकारी सफलतापूर्वक अपडेट हुई!',
    your_stripe_activete_to_continue:
      'आपका Stripe खाता सक्रिय नहीं है। कृपया इसे चालू करें या कनेक्ट करें।',
    connect_tripe: 'Stripe कनेक्ट करें',
    certificate_sent_sucessfully:
      'प्रमाणपत्र सफलतापूर्वक आपके ईमेल पर भेजा गया।',
    error_try_again: 'त्रुटि। कृपया पुनः प्रयास करें!',
    error_delete_channel: 'चैनल हटाने में त्रुटि।',
    error_update_sub: 'सब्सक्रिप्शन अपडेट करने में त्रुटि।',
    end_time_cannot_start: 'समाप्ति समय शुरू होने से पहले नहीं हो सकता।',
    start_date_time_interval:
      'शुरू करने के लिए प्रारंभ तिथि और समय आवश्यक हैं!',
    podcast_updated_successful: 'पॉडकास्ट सफलतापूर्वक अपडेट हुआ।',
    podcast_created_successful: 'पॉडकास्ट सफलतापूर्वक बनाया गया।',
    podcast_published_successful: 'पॉडकास्ट सफलतापूर्वक प्रकाशित हुआ।',
    podcast_cover_updated: 'पॉडकास्ट का कवर अपडेट किया गया',
    new_podcast_details:
      'नया पॉडकास्ट वर्तमान पॉडकास्ट में नए विवरण के साथ बनाया जाएगा।',
    current_update_podcast:
      'वर्तमान पॉडकास्ट, संगीत और कहानी विवरण अपडेट करें।',
    create_new_podcast: 'नया पॉडकास्ट बनाएँ',
    publish_podcast_public_view:
      'पॉडकास्ट को सार्वजनिक दृश्य में प्रकाशित करें।',
    only_allowed_twenty_five_email: 'केवल 25 ईमेल की अनुमति है।',
    only_allowed_five_email: 'केवल 5 ईमेल की अनुमति है।',
    cover_is_required: 'कवर आवश्यक है।',
    topic_is_required: 'विषय आवश्यक है।',
    delete_schedule: 'अनुसूची हटाएं',
    make_as_coaching: 'कोचिंग उपलब्धता के रूप में चिह्नित करें',
    manage_category: 'श्रेणी प्रबंधित करें',
    threshold: 'थ्रेशोल्ड',
    threshold_popup:
      'प्रतिशत (%) में थ्रेशोल्ड मान, उस मान के बाद अनुशंसा सक्रिय होती है।',
    list_of_catagory: 'श्रेणियाँ सूचीबद्ध करें',
    category_name: 'श्रेणी नाम',
    category_threshold: 'श्रेणी थ्रेशोल्ड',
    play_game: 'खेल खेलें',
    switching_organization: 'संगठन स्विच किया जा रहा है...',
    coaching_session: 'कोचिंग सत्र',
    required_channel_id: 'चैनल आईडी आवश्यक है!',
    error_occured_try_again: 'त्रुटि हुई। कृपया पुनः प्रयास करें!',
    please_complete_marketplace_form: 'कृपया मार्केटप्लेस फॉर्म पूरा करें!',
    upload_file_corrupt: 'अपलोड की गई फ़ाइल भ्रष्ट है।',
    course_not_published: 'पाठ्यक्रम अभी प्रकाशित नहीं हुआ है!',
    error_request: 'अनुरोध में त्रुटि। कृपया पुनः प्रयास करें!',
    skill_request: 'कृपया कौशल फ़ील्ड्स भरें!',
    error_occured: 'त्रुटि हुई। कृपया पुनः प्रयास करें!',
    show_time: 'समय दिखाएं',
    start_time: 'शुरुआत समय',
    end_time: 'समाप्ति समय',
    room_name: 'पॉडकास्ट का नाम',
    add_guest_speaker: 'अतिथि वक्ता जोड़ें',
    cover_picture: 'कवर पिक्चर',
    guest_speaker: 'अतिथि वक्ता',
    see_more: 'और देखें',
    see_less: 'कम देखें',
    background: 'पृष्ठभूमि',
    icon: 'आइकन',
    icon_size: 'आइकन का आकार',
    icon_color: 'आइकन का रंग',
    only_text: 'केवल टेक्स्ट',
    change_bg: 'पृष्ठभूमि रंग बदलें',
    bg_color: 'पृष्ठभूमि रंग',
    font_size: 'फ़ॉन्ट आकार',
    normal: 'सामान्य',
    change_color: 'पाठ का रंग बदलें',
    slant_text: 'थप्पड़ वाला टेक्स्ट',
    text_radius: 'पाठ का त्रिज्या',
    vertical_align: 'ऊर्ध्वाधर संरेखण',
    horizontal_align: 'क्षितिज संरेखण',
    change_icon_color: 'आइकन का रंग बदलें',
    upload_icon: 'आइकन अपलोड करें',
    upload_signature: 'हस्ताक्षर अपलोड करें',
    add_another_sign: 'एक और हस्ताक्षर जोड़ें',
    name_badges: 'बेज का नाम',
    should_less_150: '150 वर्णों तक होना चाहिए',
    your_badge: 'आपका बेज',
    do_you_want_delete_badge: 'क्या आप इस बेज को हटाना चाहते हैं?',
    do_you_want_delete_cert: 'क्या आप इस प्रमाणपत्र को हटाना चाहते हैं?',
    upload_logo: 'लोगो अपलोड करें',
    name_of_cert: 'प्रमाणपत्र का नाम',
    upload_cert: 'प्रमाणपत्र अपडेट करें',
    your_cert: 'आपका प्रमाणपत्र',
    translate_to: 'में अनुवादित करें',
    select_file_attach: 'संलग्न करने के लिए फ़ाइल चुनें',
    certificate: 'प्रमाणपत्र',
    badge: 'बेज',
    publish_options: 'प्रकाशन विकल्प',
    publish_skills_journey: 'कौशल यात्रा प्रकाशित करें',
    videos: 'वीडियो',
    generate_ai_video:
      'AI वीडियो बनाने में कुछ समय लग सकता है। पूरा होने पर आपको ईमेल द्वारा सूचित किया जाएगा।',
    trainer_information: 'प्रशिक्षक जानकारी',
    promotional_video_link: 'प्रोमोशनल वीडियो लिंक',
    please_select: 'कृपया चुनें',
    image_name: 'चित्र का नाम:',
    image_size: 'चित्र का आकार:',
    charecters_fifteen_less: '15 वर्णों या कम',
    leadership: 'नेतृत्व',
    text_arc: 'पाठ वक्र',
    vertical: 'ऊर्ध्वाधर',
    horizontal: 'क्षैतिज',
    badge_history: 'बेज इतिहास',
    templates: 'टेम्पलेट्स',
    sign: 'हस्ताक्षर',
    logo: 'लोगो',
    certificate_history: 'प्रमाणपत्र इतिहास',
    please_wait: 'कृपया प्रतीक्षा करें...',
    information: 'जानकारी',
    support_five_thousand_live_event:
      '5000 प्रतिभागियों तक के लाइव इवेंट का समर्थन करता है',
    support_ten_live_event: '10 लाइव प्रतिभागियों तक का समर्थन करता है',
    we_will_back_participant:
      'हम प्रतिभागियों की पहुँच वाले इवेंट के साथ लौटेंगे।',
    course_objectives: 'पाठ्यक्रम उद्देश्य',
    course_outlines: 'पाठ्यक्रम रूपरेखा',
    price_dollor: 'मूल्य (USD)',
    not_completed: 'पूरा नहीं हुआ',
    enable_marketplace: 'मार्केटप्लेस सक्षम करें',
    enable_course_ai: 'AI के साथ कोर्स निर्माण सक्षम करें',
    enable_report_to_admin: 'एडमिन को रिपोर्ट सक्षम करें',
    enable_white_label: 'व्हाइट लेबल सक्षम करें',
    enable_eleven_labs_for_maze_play: 'Maze खेलने के लिए ElevenLabs सक्षम करें',
    enable_eleven_labs_for_maze_play_cloned:
      'क्लोन की गई आवाज़ों के लिए ElevenLabs सक्षम करें',
    simulation_quiz: 'सिमुलेशन क्विज़',
    bg_color_setting: 'पृष्ठभूमि रंग सेटिंग',
    color_preview: 'रंग पूर्वावलोकन',
    choose_new_color: 'नया रंग चुनें',
    remove_color: 'रंग हटाएं',
    apply_color: 'रंग लागू करें',
    elemeent_in_a_sceenario_page:
      'आप परिदृश्य पृष्ठ में अधिक तत्व नहीं जोड़ सकते। कृपया अन्य पृष्ठ आज़माएं या मौजूदा तत्व को हटाएं।',
    no_data_found: 'कोई डेटा नहीं मिला',
    references: 'संदर्भ',
    open_file: 'फ़ाइल खोलें',
    showing_result: 'परिणाम दिखा रहा है:',
    fiften_day_free_trail: '15 दिन की मुफ्त ट्रायल',
    your_browser_does_not_support: 'आपका ब्राउज़र ऑडियो का समर्थन नहीं करता।',
    podcast_desc: 'पॉडकास्ट विवरण',
    input_podcast_desc: 'पॉडकास्ट का विवरण दर्ज करें',
    podcast_obj: 'पॉडकास्ट उद्देश्य',
    input_podcast_obj: 'पॉडकास्ट के उद्देश्य दर्ज करें',
    podcast_outline: 'पॉडकास्ट रूपरेखा',
    input_podcast_outline: 'पॉडकास्ट की रूपरेखा दर्ज करें',
    add_file: 'फ़ाइल जोड़ें',
    generate_podcast_audio: 'पॉडकास्ट ऑडियो बनाएं',
    generate_uploaded_file_input_parameter:
      'अपलोड की गई फ़ाइल की सामग्री के आधार पर जनरेट करें।',
    go_backe_generation_state: 'सामग्री निर्माण की स्थिति पर लौटें',
    create_ai_powered_podcast: 'AI संचालित पॉडकास्ट बनाएं',
    generate_voice_for_all_podcast: 'सभी एपिसोड के लिए आवाज़ बनाएं',
    create_podcast_episode: 'पॉडकास्ट एपिसोड बनाएं',
    voice_name: 'आवाज़ का नाम',
    input_custom_name: 'कृपया कस्टम नाम दर्ज करें!',
    enter_custom_name: 'आवाज़ के लिए कस्टम नाम दर्ज करें',
    upload_complete: 'अपलोड पूरा हुआ',
    uploading_in_progress: 'अपलोडिंग चल रही है...',
    podcast_stream_content: 'पॉडकास्ट स्ट्रीम सामग्री',
    upload_podcast_cover: 'कृपया पॉडकास्ट कवर अपलोड करें!',
    enter_podcast_name: 'कृपया पॉडकास्ट का नाम दर्ज करें!',
    podcast_topic: 'पॉडकास्ट विषय',
    enter_podcast_topic: 'कृपया पॉडकास्ट विषय दर्ज करें!',
    enter_podcast_desc: 'कृपया पॉडकास्ट विवरण दर्ज करें!',
    number_of_speaker: 'वक्ता की संख्या',
    select_the_number_of_speaker: 'कृपया वक्ताओं की संख्या चुनें!',
    number_of_episode: 'एपिसोड की संख्या',
    input_number_of_episode: 'एपिसोड की संख्या दर्ज करें!',
    podcast_length: 'पॉडकास्ट की लंबाई',
    select_the_podcast_length: 'पॉडकास्ट की लंबाई चुनें!',
    short_podcast: 'छोटा (5–10 मिनट)',
    medium_podcast: 'मध्यम (15–18 मिनट)',
    long_podcast: 'लंबा (18+ मिनट)',
    name_of_host: 'होस्ट का नाम',
    enter_host_name: 'कृपया होस्ट का नाम दर्ज करें!',
    guest_name: 'मेहमानों के नाम',
    enter_guest_name: 'कृपया मेहमानों के नाम दर्ज करें!',
    choose_speaker_tone: 'वक्ता का टोन चुनें',
    enter_speaker_tone: 'पॉडकास्ट के लिए वक्ता का टोन चुनें!',
    informal: 'अनौपचारिक',
    formal: 'औपचारिक',
    serious: 'गंभीर',
    light_humor: 'हल्का हास्य',
    casual: 'आम',
    select_content_source: 'सामग्री स्रोत चुनें',
    from_internet: 'इंटरनेट से',
    upload_pdf_internet: 'PDF या सामग्री पृष्ठ अपलोड करें',
    note: 'नोट:',
    podcast_content_will_be_automatically_generated:
      'पॉडकास्ट सामग्री विश्वसनीय इंटरनेट स्रोतों से स्वचालित रूप से उत्पन्न होगी।',
    upload_or_select_file: 'कृपया फ़ाइल अपलोड या चयन करें!',
    podcast_eposode_title: 'पॉडकास्ट एपिसोड का शीर्षक',
    enter_podcast_title: 'कृपया एपिसोड का शीर्षक दर्ज करें!',
    podcast_episode_des: 'पॉडकास्ट एपिसोड विवरण',
    enter_podcast_episode_des: 'कृपया एपिसोड विवरण दर्ज करें!',
    voice: 'आवाज़',
    music: 'संगीत',
    select_music: 'संगीत चुनें',
    play_the_music: 'संगीत चलाएं',
    stop_the_music: 'संगीत बंद करें',
    context: 'संदर्भ',
    generate_audio_content_selected_voice:
      'चयनित आवाज़ के साथ ऑडियो सामग्री बनाएं।',
    required_field_before_submitting:
      'कृपया सभी आवश्यक फ़ील्ड सबमिट करने से पहले भरें।',
    regenerate_voice: 'आवाज़ फिर से जनरेट करें',
    generate_voice: 'आवाज़ जनरेट करें',
    your_browser_does_not_suppot: 'आपका ब्राउज़र ऑडियो का समर्थन नहीं करता।',
    are_sure_leave_podcast: 'क्या आप वाकई पॉडकास्ट पेज छोड़ना चाहते हैं?',
    broadcast_ongoing: 'प्रसारण जारी है। क्या आप वाकई पेज छोड़ना चाहते हैं?',
    brodcaster_unavailable: 'होस्ट उपलब्ध नहीं है।',
    setting_calender_for_booking: 'बुकिंग के लिए कैलेंडर सेट कर रहे हैं',
    add_calender: 'कैलेंडर जोड़ें',
    waiting_join_host: 'होस्ट के शामिल होने की प्रतीक्षा कर रहे हैं...',
    no_reviews_found: 'कोई समीक्षाएं नहीं मिलीं',
    rated_already: 'आप पहले ही इस लाइव प्रसारण को रेट कर चुके हैं',
    downlink_png: 'PNG के रूप में डाउनलोड करें',
    downlink_jpg: 'JPG के रूप में डाउनलोड करें',
    donwload_file_format: 'डाउनलोड करने के लिए फ़ाइल प्रारूप चुनें।',
    crashed_event:
      'ईवेंट क्रैश हो गया। कृपया एक नया ईवेंट बनाएं। हमें हुई असुविधा के लिए खेद है।',
    prompt: 'प्रॉम्प्ट:',
    generated_image: '🚀 छवि उत्पन्न हो रही है... कृपया प्रतीक्षा करें।',
    download_add: 'सभी डाउनलोड करें',
    setting_generator: 'जनरेटर सेटिंग्स',
    enter_image_prompt: 'कृपया छवि विषय दर्ज करें',
    image_prompt: 'छवि विषय',
    negative_prompt: 'अवांछित सामग्री',
    negative_image_prompt: 'अवांछित छवि विषय',
    number_output: 'बनाने के लिए छवियों की संख्या',
    enter_number_output: 'कृपया संख्या दर्ज करें',
    image_style: 'छवि शैली',
    output_format: 'आउटपुट प्रारूप',
    seeds: 'सीड्स',
    enter_seeds: 'कृपया सीड दर्ज करें',
    performance_mode: 'प्रदर्शन मोड',
    quality: 'गुणवत्ता',
    speed: 'गति',
    balanced: 'संतुलित',
    guidance_scale: 'मार्गदर्शन पैमाना',
    enter_guidance: 'मार्गदर्शन मूल्य दर्ज करें',
    select_image: 'कृपया छवि चुनें।',
    image_prmt: 'छवि विषय',
    generate_image_list_empty: 'कोई छवि उपलब्ध नहीं है।',
    knowledge_center_tooltrip_des:
      'इंटरनेट से जानकारी के आधार पर सटीक और प्रासंगिक उत्तर प्राप्त करें। AI इंटरनेट सामग्री का उपयोग करता है।',
    contexts: 'संदर्भ',
    ai_processing_video_sharebot:
      'Sharebot Video के लिए AI प्रोसेसिंग 24 घंटे के लिए वैध है।',
    remove_sharebot_video:
      'Sharebot वीडियो हटाने के लिए ऑडियो/वीडियो सेक्शन हटाएं।',
    remove_sharebot_video_audio:
      'ऑडियो सेक्शन हटाने से Sharebot लिंक हट जाएगा लेकिन सामग्री लाइब्रेरी में बनी रहेगी।',
    monthly_live_stream:
      'मासिक लाइव स्ट्रीम सीमा बदलने के लिए हमसे संपर्क करें।',
    monthly_transcribe_limit:
      'मासिक ट्रांसक्राइब सीमा बदलने के लिए हमसे संपर्क करें।',
    must_be_one_to_three_hundred: 'मान 1 से 300 मिनट के बीच होना चाहिए।',
    all_field_required: 'सभी फ़ील्ड आवश्यक हैं।',
    duration_minute: 'अवधि (अधिकतम 300 मिनट)',
    gender: 'लिंग',
    select_gender: 'लिंग चुनें',
    accent: 'उच्चारण',
    select_accent: 'उच्चारण चुनें',
    create_voice: 'वॉइस बनाएं',
    enter_voice_name: 'वॉइस का नाम दर्ज करें',
    select_voice_gender: 'कृपया वॉइस का लिंग चुनें',
    upload_voice: 'अपनी वॉइस अपलोड करें',
    upload_voice_mp_three: 'अपनी वॉइस अपलोड करें (.mp3)',
    cloned_voice: 'क्लोन की गई वॉइस',
    voice_type: 'वॉइस का प्रकार',
    select_voice_type: 'वॉइस का प्रकार चुनें',
    sharelook_stand: 'स्टैंडर्ड',
    sharelook_premium: 'प्रीमियम',
    sharelook_custum_voice: 'कस्टम (वॉइस क्लोनिंग)',
    create_auto_flow: 'ऑटो फ्लो बनाएं',
    how_many_layers: 'कितनी परतें',
    verify_selection: 'चयन सत्यापित करें',
    uploaded_successful: 'सफलतापूर्वक अपलोड हो गया',
    upload_failed: 'अपलोड विफल रहा',
    upload_only_five_mb: 'सामग्री अपलोड करें (PDF फाइलें, अधिकतम 5)',
    docs_from_org_library: 'संगठन की लाइब्रेरी से दस्तावेज़ उपयोग करें',
    failed_maze_generate: 'मेज़ बनाने में विफल। कृपया पुनः प्रयास करें।',
    generate_metamaze: 'MetaMaze बना रहा है...',
    metamaze_being_generated:
      'आपका MetaMaze वर्तमान में बनाया जा रहा है। प्रक्रिया पूरी होने पर आपको ईमेल द्वारा सूचित किया जाएगा।',
    metamaze_generate_successfully: 'MetaMaze सफलतापूर्वक बना!',
    metamaze_with_proceed: 'अब आप MetaMaze के साथ आगे बढ़ सकते हैं।',
    ai_metamaze_generate: 'AI MetaMaze निर्माण',
    what_kind_maze_create: 'आप किस प्रकार का मेज़ बनाना चाहते हैं?',
    manual_metamaze_creation: 'मैनुअल MetaMaze निर्माण',
    manually_maze_customizing_scnario:
      'परिदृश्य और विकल्प पेड़ को कस्टमाइज़ करके मैन्युअली मेज़ बनाएं',
    maze_ai_generated: 'AI द्वारा स्वचालित मेज़ निर्माण',
    unmark_deadend: 'डेड एंड के रूप में अनचेक करें',
    mark_deadend: 'डेड एंड के रूप में चिह्नित करें',
    select_multiple_image_for_scenario:
      'आप परिदृश्य के लिए कई चित्र चुन सकते हैं।',
    select_your_image: 'आपके द्वारा चुनी गई छवियाँ',
    click_to_preview: 'पूर्वावलोकन के लिए क्लिक करें',
    are_you_sure_delete_image: 'क्या आप वाकई इस छवि को हटाना चाहते हैं?',
    select_image_from_library: 'मीडिया लाइब्रेरी से छवि चुनें',
    uploading_video: 'वीडियो अपलोड हो रहा है...',
    tree_node_type: 'ट्री नोड प्रकार',
    correct_option_scenario: 'सही विकल्प या परिदृश्य',
    incorrect_option: 'गलत विकल्प',
    option_scenario_without_text: 'बिना टेक्स्ट वाला विकल्प या परिदृश्य',
    dead_end: 'डेड एंड (लाल बॉर्डर)',
    correct_path: 'सही रास्ता',
    incorrect_path_not_selected_correct_option_path:
      'गलत रास्ता / जहां सही विकल्प नहीं चुना गया है।',
    double_click_on_tree_node:
      'जब आप किसी ट्री नोड पर डबल-क्लिक करेंगे, तो टेक्स्ट एडिटर उस नोड की सामग्री को स्वचालित रूप से दिखाएगा।',
    add_scenario: 'परिदृश्य जोड़ें',
    add_option: 'विकल्प जोड़ें',
    an_error_occured: 'एक त्रुटि हुई:',
    download_summary: 'सारांश डाउनलोड करें',
    step_wise_analysis: 'चरण-दर-चरण विश्लेषण',
    step: 'चरण',
    upload_csv_file: 'CSV फ़ाइल अपलोड करें',
    download_template_to_import: 'आयात के लिए नमूना टेम्पलेट डाउनलोड करें',
    please_input_email: 'कृपया ईमेल दर्ज करें।',
    email_at_least_three_characters: 'ईमेल कम से कम 3 अक्षरों का होना चाहिए।',
    email_cannot_be_empty: 'ईमेल खाली नहीं हो सकता।',
    input_email_in_new_line:
      'कृपया ईमेल दर्ज करें (प्रत्येक ईमेल नई लाइन पर हो)',
    role: 'भूमिका',
    select_role: 'कृपया भूमिका चुनें',
    select_group: 'कृपया समूह चुनें',
    identification_number: 'पहचान संख्या (वैकल्पिक)',
    add_identification_number: 'कृपया पहचान संख्या जोड़ें',
    pie_chart_of_all_categories:
      'Sharelook पर उनके उपयोग के आधार पर सभी श्रेणियों का पाई चार्ट।',
    total_sharesphere_question_answered_by_users:
      'वर्तमान संगठन में उपयोगकर्ताओं द्वारा उत्तर दिए गए ShareSphere प्रश्नों की कुल संख्या, इन श्रेणियों और उनकी सफलता व असफलता के परिणामों के साथ।',
    voice_style_over_the_text: `जहाँ आप उस टेक्स्ट पर कई वॉइस स्टाइल का उपयोग कर सकते हैं जो आप टाइप करते हैं। ब्ला ब्ला ब्ला, Lorem Ipsum प्रिंटिंग और टाइपसेटिंग उद्योग का मानक डमी टेक्स्ट है।`,
    input_your_question: 'कृपया अपना प्रश्न दर्ज करें!',
    make_me_sales_manager: 'जैसे: मुझे सेल्स मैनेजर बनाएं',
    enter_the_number_relevant_document:
      'संबंधित दस्तावेजों की संख्या दर्ज करें',
    please_wait_loading_result:
      'कृपया प्रतीक्षा करें, परिणाम लोड हो रहे हैं...',
    no_result_found: 'कोई परिणाम नहीं मिला, कृपया और प्रश्न पूछें',
    browser_doesnot_support_iframes:
      'आपका ब्राउज़र iframes का समर्थन नहीं करता',
    total_duration: 'कुल अवधि',
    number_of_messages: 'संदेशों की संख्या',
    search_result: 'खोज परिणाम',
    count_result: '(1244 परिणाम)',
    your_other_interests: 'आपकी अन्य रुचियाँ',
    your_total_score: 'आपका कुल स्कोर',
    add_a_question: '+ एक प्रश्न जोड़ें',
    travia_question_empty: 'ट्रिविया प्रश्न सूची खाली है।',
    video_generation_is_on_queue: 'आपका वीडियो निर्माण कतार में है!',
    checking_video_status: 'वीडियो स्थिति जांच रहे हैं...',
    total_quizzes: 'कुल क्विज़',
    number_of_votes: 'मतों की संख्या',
    total_events: 'कुल कार्यक्रम',
    number_of_rates: 'रेटिंग की संख्या',
    number_of_likes: 'लाइक्स की संख्या',
    all_courses: 'सभी कोर्स',
    total_questions: 'कुल प्रश्न',
    no_skill_journey: 'कोई कौशल यात्रा उपलब्ध नहीं है!',
    search_no_results: '- कोई परिणाम उपलब्ध नहीं!',
    no_image_generated: 'कोई छवि उत्पन्न नहीं हुई!',
    all_topic_in_this_lesson:
      'इस पाठ के सभी विषय हटाए जाएंगे। इसे पूर्ववत नहीं किया जा सकता।',
    content_has_been_generated: 'इस विषय के लिए सामग्री उत्पन्न कर दी गई है।',
    update_course_template: 'कोर्स टेम्पलेट अपडेट करें',
    add_course_template: 'कोर्स टेम्पलेट जोड़ें',
    create_course_now: 'अभी कोर्स बनाएं',
    preview_course: 'कोर्स पूर्वावलोकन',
    layout: 'लेआउट',
    import_from_youtube: 'यूट्यूब से आयात करें',
    my_media_library: 'मेरी मीडिया लाइब्रेरी',
    bg_added: 'पृष्ठभूमि जोड़ी गई',
    add_bg: 'पृष्ठभूमि जोड़ें',
    booked_schedule: 'बुक किया गया शेड्यूल',
    add_schedule: 'शेड्यूल जोड़ें',
    are_you_delete_schedule: 'क्या आप वाकई इस शेड्यूल को हटाना चाहते हैं?',
    add_task: 'कार्य जोड़ें',
    update_calender: 'कैलेंडर अपडेट करें',
    manage_cookies: 'कुकीज़ प्रबंधित करें',
    cookie_banner_text:
      'हम आपकी ब्राउज़िंग अनुभव को बेहतर बनाने, वेबसाइट ट्रैफ़िक का विश्लेषण करने और सामग्री को वैयक्तिकृत करने के लिए कुकीज़ का उपयोग करते हैं। आपकी गोपनीयता हमारे लिए महत्वपूर्ण है।',
    accept_all_cookies: 'सभी कुकीज़ स्वीकार करें',
    reject_all: 'सभी अस्वीकार करें',
    customize: 'अनुकूलित करें',
    cookie_preferences_title: 'कुकी वरीयताएँ और गोपनीयता सेटिंग्स',
    privacy_subtitle:
      'आपकी गोपनीयता हमारे लिए मायने रखती है। चुनें कि आप किन कुकीज़ के साथ सहज हैं। आप इन सेटिंग्स को कभी भी बदल सकते हैं।',
    save_choices: 'मेरे विकल्प सहेजें',
    strictly_necessary: 'सख्ती से आवश्यक',
    strictly_necessary_desc:
      'ये कुकीज़ वेबसाइट के सही ढंग से काम करने के लिए आवश्यक हैं। ये पेज नेविगेशन, फॉर्म सबमिशन और सुरक्षित क्षेत्रों तक पहुंच जैसी मूलभूत कार्यक्षमताएँ सक्षम करती हैं। इनके बिना वेबसाइट ठीक से काम नहीं कर सकती।',
    analytics_performance: 'विश्लेषण और प्रदर्शन',
    analytics_performance_desc:
      'ये कुकीज़ हमें यह समझने में मदद करती हैं कि आगंतुक हमारी वेबसाइट के साथ कैसे इंटरैक्ट करते हैं, जानकारी को गुमनाम रूप से एकत्रित और रिपोर्ट करके। यह हमें प्रदर्शन और उपयोगकर्ता अनुभव को बेहतर बनाने में मदद करता है।',
    advertising_marketing: 'विज्ञापन और विपणन',
    advertising_marketing_desc:
      'ये कुकीज़ आपके लिए विज्ञापन संदेशों को अधिक प्रासंगिक बनाने के लिए उपयोग की जाती हैं। ये एक ही विज्ञापन को बार-बार दिखने से रोकती हैं और सुनिश्चित करती हैं कि विज्ञापन ठीक से प्रदर्शित हों।',
    tracking_social: 'ट्रैकिंग और सोशल मीडिया',
    tracking_social_desc:
      'ये कुकीज़ उन्नत कार्यक्षमता और वैयक्तिकरण सक्षम करती हैं, जैसे सोशल मीडिया सुविधाएँ और वैयक्तिकृत सामग्री। इन्हें हम या तृतीय-पक्ष प्रदाताओं द्वारा सेट किया जा सकता है।',
    functional: 'कार्यात्मक',
    functional_desc:
      'ये कुकीज़ उन्नत कार्यक्षमताएँ सक्षम करती हैं जैसे चैट समर्थन, लाइव सहायता, और अन्य इंटरैक्टिव सुविधाएँ जो आपकी वेबसाइट अनुभव को बेहतर बनाती हैं।',
    your_rights: 'आपके अधिकार:',
    rights_description:
      'आप किसी भी समय अपनी सहमति वापस ले सकते हैं, अपने डेटा तक पहुंच सकते हैं, या इसके हटाने का अनुरोध कर सकते हैं।',
    withdraw_consent: 'सभी सहमति वापस लें',

    how_many_options: 'कितने विकल्प',
    add_content: 'सामग्री जोड़ें',
    downloads_center: 'डाउनलोड केंद्र',
    sharelook_help_center: 'Sharelook सहायता केंद्र',
    channel_outline: 'चैनल रूपरेखा',
    channel_objectives: 'चैनल उद्देश्य',
    no_sop_available: 'कोई SOP सूची उपलब्ध नहीं है।',
    generate_world_summary: 'परिदृश्य उत्पन्न करें',
    world_scenario: 'वास्तविक दुनिया का परिदृश्य',
    drag_icon_hint: 'संकेत: आइकन को कैनवास पर खींचकर स्थिति निर्धारित करें',
    drag_text_hint: 'संकेत: टेक्स्ट को कैनवास पर खींचकर स्थिति निर्धारित करें',
    edit_badge: 'बैज संपादित करें',
    create_new_badge: 'नया बैज बनाएं',
    select_video_preview: 'पूर्वावलोकन के लिए वीडियो चुनें',
    certificate_title_required: 'प्रमाणपत्र शीर्षक आवश्यक है',
    discard_changes: 'परिवर्तन रद्द करें',
    edit_certificate: 'प्रमाणपत्र संपादित करें',
    add_another_logo: 'एक और लोगो जोड़ें',
    optional: 'वैकल्पिक',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'नई क्वेस्ट बनाएं',
    quest_filter_title: 'क्वेस्ट',
    sharelook_assistance: 'Sharelook कोचिंग',
    upload_scorm_zip: 'SCORM ज़िप अपलोड करें',
    only_letters_numbers_space_dot_allowed:
      'केवल अक्षर, अंक, रिक्त स्थान और बिंदु की अनुमति है!',
    video_playing: 'चल रहा है',
    course_price_message: `*यह कोर्स केवल संगठन के उपयोगकर्ताओं के लिए प्रकाशित किया जाएगा और इसे मार्केटप्लेस पर पुनः बेचा नहीं जा सकता।`,
    lesson_must_be_positive: 'पाठों की संख्या 1 से अधिक होनी चाहिए',
    btn_proceed: 'आगे बढ़ें',
    rule_select_music: 'कृपया संगीत चुनें',
    course_info: 'कोर्स जानकारी',
    content_selection: 'सामग्री चयन',
    course_content_source: 'कोर्स सामग्री स्रोत',
    choose_how_to_source: 'इस कोर्स के लिए सामग्री कैसे प्राप्त करें, चुनें:',
    automatic_selection: 'स्वचालित चयन',
    system_will_automatically_select_relavant_documents:
      'सिस्टम स्वतः आपकी लाइब्रेरी से प्रासंगिक दस्तावेज़ों का चयन करेगा',
    manual_selection: 'मैनुअल चयन',
    choose_specific_documents_from_your_library:
      'अपनी लाइब्रेरी से विशिष्ट दस्तावेज़ चुनें',
    upload_files: 'फ़ाइलें अपलोड करें',
    upload_new_documents:
      'नए दस्तावेज़ अपलोड करें (PDF, DOC, DOCX, PPT, PPTX, TXT) - अधिकतम 5 फ़ाइलें',
    file: 'फ़ाइल',
    ready_to_upload: 'अपलोड के लिए तैयार',
    clear_all: 'सभी साफ़ करें',
    confirm_course_wide_premiew: 'कोर्स-वाइड प्रीव्यू की पुष्टि करें',
    generate_course_preview: 'कोर्स प्रीव्यू उत्पन्न करें',
    instructions_across_the_course_to_generate:
      'हम आपकी निर्देशों को पूरे कोर्स में लागू करेंगे ताकि एक प्रीव्यू तैयार किया जा सके। पहले सब कुछ समीक्षा करें, फिर रखें या रद्द करें।',
    instruction_to_preview_course_wide:
      'पूरे कोर्स का पूर्वावलोकन करने के निर्देश:',
    edit_content: 'सामग्री संपादित करें',
    manage_course_template: 'कोर्स टेम्पलेट प्रबंधित करें',
    undo: 'पूर्ववत करें',
    apply_changes: 'परिवर्तन लागू करें',
    characters: 'अक्षर',
    apply_all: 'सभी लागू करें',
    apply_to_all: 'सभी पर लागू करें',
    use_this_content: 'इस सामग्री का उपयोग करें',
    original: 'मूल',
    edited: 'संपादित',
    edited_content_preview: 'संपादित सामग्री पूर्वावलोकन',
    apply_edits_to_all_topices: 'क्या संपादन सभी विषयों पर लागू करें?',
    current_editing_instructions_across_the_whole_course:
      'यह आपकी वर्तमान संपादन निर्देशों को पूरे कोर्स में लागू करेगा। सहेजने से पहले आप संयुक्त पूर्वावलोकन की समीक्षा कर सकते हैं।',
    edit_content_instructions: 'सामग्री संपादन निर्देश',
    generate_content_for_this_topic_instruction:
      'अपने निर्देशों का उपयोग करके इस विषय के लिए सामग्री उत्पन्न करें',
    descrip_edit_content:
      'बताएं कि इस सामग्री को कैसे संपादित किया जाए (जैसे, छोटा करें, सरल करें, पुनर्लेखन करें)',
    try_short_clear_direcctives: `संक्षिप्त और स्पष्ट निर्देश आज़माएं। उदाहरण: "100 शब्दों में घटाएं, मुख्य बिंदु रखें", "भाषा सरल करें", "संक्षिप्त करें और अनावश्यक भाग हटाएं"।`,
    we_preserve_the_core_meaning:
      'हम आपके निर्देशों को लागू करते समय मूल अर्थ को बरकरार रखते हैं।',
    feedback_optional: 'प्रतिक्रिया (वैकल्पिक)',
    write_your_feedback_here: 'अपनी प्रतिक्रिया यहाँ लिखें',
    from_web: 'वेब से',
    from_desktop: 'डेस्कटॉप से',
    pleae_wait_processing: 'कृपया प्रतीक्षा करें, प्रोसेसिंग चल रही है...',
    create_simulation_from_screen_capture: 'स्क्रीन कैप्चर से सिमुलेशन बनाएं',
    sharelook_not_found: 'ShareLook नहीं मिला',
    sharelook_screen_capture_application_not_be_opened:
      'ShareLook स्क्रीन कैप्चर एप्लिकेशन नहीं खोला जा सका। यह आपके कंप्यूटर पर इंस्टॉल नहीं हो सकता है।',
    download_sharelook: 'ShareLook डाउनलोड करें',
    launch_sharelook_application: 'ShareLook एप्लिकेशन लॉन्च करें',
    this_will_open_the_sharelook_application_for_screen_capture:
      'यह स्क्रीन कैप्चर के लिए ShareLook एप्लिकेशन खोलेगा।',
    sharelook_dosenot_open:
      'यदि ShareLook नहीं खुलता, तो यह आपके कंप्यूटर पर इंस्टॉल नहीं हो सकता।',
    open_sharelook: 'ShareLook खोलें',
    download_app: 'ऐप डाउनलोड करें',
    background_image_setting: 'पृष्ठभूमि छवि सेटिंग्स',
    current_image: 'वर्तमान छवि',
    change_image: 'छवि बदलें',
    remove_image: 'छवि हटाएं',
    no_background_image_selected: 'कोई पृष्ठभूमि छवि चयनित नहीं है',
    add_image: 'छवि जोड़ें',
    this_will_open_for_screen_recording:
      'यह स्क्रीन रिकॉर्डिंग के लिए ShareLook एप्लिकेशन खोलेगा।',
    ai_image_generation: 'AI छवि निर्माण',
    image_edit: 'छवि संपादन',
    text_to_image: 'टेक्स्ट से छवि',
    output_gallary: 'आउटपुट गैलरी',
    instant_generation: 'तुरंत जनरेशन के लिए तैयार',
    prompt_and_unleash_the_power:
      'अपना प्रॉम्प्ट दर्ज करें और इसकी शक्ति खोलें',
    use_this_image: 'इस छवि का उपयोग करें',
    error_generating: 'जनरेट करने में त्रुटि।',
    generation_tips: 'जनरेशन सुझाव',
    detailed_descriptions_for_more_accurate_results:
      'अधिक सटीक परिणामों के लिए विस्तृत विवरणों का उपयोग करें',
    reference_image: 'संदर्भ छवि',
    select_pixel_image: 'पिक्सेल छवि चुनें',
    max_mb: 'अधिकतम 50MB',
    please_enter_text_to_appear_image:
      'कृपया वह टेक्स्ट दर्ज करें जो छवि में दिखाई देगा',
    enter_text_to_apear_in_the_image: 'वह टेक्स्ट दर्ज करें जो छवि में दिखेगा',
    generate_image: 'छवि बनाएं',
    prompt_assistant: 'प्रॉम्प्ट सहायक',
    generate_image_using_suggested_prompt:
      'सुझाए गए प्रॉम्प्ट का उपयोग करके छवि बनाएं',
    talk_to_ai_about_the_image_generate:
      'उस छवि के बारे में AI से बात करें जिसे आप बनाना चाहते हैं',
    ask_for_prompt_suggestions: 'प्रॉम्प्ट सुझाव मांगें...',
    enter_a_search_term_to_find_stock_images:
      'स्टॉक छवियाँ खोजने के लिए एक खोज शब्द दर्ज करें',
    choose_your_content_source: 'अपना सामग्री स्रोत चुनें:',
    upload_new_document_from_your_device:
      'अपने डिवाइस से नए दस्तावेज़ अपलोड करें',
    automatic_library_selection: 'स्वचालित लाइब्रेरी चयन',
    system_automatically_selects_relevant_document:
      'सिस्टम स्वचालित रूप से प्रासंगिक दस्तावेज़ चुनता है',
    manual_library_selection: 'मैनुअल लाइब्रेरी चयन',
    generate_content: 'सामग्री बनाएं',
    add_to_current_page: 'वर्तमान पृष्ठ में जोड़ें',
    generate_bullet_points: 'बुलेट पॉइंट बनाएं',
    generating: 'बनाया जा रहा है',
    this_may_take_a_few_moments: 'इसमें कुछ समय लग सकता है',
    apply_to_page: 'पृष्ठ पर लागू करें',
    scenario_escription: 'परिदृश्य विवरण:',
    feedback: 'प्रतिक्रिया',
    form_mode: 'फ़ॉर्म मोड',
    chat_mode: 'चैट मोड',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'यह AI का उपयोग करके चयनित कहानी की एक निरंतरता उत्पन्न करेगा।',
    continue_this_story_question: 'क्या आप इस कहानी को जारी रखना चाहते हैं?',
    continue_this_story: 'इस कहानी को जारी रखें',
    what_will_happen: 'क्या होगा:',
    the_ai_will_analyze_the_existing_story_content:
      'AI मौजूदा कहानी सामग्री का विश्लेषण करेगा',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'एक प्राकृतिक निरंतरता उत्पन्न करें जो समान स्वर और शैली का पालन करे',
    create_new_content_that_build_upon_the_current_narrative:
      'नई सामग्री बनाएं जो वर्तमान कथा पर आधारित हो',
    this_process_may_take_a_few_moments_to_complete:
      'इस प्रक्रिया को पूरा होने में कुछ समय लग सकता है।',
    no_existing_stories_found_for_this_course:
      'इस पाठ्यक्रम के लिए कोई मौजूदा कहानियाँ नहीं मिलीं।',
    create_your_first_story: 'अपनी पहली कहानी बनाएं',
    existing_stories: 'मौजूदा कहानियाँ',
    create_new_story: 'नई कहानी बनाएं',
    tone: 'स्वर',
    style: 'शैली',
    genre: 'शैली प्रकार',
    loading_your_stories: 'आपकी कहानियाँ लोड हो रही हैं...',
    edit_story: 'कहानी संपादित करें',
    story_preferences: 'कहानी प्राथमिकताएँ',
    please_input_your: 'कृपया अपना दर्ज करें',
    add_character_names_and_press_enter: 'चरित्र के नाम जोड़ें और एंटर दबाएँ',
    select_or_type_your: 'अपना चयन करें या टाइप करें',
    enter_your: 'अपना दर्ज करें',
    position_of_the_story_in_the_lesson:
      'कहानी का पाठ में स्थान। कहानी निर्दिष्ट स्थिति पर ब्लॉक के रूप में जोड़ दी जाएगी।',
    save_previous_content_on_the_pages: 'पृष्ठों पर पिछले सामग्री को सहेजें',
    the_existing_content_in_the_selected_pages:
      'चयनित पृष्ठों की मौजूदा सामग्री को उत्पन्न कहानी से बदल दिया जाएगा।',
    real_world_scenario: 'वास्तविक दुनिया का परिदृश्य',
    add_optional_instructions:
      'वैकल्पिक निर्देश जोड़ें (स्वर, लंबाई, दर्शक आदि)',
    ready_to_enerate_your_real_world_scenario:
      'आपका वास्तविक दुनिया परिदृश्य तैयार है',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      '"वास्तविक दुनिया परिदृश्य उत्पन्न करें" पर क्लिक करें ताकि आपके पाठ सामग्री के आधार पर एक वास्तविक परिदृश्य बन सके।',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI आपके पाठ्यक्रम के विषय और सामग्री का विश्लेषण करेगा',
    generate_a_practical_real_world_scenario:
      'एक व्यावहारिक वास्तविक दुनिया परिदृश्य उत्पन्न करें',
    you_can_then_edit_and_customize_the_result:
      'आप फिर परिणाम को संपादित और अनुकूलित कर सकते हैं',
    add_it_as_a_new_page_to_your_lesson:
      'इसे अपने पाठ में एक नए पृष्ठ के रूप में जोड़ें',
    regenerate_with_instructions: 'निर्देशों के साथ पुनः उत्पन्न करें',
    add_real_world_scenario: 'वास्तविक दुनिया परिदृश्य जोड़ें',
    generate_real_world_scenario: 'वास्तविक दुनिया परिदृश्य उत्पन्न करें',
    simulation_has_been_stopped: 'सिमुलेशन रोक दिया गया है!',
    loading_simulation: 'सिमुलेशन लोड हो रहा है...',
    you_have_exhausted_all_the_attempts: 'आपने सभी प्रयास समाप्त कर दिए हैं',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'इस पृष्ठ पर परिदृश्य का अध्ययन करें और नीचे दिए गए विकल्पों में से सही उत्तर चुनें।',
    attempts_limit_reached:
      'प्रयासों की सीमा पूरी हो गई। आप फिर से खेल सकते हैं लेकिन आपका स्कोर सहेजा नहीं जाएगा।',
    play_again: 'फिर से खेलें',
    import_music_from_computer: 'कंप्यूटर से संगीत आयात करें।',
    more: 'अधिक',
    no_badge_yet: 'अभी कोई बैज नहीं',
    competition_filter: 'प्रतियोगिता फ़िल्टर',
    global_leaderboard: 'वैश्विक लीडरबोर्ड',
    placeholder_for_the_global_leaderboard:
      'यह वैश्विक लीडरबोर्ड के लिए प्लेसहोल्डर है।',
    badge_editor: 'बैज संपादक',
    adjust_the_appearance_of_this_badge_icon:
      'इस बैज आइकन की उपस्थिति समायोजित करें। परिवर्तन केवल इस बैज पर लागू होंगे।',
    badge_style: 'बैज शैली',
    the_image_must_be_pixels: 'छवि 200x200 पिक्सेल में होनी चाहिए।',
    badge_name: 'बैज का नाम',
    badge_descrription: 'बैज विवरण',
    enter_badge_criteria: 'बैज मानदंड दर्ज करें',
    discard: 'त्यागें',
    badge_enable: 'बैज सक्षम',
    award_users_with_badges_to_highlight_the_milestones:
      'उपयोगकर्ताओं को बैज देकर उनके सीखने की यात्रा के मील के पत्थर को उजागर करें।',
    badge_types: 'बैज प्रकार',
    enable_or_disable_specific_badge_types_for_your_users:
      'अपने उपयोगकर्ताओं के लिए विशिष्ट बैज प्रकार सक्षम या अक्षम करें।',
    levels_enabled: 'स्तर सक्षम',
    level_rules: 'स्तर नियम',
    points: 'अंक',
    add_new_level: 'नया स्तर जोड़ें',
    add_level: 'स्तर जोड़ें',
    points_enabled: 'अंक सक्षम',
    learning_activities_and_encourage_healthy_competition:
      'विभिन्न सीखने की गतिविधियों के लिए उपयोगकर्ताओं को अंक प्रदान करें और स्वस्थ प्रतिस्पर्धा को बढ़ावा दें।',
    award_points: 'अंक प्रदान करें',
    the_following_equates_the_value_of_one_item_completion:
      'निम्नलिखित एक आइटम पूर्णता के मूल्य के बराबर है',
    general: 'सामान्य',
    others: 'अन्य',
    certificate: 'प्रमाण पत्र',
    quiz_passed: 'क्विज़ पास हुआ',
    tip_approved: 'टिप अनुमोदित',
    tip_liked: 'टिप पसंद की गई',
    rewards: 'इनाम',
    offer_discounts_when_learners_achieve:
      'जब सीखने वाले अंक, बैज या स्तर प्राप्त करें तो छूट दें।',
    give_rewards: 'इनाम दें',
    discount_course_purchases_by: 'कोर्स खरीद पर छूट दें',
    with_points_more_than: 'अंक से अधिक वाले',
    with_badges_more_than: 'बैज से अधिक वाले',
    with_level_upwards_more_than: 'स्तर से ऊपर वाले',
    leaderboard: 'लीडरबोर्ड',
    leaderboard_enabled: 'लीडरबोर्ड सक्षम',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'लीडरबोर्ड उपयोगकर्ताओं को उनके अंक की तुलना में उनकी सीखने की प्रगति का अवलोकन प्रदान करता है।',
    show_levels: 'स्तर दिखाएँ',
    show_points: 'अंक दिखाएँ',
    show_badges: 'बैज दिखाएँ',
    show_courses: 'कोर्स दिखाएँ',
    show_certificates: 'प्रमाण पत्र दिखाएँ',
    leaderboard_settings: 'लीडरबोर्ड सेटिंग्स',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'सीखने वालों की प्रेरणा बढ़ाने के लिए लीडरबोर्ड अनुभव सेट करें।',
    award_users_with_points_for_different_learning_activities:
      'विभिन्न सीखने की गतिविधियों के लिए उपयोगकर्ताओं को अंक प्रदान करें।',
    badge_set: 'बैज सेट',
    choose_the_type_of_badges_your_users:
      'अपने उपयोगकर्ताओं द्वारा अर्जित किए जाने वाले बैज का प्रकार चुनें।',
    levels: 'स्तर',
    Levels_represent_the_stages:
      'स्तर उपयोगकर्ता की सीखने की यात्रा के चरणों का प्रतिनिधित्व करते हैं।',
    enabled: 'सक्षम',
    disabled: 'अक्षम',
    quick_select: 'त्वरित चयन',
    yesterday: 'कल',
    last_week: 'पिछले सप्ताह',
    Last_month: 'पिछले महीने',
    last_quarter: 'पिछली तिमाही',
    historical_leaderboard: 'ऐतिहासिक लीडरबोर्ड',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'अपनी प्रदर्शन को ट्रैक करें और देखें कि आप अपने सहकर्मियों में कहाँ हैं।',
    time_period: 'समय अवधि',
    page_of: 'पृष्ठ 1 का 1',
    edit_competition: 'प्रतियोगिता संपादित करें',
    create_competition: 'प्रतियोगिता बनाएँ',
    arrow_right: 'सुई-दाएँ',
    update_competition: 'प्रतियोगिता अपडेट करें',
    competition_title: 'प्रतियोगिता शीर्षक',
    enter_competition_title: 'प्रतियोगिता शीर्षक दर्ज करें',
    enter_competition_description: 'प्रतियोगिता विवरण दर्ज करें',
    leaderboard_skill: 'कौशल',
    select_a_skill: 'कौशल चुनें',
    no_skills_found: 'कोई कौशल नहीं मिला',
    competition_period: 'प्रतियोगिता अवधि',
    add_badge_rule: 'बैज नियम जोड़ें',
    create_badge: 'बैज बनाएँ',
    add_level_rule: 'स्तर नियम जोड़ें',
    selected_participants: 'चयनित प्रतिभागी',
    no_participants: 'कोई प्रतिभागी नहीं',
    start_end_date: 'आरंभ-समाप्ति तिथि',
    created_date: 'द्वारा बनाया गया',
    new_competition: 'नई प्रतियोगिता',
    competitions_list: 'प्रतियोगिता सूची',
    search_competitions: 'प्रतियोगिताओं की खोज करें...',
    are_you_sure_you_want_to_delete_the_competition:
      'क्या आप निश्चित रूप से प्रतियोगिता को हटाना चाहते हैं?',
    history: 'इतिहास',
    export: 'निर्यात',
    search_by_name: 'नाम से खोजें...',
    no_historical_data_available_for_the_selected_period:
      'चयनित अवधि के लिए कोई ऐतिहासिक डेटा उपलब्ध नहीं है।',
    no_leaderboard_data_available: 'कोई लीडरबोर्ड डेटा उपलब्ध नहीं है।',
    competitions: 'प्रतियोगिताएँ',
    leaderboards: 'लीडरबोर्ड',
    welcome_back: 'वापसी पर स्वागत है',
    track_your_performance_and_see:
      'अपनी प्रदर्शन को ट्रैक करें और देखें कि आप अपने सहकर्मियों में कहाँ हैं।',
    team_leaderboard: 'टीम लीडरबोर्ड',
    try_again: 'फिर प्रयास करें',
    no_competitions_for_search: 'कोई प्रतियोगिताएँ उपलब्ध नहीं',
    no_competitions_available: 'कोई प्रतियोगिताएँ उपलब्ध नहीं',
    no_competitions_matching_search:
      'आपकी खोज से मेल खाने वाली कोई प्रतियोगिता नहीं मिली। खोज शब्द बदलें या बाद में देखें।',
    no_competitions_general:
      'वर्तमान में कोई प्रतियोगिता सेट नहीं है। बाद में देखें या अपने व्यवस्थापक से संपर्क करें।',
    media_management: 'मीडिया प्रबंधन',
    badgess_set: 'बैज सेट',
    choose_the_default_visual_style_for_badge:
      'प्लेटफ़ॉर्म पर उपयोग किए जाने वाले बैज आइकनों के लिए डिफ़ॉल्ट दृश्य शैली चुनें।',
    enable_badges: 'बैज सक्षम करें',
    add_badge: 'बैज जोड़ें',
    min: 'न्यून',
    max: 'अधिकतम',
    your_rank: 'आपकी रैंक',
    your_points: 'आपके अंक',
    your_level: 'आपका स्तर',
    rank: 'रैंक #',
    level: 'स्तर',
    progress: 'प्रगति',
    new_folder: 'नया फ़ोल्डर',
    file_upload: 'फ़ाइल अपलोड',
    writer: 'लेखक',
    text_documents: 'टेक्स्ट दस्तावेज़',
    spreadsheets: 'स्प्रेडशीट',
    impress: 'इम्प्रेस',
    presentations: 'प्रस्तुतियाँ',
    capture_desktop_screen: 'डेस्कटॉप स्क्रीन कैप्चर करें',
    capture_desktop_screens: 'डेस्कटॉप स्क्रीन कैप्चर करें',
    your_documents: 'आपके दस्तावेज़',
    manage_your_videos_images_audio_files:
      'अपनी वीडियो, इमेज, ऑडियो फ़ाइलों और अन्य सामग्री को प्रबंधित करें।',
    your_organization_documents: 'आपके संगठन के दस्तावेज़',
    keep_your_organization_creative_assets_organized:
      'अपने संगठन की क्रिएटिव संपत्तियों को व्यवस्थित और सुलभ रखें—टीमवर्क और सामग्री उत्पादन को सरल बनाएं।',
    your_public_documents: 'आपके सार्वजनिक दस्तावेज़',
    curated_collection_of_media_assets_available:
      'सभी के लिए उपलब्ध एक क्यूरेटेड मीडिया संग्रह—अन्वेषण करें, पुन: उपयोग करें और बनाएं।',
    your_download_center_documents: 'आपके डाउनलोड केंद्र दस्तावेज़',
    repository_of_approved_media_assets_for_download:
      'डाउनलोड और आपके प्रोजेक्ट्स में उपयोग के लिए अनुमोदित मीडिया संसाधनों का संग्रह।',
    search_files_and_folders: 'फ़ाइल और फ़ोल्डर खोजें...',
    home: 'मुख पृष्ठ',
    folders: 'फ़ोल्डर',
    folder_name: 'फ़ोल्डर का नाम',
    owner: 'मालिक',
    last_updated: 'अंतिम अपडेट',
    action: 'कार्य',
    no_folders_found: 'कोई फ़ोल्डर नहीं मिला',
    files: 'फ़ाइलें',
    enabling_ai: 'AI सक्षम किया जा रहा है...',
    rename: 'नाम बदलें',
    copy: 'कॉपी करें',
    move: 'स्थानांतरित करें',
    verson_history: 'संस्करण इतिहास',
    manage_permission: 'अनुमतियाँ प्रबंधित करें',
    generate_audit_report: 'ऑडिट रिपोर्ट उत्पन्न करें',
    last_edited: 'अंतिम संपादन',
    no_files_found: 'कोई फ़ाइलें नहीं मिलीं',
    are_you_sure_you_want_to_make_this_item_public:
      'क्या आप सुनिश्चित हैं कि आप इस आइटम को सार्वजनिक करना चाहते हैं? यह आपकी सार्वजनिक लाइब्रेरी में कॉपी हो जाएगा।',
    move_to_organization: 'संगठन में स्थानांतरित करें',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'क्या आप सुनिश्चित हैं कि आप इस आइटम को अपनी संगठन लाइब्रेरी में कॉपी करना चाहते हैं?',
    are_you_sure_you_want_to_make_this_item_private:
      'क्या आप सुनिश्चित हैं कि आप इस आइटम को निजी बनाना चाहते हैं? यह आपकी निजी लाइब्रेरी में कॉपी हो जाएगा।',
    date_modified: 'संशोधित तिथि',
    workflow_management: 'वर्कफ़्लो प्रबंधन',
    configure_editors_approvers_and_viewers_for_this_document:
      'इस दस्तावेज़ के लिए संपादक, अनुमोदक और दर्शक कॉन्फ़िगर करें।',
    error_Loading_editor: 'संपादक लोड करने में त्रुटि',
    debug_info: 'डीबग जानकारी',
    loading_editor: 'संपादक लोड हो रहा है...',
    submitted_for_review: 'समीक्षा के लिए प्रस्तुत किया गया',
    editors: 'संपादक',
    no_editors_added_yet:
      'अभी तक कोई संपादक नहीं जोड़ा गया। एक जोड़ने के लिए "संपादक जोड़ें" पर क्लिक करें।',
    add_editor: 'संपादक जोड़ें',
    approvers: 'अनुमोदक',
    no_approvers_added_yet:
      'अभी तक कोई अनुमोदक नहीं जोड़ा गया। एक जोड़ने के लिए "अनुमोदक जोड़ें" पर क्लिक करें।',
    add_approvers: 'अनुमोदक जोड़ें',
    viewer: 'दर्शक',
    no_viewers_added_yet:
      'अभी तक कोई दर्शक नहीं जोड़ा गया। एक जोड़ने के लिए "दर्शक जोड़ें" पर क्लिक करें।',
    add_viewer: 'दर्शक जोड़ें',
    are_you_sure_you_want_to_delete_the_selected_items:
      'क्या आप सुनिश्चित हैं कि आप चयनित आइटम हटाना चाहते हैं?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'श्रेणी अवलोकन',
    triviaReport: 'ShareSphere श्रेणी',
    overviewGraph: 'श्रेणी अवलोकन ग्राफ',
    category: 'श्रेणी',
    phCategory: 'श्रेणी चुनें',
    podcast: 'पॉडकास्ट, संगीत और कहानियाँ',
    pastPodcast: 'पिछला पॉडकास्ट',
    upcomingPodcast: 'आगामी पॉडकास्ट',
    podcastLanguageTitle: 'पॉडकास्ट, संगीत और कहानियों की भाषा',
    podcastLanguageCheckbox: 'मेरे पॉडकास्ट के लिए AI भाषा उत्पन्न करें',
    howRate: 'आप इस पॉडकास्ट को कैसे रेट करेंगे?',
    podcastSubmit: 'सबमिट करें',
    podcastGuest: 'अतिथि वक्ता:',
    podcastReview: 'समीक्षाएँ',
    podcastEpishode: 'एपिसोड',
    podcastEnd: 'पॉडकास्ट समाप्त हो चुका है',
    date_podcast: 'पॉडकास्ट तिथि',
    skill_not_found: 'क्षमा करें! कोई कौशल यात्रा नहीं मिली।',
    coaching: 'कोचिंग',
    webinar: 'वेबिनार',
    public_conference: 'सार्वजनिक सम्मेलन',
    skill_journey_subtitle:
      'अपनी कौशल यात्रा के लिए सेटिंग्स जोड़ें और चुनें कि कौन आपकी कौशल यात्रा देख और इंटरैक्ट कर सकता है।',
    enable_white_label: 'व्हाइट लेबल सक्षम करें',
    create_new_event_org: 'अपने संगठन के लिए एक नया इवेंट बनाएं।',
    create_new_event_marketplace: 'मार्केटप्लेस के लिए नया इवेंट बनाएं।',
    create_new_event_both:
      'अपने संगठन और मार्केटप्लेस दोनों के लिए नया इवेंट बनाएं।',
    event_outline: 'कृपया इवेंट रूपरेखा दर्ज करें',
    event_obj: 'कृपया इवेंट उद्देश्यों को दर्ज करें',
    event_description: 'कृपया इवेंट विवरण दर्ज करें',
    create_new_metamaze_org: 'अपने संगठन के लिए नया MetaMaze बनाएं।',
    create_new_metamaze_marketplace: 'मार्केटप्लेस के लिए नया MetaMaze बनाएं।',
    create_new_metamaze_both:
      'अपने संगठन और मार्केटप्लेस दोनों के लिए नया MetaMaze बनाएं।',
    add_key_words: 'कीवर्ड जोड़ें',
    press_enter_make_keyword: 'कीवर्ड बनाने के लिए Enter दबाएं',
    disable_skip_quiz: 'क्विज़ छोड़ना अक्षम करें',
    warning_complete_quiz: 'आगे बढ़ने के लिए कृपया क्विज़ पूरा करें।',
    signup_email_verification:
      'हमने आपके द्वारा प्रदान किए गए पते पर एक सत्यापन लिंक ईमेल किया है। कृपया पंजीकरण की पुष्टि के लिए उस लिंक पर जाएं।',
    verifying_registration: 'खाता पंजीकरण सत्यापित किया जा रहा है...',
    reset_password_linK:
      'हमने आपके द्वारा प्रदान किए गए पते पर एक लिंक ईमेल किया है। कृपया नई पासवर्ड सेट करने के लिए उस लिंक पर जाएं।',
    reset_email_error:
      'इस ईमेल के साथ कोई उपयोगकर्ता नहीं मिला, कृपया इसके बजाय उपयोगकर्ता नाम का प्रयास करें!',
    first_name: 'पहला नाम',
    last_name: 'अंतिम नाम',
    error_firstName: 'कृपया अपना पहला नाम दर्ज करें',
    error_sharebot_organization: 'कृपया अपना संगठन दर्ज करें',
    error_lastName: 'कृपया अपना अंतिम नाम दर्ज करें',
    private_conference: 'निजी सम्मेलन',
    public_conference: 'सार्वजनिक सम्मेलन',
    discussion_room: 'चर्चा कक्ष',
    training_no_courses: 'आप वर्तमान में किसी भी कोर्स में नामांकित नहीं हैं।',
    training_no_events: 'आप वर्तमान में किसी भी इवेंट में नामांकित नहीं हैं।',
    allow_sharing_trainer_info:
      'मार्केटप्लेस में ईमेल पता साझा करने की अनुमति दें',
    error_username_space: 'उपयोगकर्ता नाम में कोई स्पेस नहीं हो सकता।',
    error_sharebot_organization_space: 'संगठन नाम में कोई स्पेस नहीं हो सकता।',
    edit_permission: 'संपादन अनुमति',
    valid_price: 'कीमत 0 से अधिक होनी चाहिए',
    course_price_message: `*कोर्स केवल उन उपयोगकर्ताओं की संख्या को प्रकाशित किया जाएगा जो संगठन ने खरीदे हैं और इसे मार्केटप्लेस पर पुनर्विक्रय नहीं किया जा सकेगा।`,
    valid_edit_price: 'संपादन की कीमत खरीद मूल्य से कम होनी चाहिए।',
    my_calendar: 'मेरा कैलेंडर',
    error_valid_firstName: 'कृपया एक मान्य पहला नाम दर्ज करें।',
    error_valid_organization: 'कृपया एक मान्य संगठन नाम दर्ज करें।',
    error_valid_lastName: 'कृपया एक मान्य अंतिम नाम दर्ज करें।',
    error_name_spaces: 'नाम में कोई स्पेस नहीं हो सकता',
    items: 'आइटम',
    publish_to_channel: 'मेरे चैनल संग्रह में प्रकाशित करें',
    create_a_channel: 'चैनल बनाएँ',
    create_a_trivia: 'ट्रिविया गेम बनाएँ',
    create_a_new_channel: 'एक नया चैनल बनाएँ',
    add_videos: 'वीडियो जोड़ें',
    save_and_continue: 'सहेजें और जारी रखें',
    channel: 'चैनल',
    channels: 'चैनल्स',
    view_channel: 'चैनल देखें',
    edit_channel: 'चैनल संपादित करें',
    delete_channel: 'चैनल हटाएँ',
    my_video_channels: 'मेरे वीडियो चैनल',
    training_no_channel: 'आप वर्तमान में किसी भी चैनल में नामांकित नहीं हैं।',
    monthly_price_required: 'मासिक मूल्य आवश्यक है',
    yearly_price_required: 'वार्षिक मूल्य आवश्यक है',
    one_time_price_required: 'एक बार का मूल्य आवश्यक है',
    marketplace_quantity: 'USD',
    report_webinar: 'वेबिनार',
    report_coaching: 'कोचिंग',
    report_channel: 'चैनल',
    report_public_conference: 'सार्वजनिक सम्मेलन',
    report_maze: 'मेज',
    channel: 'चैनल',
    edit_price: 'कीमत संपादित करें ($)',
    quantity: 'मात्रा',
    payment_type: 'भुगतान प्रकार',
    total_amount: 'कुल राशि ($)',
    net_amount: 'शुद्ध राशि ($)',
    edit_option: 'संपादन विकल्प',
    marketplace_price: 'कीमत ($)',
    market_name: 'नाम',
    duration_min: 'अवधि (मिनट)',
    users_total: 'उपयोगकर्ता (कुल)',
    sales_total: 'कुल बिक्री (USD)',
    search_coaching: 'कोचिंग खोजें',
    search_channel: 'चैनल खोजें',
    search_webinar: 'वेबिनार खोजें',
    search_maze: 'मेज खोजें',
    search_public_conference: 'सार्वजनिक सम्मेलन खोजें',
    buyer_type: 'खरीदार का प्रकार',
    quanity: 'मात्रा',
    channel_unit_amount: 'शुद्ध राशि ($)',
    channel_updated_at: 'अद्यतन की तारीख',
    month_price: 'मूल्य (महीना)',
    year_price: 'मूल्य (साल)',
    one_time_price: 'मूल्य (एक बार)',
    sharebot_organization: 'नया संगठन नाम जोड़ें',
    share_sphere: 'ShareSphere',
    ai_course_title: 'कोर्स का शीर्षक',
    ai_input_course_title: 'कृपया कोर्स का शीर्षक दर्ज करें!',
    learning_objective_label: 'सीखने का उद्देश्य',
    learning_objective_message: 'कृपया सीखने का उद्देश्य दर्ज करें!',
    standard_question: 'क्या कोई मानक है जिसे छात्र को पूरा करना होगा?',
    standard_details_label: 'मानक विवरण',
    standard_details_message: 'कृपया मानक विवरण दर्ज करें!',
    estimated_duration_label: 'कोर्स की अनुमानित अवधि (मिनटों में)',
    estimated_duration_message: 'कृपया अनुमानित अवधि दर्ज करें!',
    min_duration_message: 'न्यूनतम अवधि 5 मिनट है।',
    ai_mins: '25 मिनट',
    industry_specific_question: 'क्या यह किसी विशेष उद्योग के लिए विशिष्ट है?',
    industry_label: 'उद्योग निर्दिष्ट करें',
    industry_message: 'कृपया उद्योग दर्ज करें!',
    ai_course_creation: 'AI द्वारा कोर्स निर्माण',
    course_generated: 'Sharelook द्वारा जनरेट किया गया कोर्स',
    ai: 'AI',
    ai_you: 'आप',
    ai_prompt_ready: 'आपका अनुरोध तैयार है। अब आप कोर्स सामग्री बना सकते हैं।',
    ai_unable_respond:
      'क्षमा करें! AI आपके अनुरोध का उत्तर नहीं दे सका। कृपया पुनः प्रयास करें।',
    ai_hide_toc: 'विषय सूची छुपाएं',
    ai_preview_toc: 'विषय सूची पूर्वावलोकन',
    ai_generate_toc_now: 'अभी विषय सूची बनाएं',
    ai_creation_course_title: 'कोर्स का शीर्षक:',
    ai_creation_industry_specific:
      'क्या यह किसी विशेष उद्योग के लिए विशिष्ट है:',
    ai_creation_industry: 'उद्योग:',
    ai_creation_standard_needed:
      'क्या कोई मानक है जिसे छात्र को पूरा करना होगा?',
    ai_creation_standard_details: 'मानक विवरण:',
    ai_creation_estimated_duration: 'कोर्स की अनुमानित अवधि (मिनटों में):',
    minutes: 'मिनट',
    ai_creation_learning_objective: 'सीखने का उद्देश्य:',
    setup_again: 'फिर से सेट करें',
    ai_creation_confirm_title:
      'क्या आप सुनिश्चित हैं कि आप फॉर्म रीसेट करना चाहते हैं?',
    ai_creation_confirm_content:
      'संपूर्ण बातचीत और उत्पन्न सामग्री रीसेट हो जाएगी।',
    ai_toc: 'विषय सूची',
    ai_note_topic:
      'ध्यान दें: आप कोर्स के विषयों को पुनः व्यवस्थित करने के लिए ड्रैग और ड्रॉप कर सकते हैं।',
    ai_add_topic: '+ विषय जोड़ें',
    add_topic: 'विषय जोड़ें',
    add_lesson: 'पाठ जोड़ें',
    add_new_lesson: 'नया पाठ जोड़ें',
    ai_add_lesson: '+ पाठ जोड़ें',
    attention: 'ध्यान दें',
    before_varifying: 'सत्यापन से पहले',
    ai_save_later: 'बाद में सहेजें',
    ai_download_word_doc: 'Word दस्तावेज़ के रूप में डाउनलोड करें',
    ai_download_course_word_doc:
      'कोर्स को Word दस्तावेज़ के रूप में डाउनलोड करें',
    ai_create_course_button: 'कोर्स बनाएं',
    ai_generate_course_content: 'कोर्स सामग्री बनाएं',
    ai_out_of: 'में से',
    ai_subtopic_failed_content:
      "उप-विषयों के लिए सामग्री बनाने में विफल। कृपया केवल इन उप-विषयों के लिए सामग्री बनाने के लिए 'कोर्स सामग्री बनाएं' पर फिर से क्लिक करें।",
    ai_edit_topic: 'विषय संपादित करें',
    ai_edit_lesson_title: 'पाठ शीर्षक संपादित करें',
    ai_save_topic: 'विषय सहेजें',
    ai_save: 'सहेजें',
    ai_save_lesson_title: 'पाठ शीर्षक सहेजें',
    ai_add_new_topic: 'नया विषय जोड़ें',
    ai_download_ref: 'संदर्भ के साथ डाउनलोड करें',
    ai_download_ref_content:
      'यह कोर्स को Word दस्तावेज़ के रूप में संदर्भों के साथ डाउनलोड करेगा।',
    ai_download_without_ref: 'संदर्भों के बिना डाउनलोड करें',
    ai_download_two_word: 'दो Word दस्तावेज़ डाउनलोड होंगे:',
    ai_download_two_word_content_one:
      '- एक मुख्य सामग्री के साथ बिना संदर्भों के,',
    ai_download_two_word_content_two:
      'और दूसरा केवल संदर्भों की सूची के साथ बिना लिंक की गई सामग्री के।',
    ai_manage_content: 'सामग्री प्रबंधित करें',
    ai_add_content_from_internet: '+ इंटरनेट से सामग्री जोड़ें',
    ai_confirm_start: 'शुरू करने की पुष्टि करें',
    ai_Verify: 'सत्यापित करें',
    ai_undo_warning:
      'यह प्रक्रिया कुछ समय ले सकती है। कृपया निर्माण पूरा होने तक विंडो बंद न करें क्योंकि इसे पूर्ववत नहीं किया जा सकता।',
    ai_verified_content:
      'आपने सामग्री सत्यापित कर दी है। सत्यापन के बाद आप इस सामग्री के साथ AI सहायक बातचीत पर वापस नहीं जा सकते।',
    ai_want_proceed: 'क्या आप सुनिश्चित हैं कि आप आगे बढ़ना चाहते हैं?',
    upload_simulation: 'सिमुलेशन अपलोड करें',
    name_simulation: 'सिमुलेशन का नाम',
    selected_simulation_files: 'चयनित सिमुलेशन फ़ाइलें',
    score_between_one_hundred: 'आपका स्कोर 1 से 100 के बीच होना चाहिए।',
    are_sure_simulation:
      'क्या आप सुनिश्चित हैं कि आप इस सिमुलेशन फ़ाइल को हटाना चाहते हैं?',
    required_simulation: 'स्कोर आवश्यक है',
    required_section_file: 'सेक्शन फ़ाइल आवश्यक है',
    simulation: 'सिमुलेशन',
    simulation_quiz_games: 'आपको गेम के लिए क्विज़ जोड़ना होगा',
    simulation_alert_des:
      'गेम केवल तभी जोड़े जा सकते हैं जब सभी प्रश्न सिंगल या मल्टीपल चॉइस हों।',
    alert_info: 'जानकारी',
    ai_number_quiz: 'क्विज़ की संख्या',
    ai_point: 'पॉइंट',
    ai_points: 'पॉइंट्स',
    val_required: 'आवश्यक',
    games: 'गेम्स',
    add_simulation: 'सिमुलेशन जोड़ें',
    text_tiewer: 'टेक्स्ट व्यूअर',
    back_to_account: 'खाते पर वापस जाएं',
    delete_account: 'खाता हटाएं',
    delete_account_title: 'खाता हटाएं ???',
    delete_account_subtitle: 'आप यहां अपना खाता हटा सकते हैं।',
    delete_account_cannot_undo:
      'आप अपने खाते को हटाने वाले हैं। यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    account_org_profile:
      'आपके द्वारा बनाए गए सभी कोर्स, आपका संगठन प्रोफ़ाइल और आपकी सभी सेटिंग्स भी चले जाएंगी।',
    deleting_account_database:
      'खाता हटाने से हमारे डेटाबेस से आपका सारा डेटा मिट जाएगा।',
    account_confirm_delete:
      'क्या आप सुनिश्चित हैं कि आप अपना खाता हटाना चाहते हैं?',
    action_cannot_be_undone: 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    account_delete_message_success: 'आपका खाता सफलतापूर्वक हटा दिया गया है।',
    message_edit: 'संपादित करें',
    message_delete: 'हटाएं',
    message_reply: 'उत्तर दें',
    attached_file: 'संलग्न फ़ाइल',
    attach_file: 'फ़ाइल संलग्न करें',
    attach_des: '25MB, अधिकतम फ़ाइल आकार',
    view: 'देखें',
    go_to_marketplace: 'मार्केटप्लेस पर जाएं',
    learning_center: 'शिक्षा केंद्र',
    knowledge_center: 'ज्ञान केंद्र',
    sharebot: 'शेयरबॉट',
    sharebot_help_message: 'मैं आपकी आज कैसे सहायता कर सकता हूँ?',
    my_organization: 'मेरा संगठन',
    world_knowledge: 'विश्व ज्ञान',
    welcome_to_sharelook: 'Sharelook में आपका स्वागत है!',
    sharelook_you_want_go: 'आज आप कहाँ जाना चाहेंगे?',
    shareLook_learning_management_system:
      'ShareLook लर्निंग मैनेजमेंट सिस्टम पर जाएं, जहां आप ShareLook में अपने संगठन के लिए लाइव इवेंट्स और कोर्स जैसे ट्रेनिंग संसाधन बना या एक्सेस कर सकते हैं।',
    shareLook_powerful_ai_system:
      'ShareLook की शक्तिशाली AI प्रणाली पर जाएं, जहां आप PDF फ़ाइलें अपलोड कर सकते हैं और सेकंडों में उपयोगी जानकारियाँ प्राप्त कर सकते हैं। अपने संगठन में अपलोड किए गए संसाधनों या हमारे सामान्य विश्व ज्ञान श्रेणी से त्वरित उत्तर प्राप्त करें।',
    edit_now: 'अब संपादित करें',
    sharelook_log_out:
      'आपने Sharelook से लॉग आउट कर दिया है। कृपया फिर से लॉग इन करें!',
    sorry_error: 'क्षमा करें! हमें एक त्रुटि का सामना करना पड़ा।',
    login: 'लॉगिन',
    refresh_page: 'पेज रिफ्रेश करें',
    just_a_moment: 'एक पल कृपया',
    enter_lname_fname:
      'कृपया जारी रखने के लिए अपना पहला और अंतिम नाम दर्ज करें।',
    procced_to_sharelook: 'Sharelook पर जाएं',
    option_one: 'विकल्प 1',
    option_two: 'विकल्प 2',
    selected_image: 'चयनित छवि:',
    add_text: 'टेक्स्ट जोड़ें',
    linkdin_is_required: 'LinkedIn आवश्यक है।',
    bio_is_required: 'बायो आवश्यक है।',
    save_user_information: 'उपयोगकर्ता जानकारी सहेजें',
    select_all: 'सभी चुनें',
    enable_ai: 'AI सक्षम करें',
    load_more: 'और लोड करें',
    channel_id: 'चैनल आईडी।',
    send: 'भेजें',
    v4: 'जानकारी',
    subscription: 'सदस्यता',
    reset_user_flag: 'उपयोगकर्ता फ्लैग रीसेट करें',
    delete_my_accont: 'मेरा खाता हटाएं',
    sharebot_sub_error:
      'सदस्यता प्राप्त करने में त्रुटि। कृपया पुनः प्रयास करें!',
    sharebot_no_sub: 'आपके पास वर्तमान में कोई सक्रिय सदस्यता नहीं है।',
    sharebot_dont_sub: 'आपके पास कोई पूर्व सदस्यता नहीं है।',
    sharebot_prev_sub: 'पिछली सदस्यताएं',
    sharebot_sub: 'ShareBot सदस्यता',
    sharebot_un_sub: 'ShareBot सदस्यता रद्द करें',
    sharebot_no_available: 'कोई विवरण उपलब्ध नहीं',
    sharebot_start_date: 'प्रारंभ तिथि:',
    sharebot_end_date: 'समाप्ति तिथि:',
    sharebot_sure: 'क्या आप सुनिश्चित हैं?',
    sharebot_do_you_want: 'क्या आप करना चाहते हैं',
    unsubscribe: 'अपनी सदस्यता रद्द करें',
    unsubscribe_what: 'अपनी सदस्यता रद्द करें?',
    subscribe: 'सदस्यता लें',
    subscribe_what: 'सदस्यता लें?',
    subscribe_now: 'अभी सदस्यता लें',
    confirm: 'पुष्टि करें',
    sharebot_intel_knowledge_center: 'ShareBot इंटेलिजेंट नॉलेज सेंटर',
    sharebot_welcome_paragraph:
      'ShareBot नॉलेज सेंटर में आपका स्वागत है, AI आधारित चैटबॉट जो पेशेवरों को जानकारी प्राप्त करने और सहयोग करने के तरीके को बदलने के लिए डिज़ाइन किया गया है।',
    expired: 'समय समाप्त',
    active: 'सक्रिय',
    Inactive: 'निष्क्रिय',
    yearly_subscription: 'वार्षिक सदस्यता',
    monthly_subscription: 'मासिक सदस्यता',
    no_sharebot_org: 'आपके पास ShareBot में कोई संगठन नहीं है',
    sharebot_start_free_trial: 'निःशुल्क परीक्षण प्रारंभ करें',
    sub_month: 'मासिक सदस्यता',
    sub_year: 'वार्षिक सदस्यता',
    question_per_month: 'डेटा संग्रहण (1TB) और जीवनभर के लिए 1000 प्रश्न',
    sharebot_para:
      'जैसे ही आप आगे बढ़ते हैं, आप संगठन को तुरंत हटाने की पुष्टि करते हैं। यह क्रिया ShareBot द्वारा दी गई सभी महत्वपूर्ण जानकारी को स्थायी रूप से हटा देगी।',
    cancelled_date: 'रद्द करने की तिथि:',
    live_straming_para:
      'यदि आप मासिक लाइव स्ट्रीमिंग सीमा को बदलना चाहते हैं, तो कृपया संपर्क करें',
    sharelook_agree: 'मैं Sharelook से सहमत हूं',
    terms_condition: 'नियम और शर्तें',
    and: 'और',
    privacy_policy: 'गोपनीयता नीति',
    save_for_later: 'बाद में सहेजें',
    ai: 'एआई',
    no_video_yet: 'अभी तक कोई वीडियो चयनित नहीं किया गया है!',
    are_you_sure_delete_video: 'क्या आप इस वीडियो को हटाना चाहते हैं?',
    video_des: 'विवरण',
    video_now: 'अब',
    video_playing: 'चल रहा है:',
    video_no: 'वीडियो संख्या',
    ai_generated_course: 'एआई जनित कोर्स',
    create_course_on_our_own: 'स्वयं कोर्स बनाएं',
    ai_Assisted_ourse_reation: 'एआई सहायक कोर्स निर्माण',
    pending: 'प्रतीक्षारत',
    published: 'प्रकाशित',
    intro_course: 'कोर्स में जोड़ना है?',
    clone_course: 'क्या आप इस कोर्स की प्रतिलिपि बनाना चाहते हैं?',
    browser_audio_not_support: 'आपका ब्राउज़र ऑडियो टैग का समर्थन नहीं करता।',
    audio_popup_content:
      'आप अपने टेक्स्ट के अनुसार विभिन्न आवाज़ शैलियों का उपयोग कर सकते हैं — Lorem Ipsum 16वीं सदी से प्रयोग में आने वाला एक डमी टेक्स्ट है।',
    close: 'बंद करें',
    podcast_rec: 'रिकॉर्डिंग',
    create_podcast: 'पॉडकास्ट बनाएं',
    add_admin: 'एडमिन जोड़ें',
    delete_all: 'सभी हटाएं',
    ai_podcast_audio: 'एआई जनित पॉडकास्ट ध्वनि',
    language: 'भाषा',
    podcast_download_content:
      '*एआई द्वारा निर्मित ऑडियो फ़ाइल को डाउनलोड करें और अपने संपादक में संपादित करें।',
    upload_audio: 'ऑडियो अपलोड करें',
    browser_do_not_support_audio:
      'आपका ब्राउज़र ऑडियो टैग का समर्थन नहीं करता।',
    upload_cover: 'कवर इमेज अपलोड करें',
    upload_ai_creator: 'एआई निर्माता जोड़ें',
    required_cover_image: 'कवर इमेज आवश्यक है!',
    room_required_name: 'पॉडकास्ट नाम आवश्यक है!',
    add_guest_list: 'कृपया अतिथि सूची जोड़ें!',
    podcast_add_participants: 'प्रतिभागी जोड़ें',
    topic_required: 'कम से कम एक विषय आवश्यक है',
    podcast_description: 'विवरण',
    podcast_date: 'तिथि',
    date: 'तिथि',
    podcast_time: 'समय',
    podcast_to: 'से',
    podcast_all_day: 'पूरा दिन',
    podcast_start_date_time: 'प्रारंभ तिथि और समय आवश्यक है!',
    podcast_id: 'आईडी',
    selected_user: 'चयनित उपयोगकर्ताओं को आमंत्रित करें',
    see_more: 'और देखें',
    see_less: 'कम देखें',
    no_review_yet: 'अभी तक कोई समीक्षा नहीं — पहले बनें!',
    request_to_speak: 'क्या उपयोगकर्ता के बोलने के अनुरोध को स्वीकार करना है?',
    kick_user: 'उपयोगकर्ता को हटाएं?',
    accept_request: 'अनुरोध स्वीकार करें',
    kick: 'हटाएं',
    started: 'शुरू हुआ',
    end: 'समाप्त',
    join_now: 'अब जुड़ें',
    podcast_end: 'पॉडकास्ट समाप्त हुआ',
    connecting: 'कनेक्ट हो रहा है...',
    knowledge_center_know_today: 'आज आप क्या जानना चाहते हैं?',
    knowledge_center_question: 'कृपया पहले एक प्रश्न दर्ज करें',
    knowledge_center_error: 'माफ़ कीजिए! कुछ गलत हो गया।',
    knowledge_center_tooltrip:
      'अपने संगठन के लर्निंग संसाधनों से त्वरित उत्तर प्राप्त करें, PDF रेफरेंस के साथ जिसमें आप देख और डाउनलोड कर सकते हैं।',
    my_organization: 'मेरा संगठन',
    world_knowledge: 'विश्व ज्ञान',
    open_file: 'फ़ाइल खोलें',
    reference: 'संदर्भ',
    are_you_cancel: 'क्या आप रद्द करना चाहते हैं?',
    are_you_remove_media: 'क्या आप मीडिया को हटाना चाहते हैं?',
    terms_agree: 'मैं इन शर्तों से सहमत हूं',
    ready: 'तैयार',
    send_email: 'ईमेल भेजें',
    active_users: 'सक्रिय उपयोगकर्ता',
    sign_up_user: 'पंजीकृत उपयोगकर्ता',
    non_sign_up_user: 'गैर-पंजीकृत उपयोगकर्ता',
    organisation: 'संगठन',
    usage_report: 'उपयोग रिपोर्ट',
    check_email: 'अपना ईमेल जांचें',
    delete_schedule: 'अनुसूची हटाएं',
    are_you_sure_delete_schedule: 'क्या आप इस शेड्यूल को हटाना चाहते हैं?',
    add_task: 'कृपया कार्य दर्ज करें!',
    coaching_available: 'कोचिंग उपलब्ध है',
    message_booking_coaching:
      'यह समय स्लॉट उपयोगकर्ता द्वारा कोचिंग के लिए बुक किया गया है।',
    task_day: 'कार्य दिवस',
    created_task_day: 'आपने इस दिन के लिए एक कार्य बनाया है।',
    event_day: 'इवेंट दिवस',
    has_booked_coaching: 'आपने पहले ही इस दिन के लिए कोचिंग बुक कर ली है।',
    active_day: 'सक्रिय दिन',
    selectable_time_slots:
      'दाईं ओर के सक्रिय दिनों के लिए चयन करने योग्य विकल्प उपलब्ध हैं।',
    compare_last_month: 'पिछले महीने की तुलना करें',
    uploading_file: 'फ़ाइल अपलोड हो रही है',
    attach_file_course: 'कोर्स से जोड़ा गया',
    fetch_request: 'आपका अनुरोध प्राप्त किया जा रहा है',
    finilize_upload: 'अपलोड अंतिम चरण में है',
    scorm_scanned: 'कृपया प्रतीक्षा करें... आपका SCORM फ़ाइल स्कैन हो रहा है।',
    scan_status: 'स्कैन स्थिति:',
    scan_completed: 'स्कैन पूरा हुआ। फ़ाइल है',
    scan_progress: 'स्कैन चल रहा है...',
    check_scorm: 'आपकी SCORM फ़ाइल की जांच कर रहे हैं...',
    file_check_success: 'फ़ाइल जांच सफल रही',
    file_check_progress: 'फ़ाइल जांच प्रगति पर है',
    scorm_not_upload:
      'अपलोड की गई फ़ाइल SCORM 1.2 के अनुरूप नहीं है, कृपया दोबारा प्रयास करें।',
    select_question: 'विकल्प प्रश्न (एक सही उत्तर)',
    select_answer: 'कृपया उत्तर चुनें!',
    check_option_one: 'कम से कम एक विकल्प दर्ज करें!',
    check_option_two: 'दो विकल्प दर्ज करें!',
    check_option_three: 'तीन विकल्प दर्ज करें!',
    check_option_four: 'चार विकल्प दर्ज करें!',
    question_image: 'प्रश्न छवि',
    select_question_image: 'कृपया प्रश्न के लिए छवि चुनें!',
    ans_image: 'उत्तर छवि',
    upload_image_question: 'प्रश्न की छवि अपलोड करें',
    select_image_answer: 'उत्तर की छवि चुनें!',
    save_question: 'प्रश्न सहेजें',
    do_you_leave: 'क्या आप छोड़ना चाहते हैं?',
    loose_all_progress: 'आपकी सभी प्रगति मिट जाएगी।',
    welcome: 'स्वागत है',
    team_knowledge_quest: 'टीम ज्ञान मिशन',
    your_score: 'आपका स्कोर',
    start_playing: 'खेलना प्रारंभ करें',
    share_sphere_complete: 'ShareSphere पूर्ण हुआ',
    final_score: 'अंतिम स्कोर',
    play_next: 'अगला खेलें',
    you_donot_access_event: 'आपको इस इवेंट की अनुमति नहीं है',
    ai_content_generated: 'इस विषय के लिए एआई जनित सामग्री',
    ai_popup_confirm_content: 'सामग्री निर्माण की पुष्टि करें',
    limit_transcribe_text:
      'ट्रांसक्राइब मिनट बचे हैं: <0>{{ transcribe_limit }}</0> मिनट <1/><2/> <3>. अपने ट्रांसक्राइब लिमिट को बदलने के लिए कृपया संपर्क करें </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'आपको इस इवेंट का एक्सेस नहीं है।',
    ai_course_title_training: 'लीडरशिप प्रशिक्षण कोर्स',
    ai_course_object: 'डिजिटल में नेतृत्व को नेविगेट करना',
    create_ai_video: 'एआई वीडियो बनाएं',
    generate: 'जनरेट करें',
    video_generate_process:
      'वीडियो जनरेशन प्रक्रिया में कुछ समय लग सकता है। पूरा होने पर आपको ईमेल मिलेगा।',
    stripe_account_connect:
      'आपका Stripe अकाउंट निष्क्रिय है। कृपया जारी रखने के लिए इसे कनेक्ट या सक्रिय करें।',
    ai_creator: 'एआई क्रिएटर',
    check_video_status: 'वीडियो जनरेशन की स्थिति जांच रहे हैं...',
    video_on_queue: 'वीडियो जनरेशन कतार में है।',
    video_fail_generation:
      'क्षमा करें, वीडियो जनरेशन विफल हो गया। कृपया दूसरा प्रयास करें।',
    video_currently_generated: 'यह वीडियो वर्तमान में जनरेट हो रहा है।',
    checking_status: 'स्थिति जांच रहे हैं',
    check_status: 'स्थिति जांचें',
    browser_does_not_support_audio:
      'आपका ब्राउज़र ऑडियो टैग का समर्थन नहीं करता है',
    existing_edit_scenario:
      'क्या आप मौजूदा स्थिति को संपादित करना चाहते हैं या नया स्थिति बनाना चाहते हैं? यदि आप नया बनाएंगे तो पुराना स्थिति खो जाएगा।',
    generate_scenario: 'स्थिति जनरेट करें',
    layout: 'लेआउट',
    confirm_change: 'परिवर्तन की पुष्टि करें',
    generated_ai_creation_message:
      'कृपया ध्यान दें कि केवल AI निर्माण से जनरेट किए गए टेक्स्ट तत्व ही रखे जाएंगे। अन्य सभी तत्व पृष्ठ से हटा दिए जाएंगे।',
    generate_story: 'कहानी जनरेट करें',
    save_original_content: 'मूल सामग्री सहेजें:',
    story_added_specified_position:
      'पाठ में कहानी की स्थिति। कहानी निर्दिष्ट स्थिति पर एक ब्लॉक के रूप में जोड़ी जाएगी।',
    position_of_story: 'कहानी की स्थिति',
    start_the_lesson: 'पाठ की शुरुआत',
    end_the_lesson: 'पाठ का अंत',
    add_story_pages: 'पृष्ठों में कहानी जोड़ें',
    browser_does_not_support:
      'आपका ब्राउज़र ऑडियो एलिमेंट का समर्थन नहीं करता है।',
    no_video_available: 'कोई वीडियो उपलब्ध नहीं है।',
    no_podcast_available: 'कोई पॉडकास्ट उपलब्ध नहीं है।',
    no_item_baskets: 'टोकरी में कोई आइटम नहीं हैं।',
    ai_course_object: 'डिजिटल में नेतृत्व को नेविगेट करना'
  },
  v2: {
    n_data: 'कोई डेटा नहीं',
    change: 'बदलें',
    remove: 'हटाएं',
    auto_background: 'स्वचालित पृष्ठभूमि',
    create_new_course_org: 'अपने संगठन के लिए नया कोर्स बनाएं।',
    create_new_course_marketplace: 'मार्केटप्लेस के लिए नया कोर्स बनाएं।',
    create_new_course_both:
      'अपने संगठन और मार्केटप्लेस दोनों के लिए नया कोर्स बनाएं।',
    ok: 'ठीक है',
    page_bg: 'पृष्ठ पृष्ठभूमि',
    lesson_cover: 'पाठ कवर चित्र',
    create_skill_journey: 'स्किल जर्नी बनाएं',
    Metamaze: 'Metamaze',
    events: 'इवेंट्स',
    scroms: 'SCORMs',
    min_score_pass: 'पास करने के लिए न्यूनतम स्कोर',
    no_scorms_available: 'कोई SCORM उपलब्ध नहीं है।',
    no_events_available: 'कोई इवेंट उपलब्ध नहीं हैं।',
    no_courses_available: 'कोई कोर्स उपलब्ध नहीं हैं।',
    no_courses_baskets: 'टोकरी में कोई कोर्स नहीं है।',
    no_mazes_baskets: 'टोकरी में कोई मेज़ नहीं है।',
    no_scroms_baskets: 'टोकरी में कोई SCORM नहीं है।',
    no_events_baskets: 'टोकरी में कोई इवेंट नहीं है।',
    sorry: 'क्षमा करें!',
    option_1: 'विकल्प 1',
    option_2: 'विकल्प 2',
    enter_number_words: 'अधिकतम शब्दों की संख्या दर्ज करें।',
    summarize: 'सारांश',
    answer: 'उत्तर',
    hold_tight_one_minute:
      'धैर्य रखें! हम अभी तैयारी कर रहे हैं। इसमें एक मिनट तक लग सकता है।',
    enter_question: 'अपना प्रश्न दर्ज करें।',
    enter_relevant_documents: 'संबंधित दस्तावेजों की संख्या दर्ज करें।',
    please_input_relevant_documents:
      'कृपया संबंधित दस्तावेजों की संख्या दर्ज करें!',
    please_wait_loading_results: 'कृपया परिणाम लोड होने की प्रतीक्षा करें...',
    proceed_to_add_voice: 'वॉइस जोड़ने के लिए आगे बढ़ें',
    results: 'परिणाम',
    no_result_found_try_asking_questions:
      'कोई परिणाम नहीं मिला। कृपया अधिक प्रश्न पूछें।',
    eg: 'उदा.,',
    what_make_sales_manager: 'मुझे सेल्स मैनेजर क्या बना सकता है?',
    please_select_lang: 'कृपया कोई भाषा चुनें!',
    search: 'खोजें',
    please_copy_desired_content:
      'कृपया बाएँ बॉक्स से इच्छित सामग्री को दाएँ बॉक्स में कॉपी करें।',
    rating_req: 'रेटिंग आवश्यक है।',
    review_req: 'समीक्षा आवश्यक है।',
    rating_review_req: 'दोनों रेटिंग और समीक्षा प्रदान करनी होगी।',
    how_rate_this: 'आप इसे कैसे रेट करेंगे?',
    amazing_above_expectations: 'शानदार! उम्मीद से बेहतर!',
    certificates: 'प्रमाणपत्र',
    you_no_certificates: 'आपके पास इस समय कोई प्रमाणपत्र उपलब्ध नहीं है।',
    please_add_review: 'कृपया रेटिंग के साथ समीक्षा प्रदान करें, धन्यवाद!',
    post: 'पोस्ट करें',
    rate: 'रेट करें',
    avg_rating: 'औसत रेटिंग',
    no_review_found: 'कोई समीक्षा नहीं मिली',
    are_sure_to_disale_zoom_integration:
      'क्या आप ज़ूम इंटीग्रेशन को अक्षम करना चाहते हैं?',
    badges: 'बैज',
    you_no_badge_available: 'आपके पास इस समय कोई बैज उपलब्ध नहीं है।',
    download_certificate: 'प्रमाणपत्र डाउनलोड करें',
    loading: 'लोड हो रहा है...',
    no_file_attached: 'कोई फाइल संलग्न नहीं',
    you_do_not_have_any_notes: 'आपके पास कोई नोट्स नहीं हैं।',
    question: 'प्रश्न',
    score: 'स्कोर',
    alert_score_message: 'व्यक्ति(ओं) ने अपना स्कोर सबमिट कर दिया है।',
    alert_question_message: 'अब तक कोई प्रश्न नहीं जोड़ा गया है।',
    button_submit: 'सबमिट करें',
    button_allScores: 'सभी स्कोर सबमिट हो चुके हैं।',
    record_wait: 'रिकॉर्डिंग शुरू हो रही है। कृपया प्रतीक्षा करें...',
    buttonSubmit_warning: 'सबमिट करने से पहले कृपया सभी स्कोर दर्ज करें।',
    upload_ar_assets: 'AR एसेट अपलोड करें',
    edit_ar_assets: 'AR एसेट संपादित करें',
    edit_maze_assets: 'MetaMaze एसेट संपादित करें',
    upload_assets: 'एसेट अपलोड करें',
    upload_maze_assets: 'MetaMaze एसेट अपलोड करें',
    trigger_title: 'ट्रिगर शीर्षक',
    model_title: 'मॉडल शीर्षक',
    trigger_description: 'ट्रिगर विवरण',
    model_description: 'मॉडल विवरण',
    please_type_target_description: 'कृपया लक्ष्य विवरण टाइप करें।',
    please_type_model_description: 'कृपया मॉडल विवरण टाइप करें।',
    trigger_image: 'ट्रिगर इमेज*',
    model_image: 'मॉडल इमेज*',
    upload_trigger_image: 'ट्रिगर इमेज अपलोड करें',
    upload_model_image: 'मॉडल इमेज अपलोड करें',
    drag_n_drop: 'खींचें और छोड़ें',
    file_size_should_not_exceed:
      '(इमेज फ़ाइल का आकार 512KB से अधिक नहीं होना चाहिए)',
    zip_size_should_not_exceed:
      '(ZIP फ़ाइल का आकार 60MB से अधिक नहीं होना चाहिए)',
    ar_content: 'AR कंटेंट*',
    model_content: '3D मॉडल*',
    upload_3d_zip: 'ZIP / वीडियो अपलोड करें',
    upload_3d_maze_zip: 'ZIP अपलोड करें',
    audio_content: 'ऑडियो कंटेंट',
    _mp3: '(.mp3)',
    content_attached: 'ZIP जोड़ा गया है।',
    video_attached: 'वीडियो जोड़ा गया है।',
    audio_attached: 'ऑडियो जोड़ा गया है।',
    enter_trigger_image_title: 'ट्रिगर इमेज के लिए शीर्षक दर्ज करें।',
    enter_model_title: 'MetaMaze मॉडल के लिए शीर्षक दर्ज करें।',
    ar_preview_image: 'AR पूर्वावलोकन छवि',
    upload_preview_image: 'पूर्वावलोकन छवि अपलोड करें',
    upload_audio: 'ऑडियो अपलोड करें',
    creating___: 'बना रहे हैं...',
    updating___: 'अपडेट कर रहे हैं...',
    create: 'बनाएं',
    update: 'अपडेट करें',
    ar_assets: '3D इमेज',
    _3d_files_mp4: '(ZIP .obj, .fbx या वीडियो .mp4)',
    _3d_files_mp4_ar: '(ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(ZIP .obj, .fbx)',
    _jpg_files: 'केवल .jpg फ़ाइलें समर्थित हैं',
    persons_have_submitted_their_scores:
      'उपयोगकर्ताओं ने अपने स्कोर सबमिट किए हैं।',
    no_questions_added_till_now: 'अभी तक कोई प्रश्न नहीं जोड़े गए हैं।',
    submit: 'सबमिट करें',
    all_scores_submitted: 'सभी स्कोर सबमिट कर दिए गए हैं।',
    recording_is_starting: 'रिकॉर्डिंग शुरू हो रही है। कृपया प्रतीक्षा करें...',
    please_input_scores_before_submitting:
      'कृपया सबमिट करने से पहले सभी स्कोर भरें।',
    end_for_all: 'सभी के लिए समाप्त करें',
    full_screen: 'फुल स्क्रीन',
    breakout_room: 'ब्रेकआउट रूम',
    send_invitations: 'निमंत्रण भेजें',
    add_participants: 'प्रतिभागी जोड़ें',
    create_breakout_room: 'ब्रेकआउट रूम बनाएं',
    connecting: 'कनेक्ट कर रहा है...',
    currently_broadcaster_unavailable: 'वर्तमान में प्रसारणकर्ता अनुपलब्ध है।',
    how_many_breakout_room_to_create: 'कितने ब्रेकआउट रूम बनाने हैं?',
    create_upto_three_breakout_rooms: '*आप अधिकतम 3 ब्रेकआउट रूम बना सकते हैं',
    allow: 'अनुमति दें',
    additional: 'अतिरिक्त',
    attachment: 'संलग्नक',
    no_description_available: 'कोई विवरण उपलब्ध नहीं है।',
    people: 'लोग',
    waiting: 'प्रतीक्षा कर रहे हैं',
    hand_raising_users: 'हाथ उठाने वाले उपयोगकर्ता',
    invite: 'आमंत्रित करें',
    create_room: 'रूम बनाएं',
    create_live_event: 'लाइव इवेंट बनाएं',
    support_upto_fivethousand_participants: '5000 प्रतिभागियों तक समर्थित',
    support_upto_ten_participants: '10 वीडियो प्रतिभागियों तक समर्थित',
    support_upto_twohundred_participants: '200 प्रतिभागियों तक समर्थित',
    supprt_upto_five_participants: '5 वीडियो प्रतिभागियों तक समर्थित',
    support_upto_twentyfive_participants: '25 वीडियो प्रतिभागियों तक समर्थित',
    two_live_video_participants: '2 वीडियो प्रतिभागी (होस्ट और अतिथि)',
    you_can_have_upto_five_examinees: 'आप अधिकतम 5 परीक्षार्थी जोड़ सकते हैं।',
    you_can_have_upto_twentyfive_participants:
      'आप अधिकतम 25 प्रतिभागी जोड़ सकते हैं।',
    you_can_have_upto_five_participants: 'आप अधिकतम 5 प्रतिभागी जोड़ सकते हैं।',
    you_can_have_upto_ten_participants: 'आप अधिकतम 10 प्रतिभागी जोड़ सकते हैं।',
    select_hosts_email: 'होस्ट का ईमेल चुनें',
    send_invite_email: 'निमंत्रण ईमेल भेजें',
    do_not_send_invite_email: 'ईमेल न भेजें',
    error: 'त्रुटि',
    max_twentyfive_users_allowed: 'अधिकतम 25 उपयोगकर्ता चुन सकते हैं',
    max_five_users_allowed: 'अधिकतम 5 उपयोगकर्ता चुन सकते हैं',
    max_ten_users_allowed: 'अधिकतम 10 उपयोगकर्ता चुन सकते हैं',
    no_user_found: 'कोई उपयोगकर्ता नहीं मिला',
    transcribe_to: 'लिप्यंतरण करें',
    integrate_zoom_to_start_meeting:
      'मीटिंग शुरू करने के लिए Zoom एकीकृत करें।',
    zoom_is_not_integrated: 'Zoom एकीकृत नहीं है।',
    delete_poll: 'पोल हटाएं',
    add_poll: 'पोल जोड़ें',
    live_now: 'लाइव!',
    average_rating: 'औसत रेटिंग',
    review: 'समीक्षा',
    time_spent: 'खर्च किया गया समय',
    total: 'कुल',
    mins: 'मिनट',
    no_data: 'कोई डेटा उपलब्ध नहीं है।',
    total_score: 'कुल स्कोर',
    pass_score: 'उत्तीर्ण स्कोर',
    point: 'अंक',
    wrong: 'गलत',
    response: 'प्रतिक्रिया',
    submitted: 'सबमिट किया गया',
    average: 'औसत',
    total_play: 'कुल बार खेला गया',
    view_graph: 'ग्राफ देखें',
    time_spent_mins: 'समय (मिनट में)',
    play: 'प्ले करें',
    ideal_path: 'आदर्श पथ',
    user_incorrect_path: 'उपयोगकर्ता का गलत पथ',
    ideal_path_taken: 'चुना गया आदर्श पथ',
    scenario: 'परिदृश्य',
    option: 'विकल्प',
    spend: 'खर्च',
    average_spending_time: 'औसत खर्च समय',
    activity_overview: 'गतिविधि अवलोकन',
    live_event: 'लाइव इवेंट',
    live_assessment: 'लाइव मूल्यांकन',
    report_download: 'रिपोर्ट डाउनलोड करें',
    all_workshops: 'सभी कार्यशालाएं',
    overview_average_activity: 'औसत गतिविधि अवलोकन',
    overview_workshop_graph: 'वर्कशॉप ग्राफ',
    mazes: 'भ्रमण',
    correct_feedback: 'सही प्रतिक्रिया',
    incorrect_feedback: 'गलत प्रतिक्रिया',
    checkin_checkout: 'चेक-इन चेक-आउट',
    minutes: 'मिनट',
    incorrect_path: 'गलत पथ',
    answer_not_available: 'उत्तर उपलब्ध नहीं है',
    views: 'दृश्य',
    item: 'आइटम',
    questions: 'प्रश्न',
    total_points: 'कुल अंक',
    total_attempts: 'कुल प्रयास',
    created_date: 'बनाने की तारीख',
    host_name: 'होस्ट नाम',
    host_section: 'होस्ट अनुभाग',
    choose_products: 'उत्पाद चुनें',
    add_to_basket: 'बास्केट में जोड़ें',
    basket: 'बास्केट',
    times: 'बार',
    scorms: 'SCORMs',
    skill_journey_overview: 'कौशल यात्रा अवलोकन',
    how_to_use: 'कैसे उपयोग करें',
    live_broadcast_description:
      'हमने एक आसान कोर्स-बिल्डिंग टूल में लाइव ब्रॉडकास्ट को एकीकृत किया है।',
    live_broadcast_subdescription:
      'ShareLook के लाइव ब्रॉडकास्टिंग सिस्टम के साथ, आप सहभागिता, स्वचालन और ज्ञान साझा बढ़ा सकते हैं।',
    disclaimer: `मैं यह प्रमाणित करता/करती हूँ कि मेरी कौशल यात्रा:
- किसी तीसरे पक्ष के अधिकारों का उल्लंघन नहीं करती
- अवैध सामग्री नहीं है (मानहानि, नग्नता, हिंसा, भेदभाव)
- व्यक्तिगत हमले नहीं करती
- किसी और की पहचान का अनुकरण नहीं करती
- बिना अनुमति के निजी जानकारी की रिकॉर्डिंग नहीं करती
- विज्ञापन या स्पैम नहीं है`,
    price: 'मूल्य',
    video_link: 'वीडियो लिंक',
    category: 'श्रेणी',
    objectives: 'उद्देश्य',
    marketplace_description: 'मार्केटप्लेस विवरण',
    live_discussion: 'लाइव चर्चा',
    poll: 'पोल',
    hide_grid: 'ग्रिड छुपाएं',
    show_grid: 'ग्रिड दिखाएं',
    stop_screen_share: 'स्क्रीन साझा करना बंद करें',
    screen_share: 'स्क्रीन साझा करें',
    mute: 'म्यूट करें',
    unmute: 'अनम्यूट करें',
    raise_hand: 'हाथ उठाएं',
    waiting__: 'प्रतीक्षा कर रहे हैं...',
    audio_active: 'ऑडियो सक्रिय'
  },

  general: {
    save: 'सहेजें',
    autosaved: 'स्वत: सहेजा गया',
    back_to: 'वापस',
    by: 'द्वारा',
    chat: 'बातचीत',
    completed: `पूरा: 'हो गया'`,
    canceled: 'रद्द किया गया',
    component: 'कॉम्पोनेन्ट/घटक',
    confirm: 'पुष्टि करें',
    course: 'कोर्स',
    skill: 'कौशल यात्रा',
    maze: 'मेटा भूलभुलैया',
    channel: 'चैनल',
    podcast: 'पॉडकास्ट',

    date: 'तारीख',
    details: 'विवरण',
    empty: `कोई आकड़ा उपलब्ध नहीं है`,
    enrolled: 'एनरॉल किया गया',
    free: 'नि: शुल्क',
    graph: 'ग्राफ़',
    loading: 'लोड हो रहा है...',
    lesson: 'पाठ',
    lessons: 'पाठ',
    live_assessment: `लाइव असेसमेंट`,
    live_event: 'लाइव इवेंट',
    no: 'नहीं',
    of: 'का',
    or: 'या',
    organization: 'संगठन',
    page: 'पेज',
    pages: 'पेज',
    personal: 'निजी',
    poll: 'पोल',
    rating: 'रेटिंग',
    reset: 'रीसेट',
    signin: 'साइन इन करें',
    signup: 'साइन अप करें',
    soon: 'जल्द ही',
    type: 'प्रकार',
    uploading: 'अपलोड हो रहा है ...',
    yes: 'हाँ',
    something_went_wrong: 'कुछ गलत हो गया!',
    view_all: 'सभी देखें',
    upload_successful: 'सफलतापूर्वक अपलोड हो गया है',
    upload_successful_message:
      'आपके एक्सेल दस्तावेज़ सफलतापूर्वक अपलोड हो गए हैं और अभी प्रोसेसिंग चल रही हैं। इसमें कुछ समय लग सकता है।',
    check_email_upload_successful:
      'अपलोड किए गए उपयोगकर्ता सूची की <1> रिपोर्ट </ 1> को देखने के लिए कृपया अपना ईमेल </ 0> चेक करें।',
    is_private: 'निजी'
  },

  account: {
    title: 'खाता',
    subtitle: 'अपनी सेटिंग्स और खाता जानकारी को मैनेज करें।',
    saved: 'खाता सफलतापूर्वक बदला गया'
  },

  assessments: {
    title: 'मूल्यांकन',
    subtitle: 'एक मूल्यांकन बनाएँ',
    finished: 'मूल्यांकन समाप्त हो गया है',
    countdown: 'लाइव मूल्यांकन का प्रसारण होगा',
    create: 'मूल्यांकन बनाएँ',
    list_title: 'आपका मूल्यांकन',
    delete_warning: 'क्या आप सच में इस आइटम को हटाना चाहते हैं?',
    details_title: 'मूल्यांकन संबंधित जानकारी जोड़े',
    details_subtitle:
      'अपने मूल्यांकन को नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा ।',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि मेरे द्वारा रिकॉर्ड किये गए असेसमेंट नहीं करते है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम"'`,
    assessment_details: 'मूल्यांकन का विवरण',

    assessment_settings: 'मूल्यांकन से संबंधित सेटिंग'
  },

  buildersettings: {
    title: 'सेटिंग को सार्वजनिक करें',
    subtitle:
      'आपके ईवेंट को कौन देख सकता और इंटरेक्ट कर सकता है इसकी सेटिंग करे'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'जोड़ें',
    add_page: 'पृष्ठ जोड़ें',
    add_lesson: 'पाठ जोड़े',
    add_answer: 'नया उत्तर जोड़ें',
    add_group: 'समूह जोड़ें',
    add_organization: 'संगठन जोड़ें',
    add_question: 'प्रश्न जोड़ें',
    add_quiz: 'प्रश्नोत्तरी जोड़ें',
    add_users: 'उपयोगकर्ता को जोड़ें',
    back: 'वापस जाये',
    back_to_course: 'कोर्स ओवरव्यू पर वापस जाये',
    back_to_lesson: 'पाठ ओवरव्यू पर वापस जाये',
    back_to_media: 'मीडिया लाइब्रेरी पर वापस जाये',
    back_to_details: 'विवरण पर वापस जाये',
    cancel: 'रद्द करे',
    clear: 'स्पष्ट',
    close: 'बंद करे',
    clone: 'क्लोन',
    close_lesson: 'पाठ बंद करे',
    clone_course: 'क्लोन कोर्स',
    confirm: 'पुष्टि करें',
    create: 'बनाये',
    download: 'डाउनलोड करे',
    download_mass_user_tamplate: 'टेम्पलेट डाउनलोड करें',
    add_mass_users: 'बड़े पैमाने पर उपयोगकर्ताओं को जोड़ें',
    upload_excel_list: 'एक्सेल की सूची अपलोड करें',
    delete: 'मीडिया हटाएं',
    edit: 'बदलाव करे',
    edit_course: 'कोर्स में बदलाव करे',
    enroll: 'एनरॉल करे',
    finish: 'Finish',
    upload_image: 'तस्वीर अपलोड करे',
    upload_image_video: 'तस्वीर या वीडियो अपलोड करे',
    select_media_library: 'मीडिया लाइब्रेरी का चयन करें',
    make_public: 'सार्वजनिक करें',
    make_private: 'निजी रखे',
    make_org: 'संगठन बनाये',
    media: 'मीडिया लाइब्रेरी',
    my_theme: 'मेरी थीम',
    next: 'आगे',
    next_lesson: 'अगला पाठ',
    next_step: 'अगला कदम',
    previous_step: 'पिछला कदम',
    publish: 'सार्वजनिक करे',
    publish_assessment: 'असेसमेंट सार्वजनिक करे',
    publish_course: 'अपना कोर्स सार्वजनिक करें',
    publish_event: 'अपना इवेंट सार्वजनिक करें',
    reset: 'रिसेट करें',
    reset_elements: 'एलिमेंट्स रीसेट करें',
    save: 'सहेजें',
    creating: 'बनाया जा रहा है...',
    updating: 'अपडेट हो रहा है...',
    saved: 'सहेजा गया...',
    save_for_later: 'भविष्य के लिए सहेजे',
    save_settings: 'सेटिंग सहेजे',
    select_files: 'फ़ाइलें चुनें',
    select_theme: 'थीम चुने',
    start_lesson: 'पाठ शुरू करे',
    update: 'अपडेट करें',
    upload: 'अपलोड करे',
    upload_audio: 'ऑडियो अपलोड करें',
    upload_photo: 'प्रोफाइल फोटो अपलोड करें',
    upload_video: 'विडियो अपलोड करें',
    enrolled: 'एनरॉल किया गया',
    unenroll: 'अन-एनरॉल किया गया',
    from_library: 'मिडिया लाइब्रेरी',
    remove: 'हटाये',
    removed: 'हटाया गया',
    start_broadcast: 'प्रसारण शुरू करे',
    end_broadcast: 'प्रसारण रोके',
    camera: 'कैमरा',
    screen: 'स्क्रीन',
    screen_with_camera: 'कैमरा के साथ स्क्रीन',
    insert: 'इन्सर्ट करे',

    inserting: 'इन्सर्ट कर रहे है'
  },

  card: {
    quick_add: 'जल्दी से जोड़े',
    add: 'जोड़े',
    clone: 'क्लोन',
    completed: 'पाठ खत्म हो गए है'
  },

  course: {
    upcoming_course: 'आगामी पाठ्यक्रम',
    unPublishEvent: 'अप्रकाशित इवेंट',
    unPublishAssessment: 'अप्रकाशित असेसमेंट',
    pastCourse: 'प्रशिक्षण पाठ्यक्रम',
    upcoming: 'आगामी लाइव इवेंट',
    pastEvent: 'पिछले लाइव इवेंट',
    pastAssessment: 'पिछले लाइव इवेंट',
    upcomingAssessment: 'आगामी लाइव असेसमेंट',
    created: 'तिथि बनाई गयी:',
    assignees: 'असाइनी',
    organisations: `{{संगठन}} संगठन, <2> {{उपयोगकर्ता}} उपयोगकर्ता </ 2>`,
    event_date: 'लाइव इवेंट की तिथि <1> {{तारीख}} </ 1>',
    delete_warning: 'क्या आप सच मे इसे हटाना चाहते हैं',
    clonning_no_lesson:
      'कृपया इस पाठ्यक्रम का क्लोन बनाने के लिए कम से कम एक पाठ जोड़ें।',
    clone_warning: 'क्या आप सच में इसे क्लोन करना चाहते हैं',
    clone_success: 'क्लोनिंग प्रक्रिया चालू है',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि मेरा कोर्स नहीं करता है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम”`
  },
  coursecreate: {
    dropzone_text: 'मीडिया डालें',
    sidebar_text: 'अपने <3 /> सभी पाठो के लिए एक थीम <1 /> चुनें',
    delete_warning: 'क्या आप सच में इस पाठ को हटाना चाहते हैं?'
  },

  coursepage: {
    Quizview_loading: 'उत्तरों की जाँच की जा रही है। कृपया प्रतीक्षा करें...',
    Quizview_answer: 'आपका उत्तर'
  },

  coursequiz: {
    title: 'हर पाठ के साथ क्विज'
  },

  dashboard: {
    tooltip_title: 'इस वीडियो को फिर से न दिखाएं',
    page_title: 'आपके पाठ्यक्रम का आँकड़ा',
    page_subtitle: 'आपके द्वारा बनाए गए पाठ्यक्रमों की स्थिति',
    profile_add_info:
      'अपना प्रोफ़ाइल को पूरा करने के लिए <1> {{अनकंप्लीटेक्स्ट}} </ 1> जोड़ें।',
    profile_build:
      'अपनी प्रोफ़ाइल बनाएं <1> यहां </ 1>, हमें अपनी रुचियों और कौशल के बारे में बताएं।',
    profile_title: 'प्रोफाइल स्ट्रेंथ',
    more_details: 'अधिक जानकारी'
  },

  errors: {
    answer: 'कृपया उत्तर दर्ज करे',
    answer_correct: 'सही उत्तर चुने',
    code: 'कृपया अपना कोड दर्ज करे',
    criterion: 'कृपया मापदंड तय करे',
    duration: 'अवधि भरना आवश्यक है',
    element: 'कृपया एलिमेंट दर्ज करे',
    email: 'कृपया अपना ईमेल दर्ज करेl',
    email_invalid: 'यह ईमेल मान्य नहीं हैl',
    feedback_correct: 'कृपया सही फ़ीडबैक चुने',
    feedback_incorrect: 'कृपया गलत फ़ीडबैक चुने',
    host: 'कृपया इवेंट होस्ट दर्ज करे',
    host_assessment: 'कृपया मूल्यांकन के मेजबान को दर्ज करे',
    image: 'कृपया एक चित्र अपलोड करें',
    location: 'कृपया अपना स्थान दर्ज करें',
    live_location: 'कृपया प्रसारण का एक स्थान चुनें',
    limit: 'कृपया लाइव-स्ट्रीमिंग की मिनट दर्ज करे',
    min_3char: 'न्यूनतम 3 वर्ण',
    number: 'कृपया पॉजिटिव संख्या ही दर्ज करें।',
    host_email_require: `होस्ट का ईमेल दर्ज करना आवश्यक हैं।`,
    attendee_email_require: `अटेंडी का ईमेल दर्ज करना आवश्यक हैं।`,
    name: 'कृपया अपना नाम दर्ज करें',
    not_found_course: 'कोर्स नहीं मिला',
    not_found_event: 'ईवेंट नहीं मिला',
    not_found_assessment: 'आकलन नहीं मिला',
    password: 'कृपया अपना पासवर्ड दर्ज करें',
    password_digit: 'कम से कम एक अंक',
    password_short: 'पासवर्ड बहुत छोटा है, न्यूनतम 10 वर्ण दर्ज करे',
    password_special: 'कम से कम एक विशेष कॅरक्टर',
    password_uppercase: 'कम से कम एक अपरकेस कॅरक्टर',
    password_lowercase: 'कम से कम एक लोअरकेस कॅरक्टर',
    phone: 'कृपया अपना फ़ोन नंबर दर्ज करें',
    phone_invalid: 'अमान्य फ़ोन नंबर',
    status: 'कृपया अपना स्थान दर्ज करें',
    question: 'कृपया प्रश्न दर्ज करे',
    start_date: 'आरंभ तिथि और समय आवश्यक है',
    tag: 'कृपया एक टैग का चयन करें',
    topics: 'कृपया कम से कम एक विषय का चयन करें।',
    live_topics: 'कृपया विषय जोड़ें',
    title: 'कृपया शीर्षक दे',
    title_assessment: 'कृपया असेसमेंट का शीर्षक दे',
    title_course: 'कृपया कोर्स का शीर्षक दे',
    title_empty: 'शीर्षक खाली नहीं हो सकता',
    title_event: 'कृपया ईवेंट का शीर्षक दे',
    title_lesson: 'कृपया पाठ शीर्षक दे',
    title_quiz: 'कृपया प्रश्नोत्तरी को नाम दे',
    username: 'कृपया अपना यूजरनेम दर्ज करें',
    upload_error: 'त्रुटि - फ़ाइल अनुकूल नहीं है!',
    upload_more_than_10:
      'आप केवल एक बार में अधिकतम 10 फ़ाइलें अपलोड कर सकते हैं।',
    topic_max: 'कृपया अधिकतम 3 विषय ही जोड़ें।',
    upload_excel: 'कृपया सुनिश्चित करें कि आपने सही फ़ाइल अपलोड की है।',
    title_excel: 'टेम्प्लेट अपलोड करने में त्रुटि आ रही है:',
    file_size_exceed: 'फ़ाइल का आकार तय सीमा सेँ अधिक है',
    subtitle_excel:
      'कृपया सुनिश्चित करें कि आपने दिए किए गए टेम्पलेट का उपयोग किया हो और कॉलम भी सही ढंग से भरे हो।',
    select_broadcast_option:
      'कृपया इस घटना को प्रसारित करने के लिए एक विकल्प चुनें',
    multi_hosts_number_error:
      'इवेंट की तय सीमा से अधिक प्रस्तुतकर्ता नहीं हो सकते है।',
    conference_people_number_error:
      'इवेंट की तय सीमा से अधिक प्रतिभागी नहीं हो सकते है।',
    select_max_host: 'इवेंट के लिए कम से कम 1 प्रस्तुतकर्ता का चयन करें।',
    select_max_conference: 'इवेंट के लिए कम से कम 1 प्रतिभागी का चयन करें।',
    stream_stop_error: 'स्ट्रीमिंग अचानक से रुक गयी!',
    unsecure_context:
      'बड़ी त्रुटि: असुरक्षित कंटेंट के कारण ब्राउज़र कैमरा और माइक का उपयोग नहीं कर सकता है। कृपया एचटीटीपीएस के जरिये एसएसएल इंसटाल करें  ',
    ws_not_supported: 'बड़ी त्रुटि: यह ब्राउज़र वेबसॉकेट को स्पोर्ट नहीं करता है',
    no_org: 'आगे बढ़ने के लिए कम से कम 1 संगठन का चयन करें।',
    no_org_group: 'आगे बढ़ने के लिए कम से कम 1 संगठन समूह का चयन करें।',
    waiting_to_join: 'किसी के शामिल होने का इंतजार!'
  },

  events: {
    title: 'लाइव इवेंट की जानकारी दे',
    change_host: 'होस्ट बदलें',
    finished: 'इवेंट समाप्त हो गई है',
    countdown: 'लाइव इवेंट प्रसारित होगा',
    subtitle:
      'अपने लाइव इवेंट को एक नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा।',
    poll_disabled: 'इस इवेंट के लिए पोल ​​उपलब्ध नहीं है',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि यह लाइव इवेंट नहीं करता है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम”`,
    prompt_message:
      'इस पेज से वापस जाने पर आपका इवेंट समाप्त हो जाएगा। क्या आप फिर भी इस पेज से जाना चाहते हैं? ',
    duration_exceed_message:
      'आपका प्रसारण समय तय सीमा को पार कर गया है, ऐप प्रसारण बंद करने जा रहा है।',
    before_schedule_message:
      'आप निर्धारित कार्यक्रम के समय से पहले प्रसारण शुरू करने जा रहे हैं। कृपया ध्यान दें कि प्रसारण बंद करने से इवेंट भी रुक जाएगा। ',
    browser_unsupportive_message:
      'आपका ब्राउज़र स्क्रीन शेयर को स्पोर्ट नहीं करता है। आप इस लिंक पर जाकर स्पोर्ट करने वाले ब्राउज़र डाउनलोड कर सकते हैं',
    cancel_switch_host_message:
      'होस्ट उपलब्ध नहीं है। आपकी ओर से इवेंट जारी रहेगा।',
    coaching_prompt_message: 'इवेंट खत्म होने तक आप इस पेज से नहीं जा सकते।',
    event_modal_warn: 'क्या आप इस इवेंट से बाहर निकलना चाहते हैं?',
    confirm_message: 'ठीक है पर क्लिक करने से आपका ईवेंट यही खत्म हो जाएगा।',
    screen_share_denied: 'आपने अपनी स्क्रीन साझा करने से इनकार कर दिया।',
    media_not_found:
      'आपके डिवाइस की कैमरा या माइक उपलब्ध नहीं है या आपके द्वारा इन्हे एक्सेस करने की अनुमति नहीं दी गयी।',
    media_not_access:
      'कैमरा या माइक का उपयोग कुछ अन्य प्रक्रियाओ के लिए किया जा रहा है जिससे डिवाइस को मैनेज नहीं किया जा रहा है। ',
    constraint_error:
      'ऐसा कोई उपकरण नहीं मिला है जो आपके वीडियो और ऑडियो की कमी को पूरा कर सके। आप चाहे तो वीडियो और ऑडियो बाधाओं को बदल सकते हैं।',
    media_access_denied: 'आपको कैमरा और माइक एक्सेस करने की अनुमति नहीं है।'
  },

  filters: {
    days7: 'अंतिम 7 दिन',
    days15: 'अंतिम 15 दिन',
    days30: 'अंतिम 30 दिन',
    days365: 'अंतिम 365 दिन',
    date: 'तारीख तय की गयी',
    relevance: 'उपयोग',
    popularity: 'लोकप्रियता',
    name: 'नाम',
    group: 'समूह',
    Newest_to_Oldest: 'सबसे नए से सबसे पुराना',
    Oldest_to_Newest: 'सबसे पुराने से सबसे नया',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'आपके खाते की सुरक्षा को मद्देनजर रखते हुए आपके पासवर्ड में कम से कम एक लोअरकेस और एक संख्या होना आवश्यक है। पासवर्ड में न्यूनतम 10 वर्ण  होने चाहिए। ',
    phone: 'कृपया अपना फ़ोन कंट्री कोड भरे, उदाहरण के लिए: +65',
    username:
      'आपके यूजरनेम को सार्वजनिक जानकारी के रूप में माना जाता है और आवश्यकता पड़ने पर इसे अन्य यूजर के साथ भी साझा किया जा सकता है। इसलिए, हम उम्मीद करते हैं कि आप अपने यूजरनेम में किसी निजी जानकारी का उपयोग न करें ',
    public_description_normal:
      'आपका <0> <0 /> </ 0> सहेजा जा चूका है और डिफ़ॉल्ट रूप से इसे निजी किया गया है। इसका मतलब है कि केवल आप इस कंटेंट को देख सकते हैं। इस कंटेंट को सार्वजनिक करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक करने का अर्थ है कि इस प्लॅटफॉर्म पर मौजूद सभी यूजर आपका कंटेंट एक्सेस कर सकते है। विशिष्ट यूजर विकल्प आपको अपने मनचाहे यूजर के शेयरवेयर खाते से जुड़े ईमेल पते का उपयोग करके उसके साथ अपना पाठ्यक्रम साझा करने का मौका देता है। ',
    public_description_admin:
      'आपका <0> <0 /> </ 0> सहेजा जा चूका है और डिफ़ॉल्ट रूप से इसे निजी किया गया है। इसका मतलब है कि केवल आप (और कंटेंट क्रिएटर) इस कंटेंट को देख सकते हैं। इस कंटेंट को सार्वजनिक करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक करने का अर्थ है कि इस प्लॅटफॉर्म पर मौजूद सभी यूजर आपका कंटेंट एक्सेस कर सकते है।  - जिसमें आपके संगठन के बाहर के लोग भी शामिल होंगे। इसे संगठन के साथ सार्वजनिक करने का अर्थ है कि संगठन के भीतर मौजूद सभी यूजर इसे देख पाएंगे। आप इसे 1 या अधिक समूहों के बीच भी सार्वजनिक कर सकते हैं, जिसका अर्थ है कि केवल उन समूहों के उपयोगकर्ता ही इसे देख पाएंगे। अंत में, आपके पास एक और विकल्प है जिसकी सहायता से आप अपने संगठन के भीतर और कुछ बाहरी यूजर के समक्ष अपना पाठ्क्रम सार्वजनिक कर सकते है। इसे करने के लिए आपको उनके शेयरलुक खाते से जुड़े ईमेल पते की जरूरत होगी। '
  },

  labels: {
    add: 'जोड़ें',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'उत्तर दर्ज करे',
    answers: 'उत्तर',
    back_to_quiz: 'प्रश्नोत्तरी की सूची पर वापस जाये',
    back_to_question: 'प्रश्न सूची पर वापस',
    chat: 'चैट',
    chat_available: 'इस इवेंट में चैट उपलब्ध नहीं है',
    chat_report: 'चैट की रिपोर्ट',
    choice_single: 'एकमात्र विकल्प',
    choice_multiple: 'बहुविकल्पी',
    choice_free: 'नि: शुल्क विकल्प',
    choice_sorting: 'विकल्प छांटे',
    choice_matrix: '"मैट्रिक्स छांटने" का विकल्प',
    clone_lesson_permission: 'क्लोन की अनुमति',
    code: 'कोड',
    correct: 'सही',
    created: 'तारीख तय की गयी',
    clone_modal: 'क्लोन कोर्स',
    cloning_course: 'क्लोनिंग कोर्स ...',
    cloning: 'क्लोनिंग ...',
    cloning_course_desc:
      'इस प्रक्रिया में कुछ समय लग सकता है। कृपया धैर्य बनाये रखें',
    cloning_success: 'कोर्स "<0 />" का क्लोन बनाया गया!',
    description: 'विवरण',
    disclaimer: 'अस्वीकरण',
    drop_file: 'फाइल यहाँ उपलोड करे...',
    duration: 'अवधि',
    edit: 'बदलाव करें',
    email: 'ईमेल',
    event: 'इवेंट',
    event_all: 'सभी इवेंट',
    event_date: 'लाइव इवेंट का लोकल समय /तारीख',
    event_this: 'यह इवेंट',
    expire: 'को खत्म होगा',
    expiry_date: 'समाप्ति की तारीख',
    forgot: 'पासवर्ड भूल गए?',
    group: 'समूह',
    groups_list: 'समूह की सूची',
    host: 'होस्ट',
    id_annotation: 'एनोटेशन आईडी',
    id_quiz: 'क्विज़ आईडी',
    incorrect: 'गलत',
    interests: 'रुचियां',
    invited: 'आमंत्रित किया गया',
    live_chat: 'लाइव चर्चा',
    live_stream_limit: 'लाइव-स्ट्रीमिंग की मिनट',
    contact_text: 'अपनी मासिक लाइव-स्ट्रीमिंग सीमा को बदलने के लिए संपर्क करें',
    contact_admin:
      '<0> यदि आप अपनी मासिक लाइव-स्ट्रीमिंग सीमा बदलना चाहते हैं तो यहाँ संपर्क करें </ 0> <1> admin@sharelook.com </ 1>',
    limit_stream_text:
      'Live-streaming Minutes Remaining: <0> {{सीमा}} </ 0> मिनट <1 /> <2 /> <3> अपनी मासिक लाइव-स्ट्रीमिंग सीमा को बदलने के लिए कृपया संपर्क करें </ 3> <4> व्यवस्थापक @ sharelook.com </ 4> ',
    location: 'लोकेशन',
    lessons: 'पाठ',
    location_broadcast: 'होस्ट सर्वर की लोकेशन',
    location_broadcast_subtitle:
      'ऑडिओ विज़ुअल डिले को कम करने के लिए प्रसारण होस्ट की लोकेशन के नजदीक एक लोकेशन जोड़े',
    Media_manager: 'मीडिया मैनेजर',
    minutes: 'मिनट',
    name: 'नाम',
    online_quiz: 'ऑनलाइन क्विज़',
    organiser: 'लेखक',
    organization: 'संगठन',
    overall_emotion: 'समग्र अनुभव:',
    organizations_list: 'संगठनों की सूची',
    password: 'पासवर्ड',
    participants: 'प्रतिभागी',
    picture: 'चित्र (16: 9)',
    phone: 'फ़ोन',
    photo: 'फोटो',
    poll: 'पोल',
    position: 'पोजीशन',
    processing: 'प्रोसेस हो रहा है',
    privacy_settings: 'गोपनीय सेटिंग्स',
    question: 'प्रश्न',
    quiz_create: 'नई प्रश्नोत्तरी बनाएं',
    quiz_name: 'प्रश्नोत्तरी का नाम',
    quiz_update: 'क्विज़ अपडेट करें',
    select_organization: 'एक संगठन का चयन करें',
    settings: 'सेटिंग्स',
    show: 'दिखाएं',
    show_graph: 'ग्राफ के परिणाम दिखाएं',
    signin: 'साइन इन करे',
    signup: 'साइन अप करें',
    sort_by: 'द्वारा क्रमबद्ध करें',
    start_date: 'शुरू होने की तारीख',
    tags: 'टैग',
    terms: 'मैं इन <1> नियमों और शर्तों से सहमत हूं </ 1>।',
    title: 'शीर्षक',
    topics: 'विषय',
    topic: 'विषय',
    total_comments: 'कुल टिप्पणियाँ',
    username: 'उपयोगकर्ता का नाम',
    users_list: 'उपयोगकर्ताओं की सूची',
    users_emails: 'खास उपयोगकर्ताओ के ईमेल दर्ज करे',
    description_specifiction_email:
      'कृपया एक से अधिक खास उपयोगकर्ताओं के साथ इसे साझा करने के लिए प्रति पंक्ति में 1 ईमेल पता दर्ज करें।',
    message_specific_email: 'कृपया विशेष उपयोगकर्ता का ईमेल दर्ज करें।',
    viewers: 'दर्शक',
    edit_course: 'बदलाव करें',
    edit_assessment: 'बदलाव करें',
    edit_event: 'बदलाव करें',
    delete_course: 'हटाएँ',
    delete_event: 'हटाएँ',
    delete_assessment: 'हटाएँ',
    view_course: 'देखें',
    view_event: 'देखें',
    view_assessment: 'देखें',
    date_event: 'लाइव इवेंट की तारीख',
    date_assessment: 'लाइव असेसमेंट की तारीख',
    clone_of: 'क्लोन',
    clone_course:
      'इस पाठ्यक्रम का एक क्लोन बनाएं जिसमें आप स्वतंत्र रूप से बदलाव कर सकते हैं, जिसमें सभी पाठ और पृष्ठ शामिल हैं।',
    make: 'बनाएं',
    available_to: 'किसी भी शेयरलुक यूजर के लिए उपलब्ध',
    uploaded_by: 'द्वारा अपलोड किया गया:',
    course: 'कोर्स',
    assessment: ' मूल्यांकन',
    user_not_exist: 'यूजर मौजूद नहीं है, क्या आप निमंत्रण भेजना चाहेंगे?',
    check_user: 'नोटिस',
    user_not_exist_in_org:
      'यूजर इस संगठन में मौजूद नहीं है, क्या आप निमंत्रण भेजना चाहेंगे?',
    title_modal_stream: 'ऑर्गनाइजेशन लाइवस्ट्रीम लिमिट में बदलाव करे',
    des_warning_stream: 'आप बदलने वाले हैं',
    monthly_stream: 'मासिक लाइव-स्ट्रीमिंग सीमा',
    min_per_month: 'मिनटे/ माह',
    broadcast_label: 'मैं करना चाहता हूं:',
    hosts_emails: 'विशिष्ट होस्ट का ईमेल दर्ज करे',
    attendee_emails: 'विशिष्ट प्रतिभागी के ईमेल दर्ज करे',
    description_host_specifiction_email:
      'कृपया प्रति पंक्ति में 1 ईमेल पता दर्ज करें।',
    presenter_label: 'प्रस्तुतकर्ता',
    presenter_label_conference: 'लोगो की संख्या',
    event_privacy: 'कांफ्रेंस मोड़'
  },

  broadcastOptions: {
    wowza_gocoder: 'मेरे फोन से सीधा लाइव प्रसारण करे',
    other_webrtc: 'मेरे पीसी से वेबिनार करे',
    multihost: 'मेरे पीसी से मल्टीकास्ट वेबिनार करे',
    peer2peer: 'कोचिंग सेशन',
    conference: 'लाइव कांफ्रेंस'
  },

  lessoncreate: {
    title: 'पाठ से संबंधित जानकारी दे',
    subtitle:
      'अपने पाठ का नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा',
    input_label_title: 'पाठ का शीर्षक',
    input_label_topics: 'पाठ का विषय',
    input_label_description: 'पाठ का विवरण',
    delete_warning: 'क्या आप सच में इस पेज को मिटाना चाहते है ?'
  },

  lessonoverview: {
    title: 'पाठ जोड़ें',
    subtitle: 'मौजूदा पाठ जोड़ें या एक नया बनाएं',
    new_lesson: 'एक नया पाठ बनाएँ',
    new_lesson_sub: 'स्क्रैच से एक नया पाठ बनाएँ!',
    existing_lesson: 'मौजूदा पाठ का चयन करें',
    existing_lesson_sub:
      'मौजूदा पाठ का लिंक, इस पाठ में किए गए परिवर्तन से अन्य पाठ्यक्रमों में भी इसी पाठ पर प्रभाव पड़ेगा',
    clone_lesson: 'मौजूदा पाठ की नकल करके एक ओर ऐसा ही पाठ बनाये',
    clone_lesson_sub:
      'इस पाठ्यक्रम के पाठ की एक कॉपी बनाये , इस पाठ में किए गए परिवर्तन मूल पाठ को प्रभावित नहीं करेंगे',
    clone_lesson_modal_sub:
      'कृपया अपने मनचाहे पाठ को जोड़ने के लिए उसके नीचे दिए गए क्लोन बटन पर क्लिक करें'
  },

  management: {
    groups_title: 'समूहों को मैनेज करें',
    delete_warning: 'क्या आपको यकीन है?',
    organizations_title: 'मेरे संगठन',
    organizations_subtitle: 'संगठनों को अपनी सूची में जोड़ें',
    users_title: 'यूजर को मैनेज करें',
    users_position: 'वरिष्ठ खाता प्रबंधक',
    user_not_found: 'यूजर नहीं मिला',
    select_org:
      'कृपया उपयोगकर्ताओं को प्रबंधित करने के लिए एक संगठन खोजें और चुनें'
  },

  audio: {
    modal_title: 'ऑडियो अपलोड करें ',
    list_view: 'लिस्ट व्यू',
    create_audio_modal_title: 'ऑडियो बनाएँ',
    edit_audio_modal_title: 'ऑडियो में बदलाव',
    public_audio_not_found: 'ऑडियो नहीं मिला ',
    Private_audio_not_found: 'आपने अभी तक कोई ऑडियो अपलोड नहीं किया है',
    are_you_sure_to_delete: 'क्या आप वाकई हटाना चाहते हैं?',
    type_something: 'कुछ टाइप करे',
    select_voice: 'चुने',
    file_name: 'फ़ाइल का नाम',
    description: 'विवरण',
    topic: 'विषय',
    key_words_tag: 'कीवर्ड्स को टैग बनाये',
    mp3_audio: 'एमपी 3 ऑडियो',
    created: 'बनाया',
    duration: 'अवधि',
    close: ' बंद करे'
  },

  image: {
    modal_title: 'चित्र अपलोड करे',
    image: 'चित्र ',
    pixel: 'पिक्सेल',
    dimension: 'आयाम',
    public_image_not_found: 'चित्र नहीं मिला।',
    Private_image_not_found: 'आपने अभी तक कोई छवि अपलोड नहीं की है'
  },

  annotation: {
    modal_title: 'एनोटेशन'
  },

  text: {
    modal_title: 'टेक्स्ट एडिटर'
  },

  video: {
    modal_title: 'वीडियो अपलोड करे',
    image: ' वीडियो ',
    mp4_video: 'MP4 वीडियो ',
    public_video_not_found: 'वीडियो नहीं मिली',
    private_video_not_found: 'आपने अभी तक कोई वीडियो अपलोड नहीं की है'
  },

  media: {
    title: 'मीडिया लाइब्रेरी',
    subtitle: 'आपकी फाइलों की लाइब्रेरी',
    modal_title: 'मीडिया उपलोड करे',
    delete_warning: 'डिलीट कन्फर्म करे',
    delete_message:
      'डिलीट किया हुए मीडिया को आपने जिन भी पेजो पर इस्तेमाल किया है वो वहाँ से नहीं हटेंगे',
    dropzone_text: 'ड्रैग या ड्राप करे ',
    delete_success: ' मीडिया को सफलतापूर्वक डिलीट किया गया',
    upload_file: 'फाइल उपलोड करे',
    drag_drop: 'ड्रैग या ड्राप करे',
    import_file: 'कंप्यूटर से फाइल उपलोड करे',
    no_media: 'आपने अभी तक कोई मीडिया अपलोड नहीं किया है',
    media_type: 'मीडिया का प्रकार',
    video: 'वीडियो',
    image: 'चित्र',
    audio: 'ऑडियो',
    gif: 'GIF/जीआईऍफ़  ',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'मीडिया नहीं है',
    of: 'of',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि यह मिडिया इवेंट नहीं करता है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम”`,
    my_media: 'मेरा मीडिया',
    public_library: 'पब्लिक लाइब्रेरी',
    organization_library: 'संगठन की लाइब्रेरी ',
    upload_from_computer: 'कंप्यूटर से अपलोड करे',

    create: 'क्रिएट करे',
    all: 'सभी',
    male: 'पुरुष ',
    female: ' महिला',
    processing_audio: 'ऑडियो प्रोसेस हो रही है',

    create_annotation: 'एनोटेशन बनाएं',
    popup_over_lesson_text:
      'क्लिक करने के बाद एनोटेशन पाठ के पृष्ठ पर पॉप अप होगा',
    edit_detail: 'विवरण में बदलाव करे',

    delete: 'हटाएं',

    go_create_audio: 'आइये , ऑडियो बनाएँ',

    show_more_details: 'अधिक विवरण दिखाएं',

    show_less_details: 'कम विवरण दिखाएं',

    drop_files: 'सही जगह फाइल अपलोड करे',
    or: 'या',
    import_files: 'कंप्यूटर से फ़ाइलें अपलोड करें'
  },

  navigation: {
    account: 'खाता',
    assessments: 'मूल्यांकन',
    dashboard: 'डैशबोर्ड',
    groups: 'समूह प्रबंधन',
    logout: 'लॉग आउट',
    organisations: 'संगठन',
    organizations_users: 'संगठन और उपयोगकर्ता',
    reports: 'रिपोर्ट',
    schedule: 'अनुसूची',
    training: 'प्रशिक्षण',
    nowLive: 'लाइव',
    users: 'उपयोगकर्ता',
    workshop: 'मेरी कार्यशाला'
  },

  onboarding: {
    step1_title: 'चरण 1: हमें अपने बारे में थोड़ा बताएं',
    step1_subtitle: 'आपका नाम क्या हे? आप कहां के निवासी हैं? आप क्या करते है?',
    step2_title: 'चरण 2: आप जिस कौशल में सुधर करना चाहते उसका चयन करें',
    step2_subtitle:
      'इसके बाद, हमें बताएं कि आप किस बारे में और बेहतर तरिके से समझना चाहेंगे। हमे उम्मीद है ऐसा कुछ न कुछ जरूर होगा? अध्ययन का एक नया क्षेत्र? आपके प्रिय व्यक्ति क्या करते है? '
  },

  pagebuilder: {
    title: 'एक पाठ तैयार करे ',
    subtitle:
      'अब समय आ गया है कि आपके दर्शक आपसे कुछ सिख पाए, इसके लिए आप तस्वीर, वीडियो और इन्फोग्राफिक्स का इस्तेमाल कर सकते हैं',
    select_layout: 'एक पेज लेआउट चुनें',
    template1: 'ब्लैंक',
    template2: 'शीर्षक और उपशीर्षक',
    template3: 'शीर्षक और पाठ',
    template4: 'शीर्षक, मीडिया और पाठ',
    template5: 'शीर्षक और मीडिया',
    template6: 'शीर्षक और प्रश्नोत्तरी'
  },

  pageconstructor: {
    title: 'पाठ तैयार करे और क्लोन बनाये',
    subtitle:
      'अब समय आ गया है कि आपके दर्शक आपसे कुछ सिख पाए, इसके लिए आप तस्वीर, वीडियो और इन्फोग्राफिक्स का इस्तेमाल कर सकते हैं'
  },

  passwordreset: {
    success_coded:
      'हमने आपके दिए गए पते पर एक पुष्टिकरण कोड ईमेल किया है, कृपया एक नया पासवर्ड सेट करने के लिए नीचे दिए गए फ़ील्ड में कोड कॉपी करे।',
    success_changed:
      'आपने सफलतापूर्वक एक नया पासवर्ड सेट किया है। अब आप साइन इन कर सकते हैं। '
  },

  placeholders: {
    search: 'खोजे',
    answer: 'उत्तर',
    chat: 'कुछ कहे ...',
    code: 'कोड',
    criterion: 'मापदंड',
    date_event: 'तारीख और समय का चयन करे ',
    date_start: 'शुरु होने की तारीख',
    date_expire: 'समाप्ति की तारीख',
    description: 'विवरण',
    elements: 'चीजों को क्रमबद्ध करें',
    email: 'ईमेल',
    feedback_correct: 'सही फीडबैक',
    feedback_incorrect: 'गलत फीडबैक',
    host: 'होस्ट',
    keywords: 'कीवर्ड खोजे',
    lesson_description: 'पाठ का विवरण',
    location: 'लोकेशन',
    minutes: 'मिनटे',
    name: 'नाम',
    organiser: 'लेखक',
    organization: 'संगठन',
    password: 'पासवर्ड',
    phone: 'फ़ोन',
    photo: 'फोटो',
    picture: 'चित्र',
    point: 'बिंदु',
    position: 'पोजीशन',
    question: 'सवाल',
    quiz: 'प्रश्नोत्तरी का नाम',
    search_course: 'कोर्स खोजें',
    search_media: 'मीडिया खोजें',
    search_name: 'नाम से खोजें',
    search_title: 'शीर्षक से खोजें',
    search_training: 'प्रशिक्षण खोजे',
    settings: 'सेटिंग्स',
    tags: 'टैग',
    title: 'शीर्षक',
    topics: 'विषय',
    username: 'यूजरनेम',
    keyword: 'कीवर्ड',
    max_500_characters: 'अधिकतम 500 वर्ण',
    no_description: 'इस फ़ाइल का विवरण नहीं है',
    no_keyword: 'इस फ़ाइल में कोई कीवर्ड नहीं है',
    no_topics: 'इस फ़ाइल में विषय सेट नहीं है',
    feedback: 'संदेश',
    contact: 'हम कैसे मदद कर सकते हैं?'
  },

  publishsettings: {
    title: 'सेटिंग सार्वजनिक करे ',
    event_subtitle:
      'आपके ईवेंट को कौन देख सकता है और कौन इंटरेक्ट कर सकता है उसकी सेटिंग करे',
    assessment_subtitile:
      'अपने असेसमेंट का नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा',
    course_subtitle:
      'आपके कोर्स को कौन देख सकता है और कौन इंटरेक्ट कर सकता है उसकी सेटिंग करे',
    disclaimer: `1. पंजीकरण

  यदि आप एक यूजर के रूप में पंजीकरण करते / एक खाता बनाते तो मान लिया जायेगा कि आप हमारे [यूजर समझौते] से सहमत हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।


2. कोर्स क्रिएट करना

  यदि आप हमारे टूल का उपयोग करके कोर्स क्रिएट करते है, तो  माना लिया जायेगा कि आप हमारे [यूजर एग्रीमेंट] से सहमत होते हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।


3. इवेंट क्रिएट करना

  यदि आप हमारे टूल का उपयोग करके इवेंट क्रिएट करते है, तो मान लिया जायेगा कि आप हमारे [यूजर एग्रीमेंट] से सहमत होते हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।

4. असेसमेंट क्रिएट करना

  यदि आप हमारे टूल का उपयोग करके असेसमेंट क्रिएट करते है, तो मान लिया जायेगा कि आप हमारे [यूजर एग्रीमेंट] से सहमत होते हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।`,
    dates_validation_error: 'दोनों तारीखें भरनी होंगी',
    course_dates_validation_error: 'कृपया इस पाठ्यक्रम की आरंभ और समाप्ति तिथि दर्ज करें।',
    email_validation_error: 'ईमेल की सूची अमान्य है',
    specific_email_validation_error: 'केवल एक ईमेल की अनुमति है',
    i_agree_to_these: 'मैं इनसे सहमत हूं',
    terms_and_conditions: 'नियम और शर्तें',
    PublicDescription:
      'नि: शुल्क स्वतंत्र यूजर: (निजी और सार्वजनिक विकल्प) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा गया है और डिफ़ॉल्ट रूप से इसे निजी माना जाता है। इसका मतलब है कि केवल आप इस कंटेंट को देख सकते हैं। इस कंटेंट को सार्वजनिक करने के लिए आप इसे नीचे सार्वजनिक करना चुन सकते हैं। इसका मतलब है कि अब प्लेटफार्म पर मौजूद सभी उपयोगकर्ताओं आपके कंटेंट को देख सकेंगे।',
    OrganisationsDescription:
      'संगठन के उपयोगकर्ता: ("" समाप्त "" के बजाय "" "प्रकाशित करें" का उपयोग करें) और अन्य उपयोगकर्ताओं की तरह ही प्रकाशित पृष्ठ पर लाएं, लेकिन किसी भी प्रकाशित विकल्प का उपयोग किये बिना।) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा जा चूका और निजी रखा गया है। इसका मतलब है कि केवल आप और आपके संगठन के व्यवस्थापक ही इसे देख सकते हैं। एक उपयोगकर्ता के लिहाज से , आप अपने संगठन के भीतर अपनी सामग्री को स्वयं प्रकाशित नहीं कर सकते क्योंकि इसके लिए व्यवस्थापक अधिकारों की आवश्यकता होती है। कृपया अपने किसी व्यवस्थापक से संपर्क करें और उन्हें अपनी सामग्री को सार्वजनिक तौर पर, पूरे संगठन के बीच, आपके संगठन के विशिष्ट समूहों के बीच या विशिष्ट उपयोगकर्ताओं के समक्ष प्रकाशित करने के लिए अनुरोध करे । ',
    OrganisationGroupsDescription:
      'संगठन के व्यवस्थापक: (संगठन के भीतर तैयार की गई सामग्री के लिए: निजी, सार्वजनिक, संगठन, समूह, विशिष्ट उपयोगकर्ता): यह पाठ्यक्रम [इवेंट |असेसमेंट] सहेजा जा चूका और निजी रखा गया है। । इसका मतलब है कि केवल आप (और कंटेंट क्रिएटर) इस सामग्री को देख सकते हैं। इस सामग्री को प्रकाशित करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक रूप से प्रकाशित करने का अर्थ है कि अब यह प्लेटफ़ॉर्म पर मौजूद सभी उपयोगकर्ताओं के लिए उपलब्ध होगा - जिसमें आपके संगठन से बाहर के लोग भी शामिल होंगे। इसे संगठन के समक्ष प्रकाशित करने का अर्थ है कि संगठन के भीतर के सभी उपयोगकर्ता इसे देख पाएंगे। आप इसे 1 या अधिक समूहों के बीच भी प्रकाशित कर सकते हैं, जिसका अर्थ है कि केवल उन समूहों के उपयोगकर्ता ही इसे देख पाएंगे। अंत में, आपके पास अपने संगठन के भीतर और बाहर के विशिष्ट उपयोगकर्ताओं के साथ  साझा करते हुए उनके खाता ईमेल पते का उपयोग करके इसे प्रकाशित करने का विकल्प है। ',
    SpecificUsersDescription: `पेड़ स्वतंत्र उपयोगकर्ता: (निजी, सार्वजनिक और विशिष्ट उपयोगकर्ता) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा गया है और डिफ़ॉल्ट रूप से निजी माना जाता है। इसका 'पेड़ स्वतंत्र उपयोगकर्ता: (निजी, सार्वजनिक और विशिष्ट उपयोगकर्ता) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा गया है और डिफ़ॉल्ट रूप से निजी माना जाता है। इसका मतलब है कि केवल आप इस सामग्री को देख सकते हैं। इस सामग्री को प्रकाशित करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक रूप से प्रकाशित करने का अर्थ है कि यह मंच के सभी उपयोगकर्ताओं के लिए उपलब्ध होगा। विशिष्ट उपयोगकर्ता विकल्प आपको अपने साझाकरण खाते से जुड़े ईमेल पते का उपयोग करके विशिष्ट उपयोगकर्ताओं के साथ अपना पाठ्यक्रम साझा करने में मौका देता है। ',मतलब है कि केवल आप इस सामग्री को देख सकते हैं। इस सामग्री को प्रकाशित करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक रूप से प्रकाशित करने का अर्थ है कि यह मंच के सभी उपयोगकर्ताओं के लिए उपलब्ध होगा। विशिष्ट उपयोगकर्ता विकल्प आपको अपने साझाकरण खाते से जुड़े ईमेल पते का उपयोग करके विशिष्ट उपयोगकर्ताओं के साथ अपना पाठ्यक्रम साझा करने में मौका देता है। `
  },

  quiz: {
    quiz_empty: 'आपने अभी तक क्विज क्रिएट नहीं की है',
    questions_empty: 'आपने अभी तक सवाल नहीं बनाया है'
  },

  regions: {
    asia_pacific_australia: 'ऑस्ट्रेलिया',
    asia_pacific_india: 'भारत',
    asia_pacific_japan: 'जापान',
    asia_pacific_s_korea: 'दक्षिण कोरिया',
    asia_pacific_singapore: 'सिंगापुर',
    asia_pacific_taiwan: 'ताइवान',
    eu_belgium: 'बेल्जियम',
    eu_germany: 'जर्मनी',
    eu_ireland: 'आयरलैंड',
    south_america_brazil: 'ब्राज़ील',
    us_central_iowa: 'लोवा',
    us_east_s_carolina: 'दक्षिण कैरोलिना',
    us_east_virginia: 'वर्जिनिया',
    us_west_california: 'कैलिफ़ोर्निया',
    us_west_oregon: 'ऑरेगोन'
  },

  reports: {
    title: 'रिपोर्ट',
    workshop_report: 'वर्कशॉप रिपोर्ट',
    user_report: 'यूजर रिपोर्ट ',
    organization_workshop: 'संगठन की वर्कशॉप ',
    course: 'कोर्स',
    live_event: 'लाइव इवेंट',
    workShop_graph: 'वर्कशॉप ग्राफ',
    organization_account: ' संगठन का खाता ',
    all: 'सभी',
    name: 'नाम',
    id_number: 'आइडी नंबर',
    email: 'ईमेल',
    search_user_report: 'यूजर रिपोर्ट ढूंढे',
    participant: 'प्रतिभागी',
    participants: 'प्रतिभागी',
    host: 'मेज़बान',
    username: 'यूजर का नाम',
    event: 'इवेंट',
    quiz: 'प्रश्नोत्तरी ',
    assessment: 'मूल्यांकन',
    time: ' समय ',
    no_recent_activity: 'कोई हालिया गतिविधि नहीं',
    workshops: 'वर्कशॉप',
    courses: 'कोर्स',
    live_events: 'लाइव इवेंट',
    live_assessments: 'लाइव मूल्यांकन',
    quizzes: 'प्रश्नोत्तरी ',
    overview: 'ओवरव्यू',
    by: 'द्वारा',
    views: 'व्यूज',
    status: 'स्टेटस ',
    poll: 'पोल',
    comment: 'टिप्पणियाँ',
    comments: 'टिप्पणियाँ',
    no_comments: 'कोई टिप्पणियाँ नहीं',
    no_polls: 'कोई पोल नहीं',
    live_date: 'लाइव तारीख',
    score: 'स्कोर',
    question: 'प्रश्न',
    submit: 'जमा करे',
    recent_activity: 'हाल की गतिविधि',
    ago: 'पहले',
    no_data_found: 'कोई डेटा नहीं मिला',
    start_end_live: 'प्रारंभ / अंत लाइव का',
    join_leave_date: 'जुड़े/बाहर निकले',
    watched_time: 'जितनी देर देखा',
    complete: 'पूर्ण',
    in_complete: 'अधूरा',
    today: 'आज',
    seven_days: '7 दिन',
    last_month: 'पिछला माह',
    one_year: '1 साल',
    all_time: 'पूर्ण समय',
    report: 'रिपोर्ट',
    from_date: 'इस तारीख से',
    to_date: 'इस तारीख तक',
    all_workshop: 'सभी वर्कशॉप',
    all_participants: 'सभी प्रतिभागी',
    live_assessment: 'लाइव मूल्यांकन',
    users: 'यूज',
    download: 'डाउनलोड',
    recent: 'हाल का',
    WorkShop: 'वर्कशॉप',
    Activity: 'गतिविधि',
    created_date: 'बनाने की तारीख',
    lessons: 'पाठ',
    lesson: 'पाठ',
    completed: 'पूर्ण',
    report_download: 'रिपोर्ट डाउनलोड',
    this_month: 'इस माह',
    search_course: 'कोर्स ढूंढे',
    participants_graph: 'प्रतिभागी का ग्राफ',
    viewed: 'देखा गया',
    enrolled: 'एनरोल किया',
    description: 'विवरण',
    topic: 'विषय',
    analytic: 'विश्लेषणात्मक',
    quiz_list: 'प्रश्नोत्तरी की सूची',
    select_one: 'एक चुनो',
    group_status: 'ग्रुप स्टेटस',
    duration_min: 'अवधि (मिनट)',
    submit_poll: 'वोट करे',
    download_events: 'इवेंट डाउनलोड करे',
    search_event: 'इवेंट खोजे',
    duration: 'अवधि ',
    total_participants: 'कुल प्रतिभागी',
    message: 'संदेश',
    avg_message: 'औसत संदेश',
    per_message: 'औसत मैसेजेस / ईवेंट'
  },

  signup: {
    success_step1:
      'हमने आपके द्वारा दिए गए पते पर एक सत्यापन कोड ईमेल किया है, कृपया अपने पंजीकरण की पुष्टि करने के लिए नीचे दिए गए खाली स्थान में वो कोड कॉपी करें।',
    success_step2: 'धन्यवाद। आपका सफलतापूर्वक पंजीकृत पूरा हैं।',
    privacy: `मैं शेयरलुक के <1> नियम और शर्तें </ 1> और <3> गोपनीयता नीति </ 3> से सहमत हूं।`
  },

  stream: {
    emotion_impressive: 'प्रभावशाली',
    emotion_unimpressive: 'प्रभावशाली नहीं है',
    message_not_started: 'जल्द आ रहा है',
    message_running: 'लाइव',
    message_processing:
      'हम वर्तमान में प्लेबैक के लिए लाइव रिकॉर्डिंग कर रहे हैं। कृपया वीडियो देखने और रेटिंग और फ़ीडबैक देने के लिए बाद में वापस देखें '
  },

  tabs: {
    audience: 'दर्शक',
    course: 'कोर्स ओवरव्यू',
    details: 'लाइव इवेंट का विवरण',
    description: 'विवरण',
    host: 'होस्ट',
    lesson: 'पाठ ओवरव्यू',
    lessons: 'पाठ ',
    overview: ' ओवरव्यू ',
    page: 'पेज बिल्डर',
    publish: 'प्रकाशित करें',
    settings: 'प्रकाशित करने हेतु सेटिंग',
    total_views: 'कुल व्यू',
    live_participates: 'लाइव प्रतिभागी',
    live_chats: 'लाइव चैट',
    live_quiz: 'लाइव पोल',
    trainer_rating: 'ट्रेनर रेटिंग',
    trainer_times: 'ट्रेनर टाइम',
    courses_quizzes: 'पाठ्यक्रम क्विज़',
    user_list: 'उपयोगकर्ता सूची',
    discussion: 'चर्चा',
    notes: 'मेरे नोट्स'
  },

  topics: {
    SALES_TRAINING: 'बिक्री प्रशिक्षण',
    NEGOTIATION_TRAINING: 'मोलभाव प्रशिक्षण',
    CROSS_CULTURAL_AWARENESS: 'क्रॉस-कल्चरल अवेयरनेस',
    NETWORKING_SKILLS: 'नेटवर्किंग कौशल',
    SOFTWARE_ARCHITECTURE: 'सॉफ्टवेयर आर्किटेक्चर',
    PROJECT_MANAGEMENT: 'परियोजना प्रबंधन',
    DIGITAL_TRANSFORMATION: 'डिजिटल परिवर्तन',
    IT_CONSULTING: 'आईटी परामर्श',
    MANAGEMENT_CONSULTING: 'प्रबंधन परामर्श',
    HR_CONSULTING: 'मानव संसाधन परामर्श',
    INTERNET_OF_THINGS: 'इंटरनेट ऑफ थिंग्स',
    CYBERSECURITY: 'साइबर सुरक्षा',
    PRIVACY_AND_GDRP: 'गोपनीयता और जीडीपीआर'
  },

  training: {
    title: 'प्रशिक्षण',
    title_assessment: ' मूल्यांकन',
    subtitle: 'पाठ्यक्रम और लाइव इवेंट',
    enrolled_title: 'एनरॉल किए गए पाठ्यक्रम और लाइव इवेंट',
    enrolled_subtitle: 'पाठ्यक्रम और लाइव इवेंट जिसे आपने एनरॉल किया है',
    enrolled_message:
      'आप वर्तमान में किसी भी पाठ्यक्रम और घटनाओं में एनरॉल नहीं हैं।',
    past_live_event_title: 'पिछले लाइव इवेंट',
    past_live_event_subTitle: 'लाइव इवेंट समाप्त',
    past_live_event: 'वर्तमान में कोई भी लाइव इवेंट नहीं हैं।',
    recomended_title: ' सुझाये पाठ्यक्रम और लाइव इवेंट',
    now_live_event_title: 'अभी लाइव',
    now_live_event_subTitle: 'वे कार्यक्रम जो अभी लाइव हैं या बहुत जल्द होंगे',
    now_live_event: 'वर्तमान में कोई लाइव इवेंट नहीं है।',
    webinar_event_title: 'वेबिनार चैनल',
    webinar_event_subTitle: 'वेबिनार समाप्त',
    webinar_event: 'वर्तमान में कोई वेबिनार नहीं हैं।',
    p2p_event_title: 'कोचिंग सत्र',
    p2p_event_subTitle: 'कोचिंग सत्र समाप्त ',
    p2p_event: 'वर्तमान में कोचिंग सत्र नहीं हैं।',

    now_live_assessment_title: 'अब लाइव',
    now_live_assessment_subTitle:
      'मूल्यांकन जो अभी लाइव चल रहे है या आगे होने वाले है',
    now_live_assessment_message: 'वर्तमान में कोई लाइव मूल्यांकन नहीं है।',

    upcoming_assessment_title: 'आगामी लाइव मूल्यांकन ',
    upcoming_assessment_subtitle: 'आगामी लाइव मूल्यांकन',
    upcoming_assessment_message:
      'वर्तमान में कोई आगामी लाइव मूल्यांकन नहीं है।',

    past_live_assessment_title: 'पिछला लाइव मूल्यांकन ',
    past_live_assessment_subTitle: 'लाइव मूल्यांकन समाप्त ',
    past_live_assessment_message: 'वर्तमान में कोई पिछले लाइव आकलन नहीं हैं।',
    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'हमने आपके <0><0/></0> आधार पर पाठ्यक्रमों और लाइव घटनाओं को क्यूरेट किया है ',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'खोज प्रशिक्षण',
    search_assessment: 'खोज आकलन',
    recomended_message: 'वर्तमान में कोई अनुशंसित पाठ्यक्रम और ईवेंट नहीं हैं।'
  },

  warnings: {
    delete: 'क्या आपको यकीन है?'
  },

  workshop: {
    title: 'माई वर्कशॉप',
    subtitle: 'एक पाठ्यक्रम बनाएं या अपनी खुद की एक लाइव घटना की मेजबानी करें',
    new_course: 'एक नया पाठ्यक्रम बनाएं',
    new_event: 'एक नया लाइव ईवेंट बनाएं',
    new_assessment: 'एक नया लाइव मूल्यांकन बनाएं',
    courses_title: 'निर्मित पाठ्यक्रम और लाइव इवेंट',
    courses_subtitle:
      'अपना बनाया गया पाठ्यक्रम संपादित और प्रकाशित करें और लाइव इवेंट की योजना बनाएं',
    tags_course: 'कोर्स',
    tags_live: 'लाइव इवेंट',
    tags_assessment: 'लाइव असेसमेंट'
  },

  help_center: {
    sidebar: {
      title: 'हम आपकी कैसे मदद कर सकते हैं?',
      back_to: 'डैशबोर्ड'
    },
    menu: {
      help_center: 'सहायता केंद्र',
      whats_new: 'नया क्या है',
      feedback: 'फ़ीडबैक',
      feedback_title: ' शेयरलूक को फ़ीडबैक भेजें',
      terms_and_conditions: 'नियम और शर्तें',
      privacy_policy: 'गोपनीयता नीति',
      contact_us: 'हमसे संपर्क करें'
    },
    get_started: {
      title: 'शेयर लुक से शुरू करें',
      description: {
        main: 'हमे लाइव वीडियो को आसान कोर्स बिल्डर में शामिल कर दिया है',
        tagline:
          'शेयरलूक के पेटेंट लाइव प्रसारण प्रणाली के साथ, आप इंगेजमेंट, स्वचालित रूप से सीखना और साथ ही अपने ज्ञान को दुसरो के साथ साझा कर सकते हैं।'
      }
    },
    whats_new: {
      title: 'शेयर लुक से शुरू करें',
      description: {
        main:
          'क्या आप जानते हैं कि स्टोरीटेलिंग स्टाइल सीखना कम समय में सम्भव और वो भी आपके बजट में ? बीएस आपको शेयरलुक कोर्स बिल्डर और संबंधित प्रतिभाओं को जोड़ना होगा । आप हमसे पूछ सकते हैं कैसे',
        tagline: ''
      }
    },
    create_workshop: ' एक कार्यशाला कैसे बनाये',
    create_course: 'कैसे एक पाठ्यक्रम कैसे बनाये',
    create_user: 'यूजर कैसे क्रिएट करे',
    create_group: 'ग्रुप कैसे बनाएं',
    create_webinar: 'वेबिनार कैसे बनाएं',
    create_live_event: 'लाइव इवेंट कैसे बनाएं',
    create_live_assessment: 'लाइव आकलन कैसे करे',
    create_live_on_mobile: 'मोबाइल पर लाइव बनाएं',
    personalize_profile: 'एक प्रोफ़ाइल को निजीकृत करें',
    manage_group: 'समूह प्रबंधित करें',
    report: 'रिपोर्ट',
    add_annotations: 'एनोटेशन / पॉपअप कैसे जोड़ें',
    add_audio: 'ऑडियो कैसे जोड़ें',
    add_header_and_footer: 'हैडर और फुटर जोड़ना',
    add_image: 'छवि कैसे जोड़ें',
    add_quiz_content: 'प्रश्नोत्तरी सामग्री कैसे जोड़ें',
    add_text_content: 'पाठ सामग्री कैसे जोड़ें',
    add_user: 'उपयोगकर्ता कैसे जोड़ें',
    add_video: 'वीडियो कैसे जोड़ें',
    clone_course: 'हाउ टू क्लोन कोर्स',
    find_live_broadcast: 'लाइव प्रसारण कैसे खोजें',
    contact_us: {
      title: 'हमसे संपर्क करें',
      subject_placeholder: 'एक विषय दर्ज करें *',
      content_placeholder: 'एक संदेश दर्ज करें *',
      subject_required: '* विषय आवश्यक है',
      content_required: '* संदेश आवश्यक है',
      submit: 'भेजें',
      cancel: 'रद्द करें',
      sent: 'भेजा गया'
    },
    feedback: {
      title: 'साझा करने के लिए प्रतिक्रिया भेजें',
      attach_title: 'एक फाइल संलग्न करें',
      choose: 'फ़ाइल चुनें',
      detail: 'फाइल को सपोर्ट टीम के साथ साझा किया जाएगा',
      content_placeholder: ' एक संदेश दर्ज करें*',
      content_required: '* संदेश आवश्यक है',
      submit: 'भेजें',
      cancel: 'रद्द करें',
      sent: 'भेजा गया'
    }
  },
  discussion: {
    join_discussion: 'चर्चा में शामिल हों'
  },
  notes: {
    title: 'मेरे नोट्स',
    add_note: 'नया नोट जोड़ें'
  }
}
